import React, { useState, useEffect, useRef, useMemo } from "react";
import axios from "axios";
import { BASE_URL, AUTH, AUTHH } from "../../config/axios";
import Dashboardnavbar from "../../layout/Dashboardnavbar";
import { useLocation } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { AddwithBlueCircle } from "../AllSvg";
import { v4 as uuidv4 } from "uuid";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import Select from "react-select";
import { calculateTotal, formatCurrencyIndian } from "../CustomFunctions";
import { SubmissionPayment } from "./PaymentModals";
import { RailwayPayment } from "./railways/RailwayPayment";
import { toast } from "react-toastify";
import { EOTTimeline } from "./Eottimeline";
import { EOTHistoryButton } from "./Eothistorymodal";
import { getPaymentSources } from "./paymentUtils";

const CHUNK_SIZE = 10 * 1024 * 1024; // 20MB

// AUTH() mai Content-Type: application/json hota hai, FormData ke liye wo hatana zaroori hai
// (browser/axios khud multipart boundary set karega)
const getMultipartConfig = () => {
  const cfg = AUTH() || {};
  const headers = { ...(cfg.headers || {}) };
  delete headers["Content-Type"];
  delete headers["content-type"];
  return { ...cfg, headers };
};

const sortByLetterDate = (list = [], order = "asc") => {
  const dir = order === "asc" ? 1 : -1;
  return [...(list || [])].sort((a, b) => {
    const da = a?.date ? new Date(a.date).getTime() : NaN;
    const db = b?.date ? new Date(b.date).getTime() : NaN;
    if (isNaN(da) && isNaN(db)) return 0;
    if (isNaN(da)) return 1;   // bina date wali row hamesha neeche
    if (isNaN(db)) return -1;
    return (da - db) * dir;    // same date par upload order barkarar rehta hai
  });
};
const getDocUrl = (doc) =>
  doc?.document_file || doc?.file_url || doc?.file || null;

const DocLinks = ({ documentData, inputId, inputtype }) => {
  if (inputtype === "normal") return "-";

  const docs = (documentData || []).filter((d) => d.input_id === inputId);
  if (!docs.length) return "-";

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
      {docs.map((doc, i) => {
        const url = getDocUrl(doc);
        const label = docs.length > 1 ? `View ${i + 1}` : "View";
        return url ? (
          <a key={doc.id || i} href={url} target="_blank" rel="noopener noreferrer" title={doc.name}>
            {label}
          </a>
        ) : (
          <span key={doc.id || i} style={{ color: "#999" }} title="File missing on server">
            {label} (no file)
          </span>
        );
      })}
    </div>
  );
};

// API 1 (chunk-upload) + API 2 (complete-upload)
export const uploadDocumentChunked = async (file, onProgress) => {
  const file_id = uuidv4();
  const total_chunks = Math.max(1, Math.ceil(file.size / CHUNK_SIZE));

  for (let i = 0; i < total_chunks; i++) {
    const chunk = file.slice(i * CHUNK_SIZE, (i + 1) * CHUNK_SIZE);

    const fd = new FormData();
    fd.append("file", chunk, file.name);
    fd.append("file_id", file_id);
    fd.append("chunk_index", i);
    fd.append("total_chunks", total_chunks);
    fd.append("original_filename", file.name);

    await axios.post(`${BASE_URL}/dpr/document/chunk-upload/`, fd, getMultipartConfig());
    onProgress?.(Math.round(((i + 1) / total_chunks) * 100));
  }

  const res = await axios.post(
    `${BASE_URL}/dpr/document/complete-upload/`,
    { file_id },
    AUTH(),
  );
  return { ...res.data, file_id }; // { file_name, file_path, file_url, file_id }
};

// API 3 (confirm-upload) - ab har file ke liye ek request (flat payload)
export const confirmUploads = async (project, files) => {
  for (const f of files) {
    await axios.post(
      `${BASE_URL}/dpr/document/confirm-upload/`,
      {
        file_id: f.file_id,
        name: f.document_name,
        input_id: f.input_id,
        project,
        section_id: f.section_id,
      },
      AUTH(),
    );
  }
};
const AddSubmission = ({ i, getProject, project, allData, id }) => {
  const [errors, setErrors] = useState({});
  const [show, setShow] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [formData, setFormData] = useState([
    {
      submissionName: "",
      status: "",
      submission_id: uuidv4(), // ✅ unique ID on initialization
      commentData: [],
      paymentData: {
        billingClaimedPercent: 0,
        billingReceivedPercent: 0,
        tdsPercent: 0,
        retentionPercent: 0,
        otherDeductionPercent: 0,
        remarks: "",
      },
      replyData: [],
      submissionData: [],
      cost: "",
      percentage: ``,
    },
  ]);

  const [formData2, setFormData2] = useState();

  // 🟢 Open modal and pre-fill with existing submission data (if present)
  const handleShow = () => {
    if (allData?.workstat && Array.isArray(allData.workstat)) {
      const target = allData.workstat.find((w) => w.id === id);

      if (target && target.submission_data?.length > 0) {
        // Pre-fill existing submission data
        setFormData(
          target.submission_data.map((item) => ({
            submissionName: item.submissionName || "",
            status: item.status || "",
            cost: item.cost || "",
            submission_id: item.submission_id || uuidv4(),
            commentData: item.commentData || [],
            replyData: item.replyData || [],
            submissionData: item.submissionData || [],
            paymentData: item.paymentData || {
              billingClaimedPercent: 0,
              billingReceivedPercent: 0,
              tdsPercent: 0,
              retentionPercent: 0,
              otherDeductionPercent: 0,
              remarks: "",
            },

            percentage: item.percentage || "",
          })),
        );
      } else {
        // No existing data → empty one input field
        setFormData([
          {
            submissionName: "",
            cost: "",
            status: "",
            submission_id: uuidv4(),
            commentData: [],
            replyData: [],
            submissionDataState: [],
            paymentData: {
              billingClaimedPercent: 0,
              billingReceivedPercent: 0,
              tdsPercent: 0,
              retentionPercent: 0,
              otherDeductionPercent: 0,
              remarks: "",
            },
            percentage: ``,
          },
        ]);
      }
    }
    setFormData2(allData);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setErrors({});
    setFormData([
      {
        submissionName: "",
        status: "",
        submission_id: uuidv4(), // ✅ reset with new ID
        commentData: [],
        replyData: [],
        paymentData: {
          billingClaimedPercent: 0,
          billingReceivedPercent: 0,
          tdsPercent: 0,
          retentionPercent: 0,
          otherDeductionPercent: 0,
          remarks: "",
        },
        cost: "",
        percentage: "",
        submissionDataState: [],
      },
    ]);
  };

  // 🟡 Handle input change inside a specific submission index
  const handleInputChange = (e, index) => {
    const { name, value } = e.target;

    const updated = [...formData];
    updated[index][name] = value;
    setFormData(updated);

    // Clear field error immediately
    setErrors((prev) => {
      const newErrors = { ...prev };

      if (value.trim()) {
        delete newErrors[`${name}_${index}`];
      }

      if (newErrors._global) {
        delete newErrors._global;
      }

      return newErrors;
    });
  };

  // 🟢 Add new submission field
  const handleAddSubmission = () => {
    setFormData((prev) => [
      ...prev,
      {
        submissionName: "",
        status: "",
        submission_id: uuidv4(), // ✅ each new one gets its own ID
        commentData: [],
        cost: "",
        replyData: [],
        paymentData: {
          billingClaimedPercent: 0,
          billingReceivedPercent: 0,
          tdsPercent: 0,
          retentionPercent: 0,
          otherDeductionPercent: 0,
          remarks: "",
        },
        percentage: "",
        submissionData: [],
      },
    ]);
  };

  // 🔴 Remove a submission section
  const handleRemoveSubmission = (index) => {
    setFormData((prev) => prev.filter((_, i) => i !== index));
  };

  // REPLACE the existing validateform in AddSubmission
  const validateform = () => {
    const newErrors = {};

    // Guard: prevent saving if every submission entry is completely empty
    const allBlank = formData.every(
      (item) => !item.submissionName?.trim() && !item.status
    );
    if (allBlank) {
      newErrors._global = "Please fill in at least one submission before saving.";
      setErrors(newErrors);
      return false;
    }

    formData.forEach((item, idx) => {
      if (!item.submissionName?.trim()) {
        newErrors[`submissionName_${idx}`] = "Submission name is required!";
      }
      if (!item.status) {
        newErrors[`status_${idx}`] = "Status is required!";
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // 🟢 Submit updated data
  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (!validateform()) return;
    if (submitting) return;
setSubmitting(true);

    const loadingToastId = toast.loading(
      "Updating submission... Please wait...",
    );

    try {
      const updatedData = { ...allData };

      if (updatedData?.workstat && Array.isArray(updatedData.workstat)) {
        const target = updatedData.workstat.find((w) => w.id === id);

        if (target) {
          target.submission_data = formData.map((item) => ({
            submissionName: item.submissionName || "",
            status: item.status || "pending",
            submission_id: item.submission_id || uuidv4(),
            commentData: item.commentData || [],
            replyData: item.replyData || [],
            cost: item.cost,
            paymentData: item.paymentData || {
              billingClaimedPercent: 0,
              billingReceivedPercent: 0,
              tdsPercent: 0,
              retentionPercent: 0,
              otherDeductionPercent: 0,
              remarks: "",
            },
            submissionData: item.submissionData || [],
          }));
        } else {
          console.warn(`Workstat detail not found for ID: ${id}`);
        }
      }

      const payload = {
        workstat: updatedData.workstat,
      };

      const res = await axios.put(
        `${BASE_URL}/dpr/project/${project}/`,
        payload,
        AUTH()
      );

      if (res.status === 200 || res.status === 201) {
        toast.success("Submission data updated successfully!");
        setShow(false);
        getProject();
      } else {
        toast.error("Update failed, please try again.");
      }
    } catch (err) {
      console.error("Error updating project:", err);
      toast.error("Something went wrong while updating submission");
    } finally {
  toast.dismiss(loadingToastId);
  setSubmitting(false);
}
  };

  useEffect(() => {
    if (!formData.length) return;

    if (formData.length > 1) {
      const percentage = 100 / formData.length;
      const cost = i.cost;
      const costForStage = Number(cost) * (Number(percentage) / 100);

      setFormData((prev) =>
        prev.map((item) => ({
          ...item,
          percentage: percentage,
          cost: costForStage,
        })),
      );
    } else {
      setFormData((prev) =>
        prev.map((item) => ({
          ...item,
          percentage: 100,
          cost: i.cost,
        })),
      );
    }
  }, [formData.length, i.cost, formData[0]?.status]);

  console.log(`formdataSubmission `, formData);
  console.log(`allData `, i);

  return (
    <>
      <button
        title="Add Data"
        onClick={handleShow}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "5px",
          padding: "5px 12px",
          borderRadius: "5px",
          border: "0.5px solid #2576bc",
          background: "#fff",
          color: "#2576bc",
          fontSize: "12px",
          fontWeight: 500,
          cursor: "pointer",
        }}
      >
        + Data
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="request-leave">
        <Modal.Header
          closeButton
          style={{
            padding: "14px 20px",
            borderBottom: "0.5px solid #e0e0e0",
            background: "#f5f7fa",
          }}
        >
          <Modal.Title
            style={{ fontSize: "14px", fontWeight: 600, color: "#1e293b" }}
          >
            Add / Edit Submission
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ padding: "16px 20px", overflowX: "hidden" }}>
          <form onSubmit={handleFormSubmit}>

            {formData.map((item, index) => (
              <div
                key={item.submission_id}
                style={{
                  border: "0.5px solid #e0e0e0",
                  borderRadius: "6px",
                  marginBottom: "12px",
                  background: "#fff",
                  overflow: "hidden",
                }}
              >
                {/* Header */}
                <div style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "10px 14px",
                  background: "#f5f7fa",
                  borderBottom: "0.5px solid #e0e0e0",
                }}>
                  <span style={{ fontSize: "13px", fontWeight: 600, color: "#1e293b" }}>
                    Submission {index + 1}
                  </span>
                  <button
                    type="button"
                    onClick={() => handleRemoveSubmission(index)}
                    style={{
                      fontSize: "11px",
                      fontWeight: 500,
                      color: "#dc2626",
                      background: "#fee2e2",
                      border: "none",
                      borderRadius: "4px",
                      padding: "3px 10px",
                      cursor: "pointer",
                    }}
                  >
                    Remove
                  </button>
                </div>

                {/* Body */}
                <div style={{ padding: "14px 16px" }}>

                  {/* Submission Name */}
                  <div style={{ marginBottom: "14px" }}>
                    <label
                      htmlFor={`submissionName_${index}`}
                      style={{ fontSize: "12px", fontWeight: 500, color: "#374151", display: "block", marginBottom: "6px" }}
                    >
                      Submission Name <span style={{ color: "#dc2626" }}>*</span>
                    </label>
                    <input
                      type="text"
                      id={`submissionName_${index}`}
                      name="submissionName"
                      placeholder="Enter Submission Name"
                      onChange={(e) => handleInputChange(e, index)}
                      value={item.submissionName}
                      style={{
                        width: "100%",
                        padding: "8px 5px",
                        border: errors[`submissionName_${index}`] ? "1px solid #dc2626" : "0.5px solid #e0e0e0",
                        borderRadius: "5px",
                        fontSize: "13px",
                        color: "#1e293b",
                        background: "#f9fafb",
                        outline: "none",
                        boxSizing: "border-box",
                      }}
                    />
                    {errors[`submissionName_${index}`] && (
                      <span
                        style={{
                          display: "block",
                          marginTop: "4px",
                          fontSize: "11px",
                          color: "#dc2626",
                        }}
                      >
                        {errors[`submissionName_${index}`]}
                      </span>
                    )}
                  </div>

                  {/* Status */}
                  <div>
                    <label
                      htmlFor={`status_${index}`}
                      style={{ fontSize: "12px", fontWeight: 500, color: "#374151", display: "block", marginBottom: "6px" }}
                    >
                      Status <span style={{ color: "#dc2626" }}>*</span>
                    </label>
                    <select
                      name="status"
                      value={item.status}
                      onChange={(e) => handleInputChange(e, index)}
                      style={{
                        width: "100%",
                        padding: "8px 5px",
                        border: "0.5px solid #e0e0e0",
                        borderRadius: "5px",
                        fontSize: "13px",
                        color: "#1e293b",
                        background: "#f9fafb",
                        outline: "none",
                        boxSizing: "border-box",
                        cursor: "pointer",
                      }}
                    >
                      <option value="">Select Type</option>
                      <option value="pending">Pending</option>
                      <option value="completed">Completed</option>
                    </select>
                    {errors[`status_${index}`] && (
                      <span
                        style={{
                          display: "block",
                          marginTop: "4px",
                          fontSize: "11px",
                          color: "#dc2626",
                        }}
                      >
                        {errors[`status_${index}`]}
                      </span>
                    )}
                  </div>

                </div>
              </div>
            ))}

            {/* Add Submission */}
            <div style={{ textAlign: "center", marginBottom: "16px" }}>
              <button
                type="button"
                onClick={handleAddSubmission}
                style={{
                  padding: "6px 16px",
                  borderRadius: "5px",
                  border: "0.5px solid #2576bc",
                  background: "#fff",
                  color: "#2576bc",
                  fontSize: "12px",
                  fontWeight: 500,
                  cursor: "pointer",
                }}
              >
                + Add Submission
              </button>
            </div>

            {/* Global validation error */}
            {errors._global && (
              <div style={{
                padding: "10px 14px",
                marginBottom: "12px",
                background: "#fee2e2",
                border: "0.5px solid #dc2626",
                borderRadius: "5px",
                fontSize: "12px",
                color: "#dc2626",
                fontWeight: 500,
              }}>
                {errors._global}
              </div>
            )}

            {/* Footer */}
            <div style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
              paddingTop: "12px",
              borderTop: "0.5px solid #e0e0e0",
            }}>
              <button
                type="button"
                onClick={handleClose}
                style={{
                  padding: "7px 18px",
                  borderRadius: "5px",
                  border: "0.5px solid #e0e0e0",
                  background: "#fff",
                  color: "#64748b",
                  fontSize: "12px",
                  fontWeight: 500,
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>
              <button
                type="submit"
  disabled={submitting}
                style={{
                  padding: "7px 18px",
                  borderRadius: "5px",
                  border: "none",
                  background: "#2576bc",
                  color: "#fff",
                  fontSize: "12px",
                  fontWeight: 500,
                  cursor: "pointer",
               opacity: submitting ? 0.6 : 1, cursor: submitting ? "not-allowed" : "pointer" }}
>
  {submitting ? "Saving..." : "Update"}
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

const AddsubmissionData = ({
  i,
  documentData,
  getProject,
  project,
  allData,
  id,
  submission_id,
  submissionItem,
  getDocuments,
}) => {
  const [errors, setErrors] = useState({});
  const [show, setShow] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const fileInputRefs = useRef([]);

  const [formData, setFormData] = useState([
    {
      submissionName: "",
      status: "",
      submission_id: "",
      commentData: [],
      replyData: [],
      submissionDataState: [],
      paymentData: {
        billingClaimedPercent: 0,
        billingReceivedPercent: 0,
        tdsPercent: 0,
        retentionPercent: 0,
        otherDeductionPercent: 0,
        remarks: "",
      },
    },
  ]);
  const [formData2, setFormData2] = useState();
  const [idData, setIdData] = useState({});
  const loaDate = allData?.project_details_data?.loa_date || "";

  const [documentFormData, setDocumentFormData] = useState([
    {
      input_id: "null",
      document_file: null,
      name: null,
      project: "null",
    },
  ]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDocumentFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    setDocumentFormData((prev) => ({
      ...prev,
      document_file: e.target.files[0],
    }));
  };

  // 🟢 Open modal & prefill data
  const handleShow = () => {
    if (allData?.workstat && Array.isArray(allData.workstat)) {
      // 1️⃣ Find the current workstage by matching workstat id
      const targetWorkstage = allData?.workstat.find((w) => w.id === id);

      if (submissionItem && submissionItem?.length > 0) {
        const filteredSubmission = (submissionItem || []).filter((item) => {
          return (
            String(item.submission_id).trim() ===
              String(submission_id).trim() ||
            String(item.id).trim() === String(submission_id).trim()
          );
        });

        if (filteredSubmission.length > 0) {
          setIdData(filteredSubmission[0]);

          setFormData(
            filteredSubmission.map((item) => ({
              submissionName: item.submissionName || "",
              status: item.status || "",
              commentData: item.commentData || [],
              replyData: item.replyData || [],
              submissionDataState: item.submissionData || [],
              paymentData: item.paymentData || {
                billingClaimedPercent: 0,
                billingReceivedPercent: 0,
                tdsPercent: 0,
                retentionPercent: 0,
                otherDeductionPercent: 0,
                remarks: "",
              },
              submission_id: item.submission_id || "",
            })),
          );
        } else {
          // no match — reset to blank form
          setFormData([
            {
              submissionName: "",
              status: "",
              submission_id: "",
              commentData: [],
              replyData: [],
              submissionDataState: [],
            },
          ]);
        }
      }
    }

    setFormData2(allData);
    setShow(true);
  };

  const [iddData, setIddData] = useState([]);
  useEffect(() => {
    if (Array.isArray(idData.replyData) && idData.replyData.length > 0) {
      setIddData(idData.replyData);
    }
  }, [idData]);
  const handleClose = () => {
    setShow(false);
    setErrors({});
  };

  // 🟡 handle submission name input
  const handleInputChange = (e, index) => {
    const { name, value } = e.target;

    const updated = [...formData];
    updated[index][name] = value;
    setFormData(updated);

    // Clear field error immediately
    setErrors((prev) => {
      const newErrors = { ...prev };

      if (value.trim()) {
        delete newErrors[`${name}_${index}`];
      }

      if (newErrors._global) {
        delete newErrors._global;
      }

      return newErrors;
    });
  };

  // ➕ Add new submission section
  const handleAddSubmission = () => {
    setFormData((prev) => [
      ...prev,
      {
        submissionName: "",
        status: "",
        commentData: [],
        replyData: [],
        submissionData: [],
      },
    ]);
  };

  // ❌ Remove a submission section
  const handleRemoveSubmission = (index) => {
    setFormData((prev) => prev.filter((_, i) => i !== index));
  };

  // 🟢 Add new submissionDataState field (normal/document)
  const handleAddsubmissionDataState = (index) => {
    const updated = [...formData];

    const currentInputType = updated[index]?.inputtype;

    const newEntry = {
      id: uuidv4(),
      replyId: "",
      rev_no: "",
      date: "",
      Letter_num: currentInputType === "normal" ? "NA" : "",
      submitted_to: "",
      replyLetter_num: "",
      inputtype: currentInputType || "",
      description: "",
      document_file: "",
      document_name: currentInputType === "normal" ? "NA" : "",
      SubmissionInput: "",
      reply_value: "",
    };

    if (!updated[index]) return;

    if (!Array.isArray(updated[index].submissionDataState)) {
      updated[index].submissionDataState = [];
    }

    updated[index].submissionDataState = [
      ...updated[index].submissionDataState,
      newEntry,
    ];

    setFormData(updated); // ✅ VERY IMPORTANT
  };

  const handlesubmissionDataStateChange = (e, parentIndex, childIndex) => {
    const { name, value, files } = e.target;

    setFormData((prev) =>
      prev.map((parent, pIndex) => {
        if (pIndex !== parentIndex) return parent;

        return {
          ...parent,
          submissionDataState: parent.submissionDataState.map(
            (child, cIndex) => {
              if (cIndex !== childIndex) return child;

              let updatedChild = { ...child };

              // ✅ Update changed field first
              if (name === "document_file") {
                if (files?.length > 0) {
                  const file = files[0];
                  updatedChild.document_file = file;
                  updatedChild.document_name = file.name;
                } else {
                  updatedChild.document_file = null;
                  updatedChild.document_name = "";
                }
              } else {
                updatedChild[name] = value;
              }

              // ✅ Only run when replyId changes
              if (name === "replyId") {
                if (value && value !== "null") {
                  const replyData = iddData.find(
                    (item) => String(item.id) === String(value),
                  );

                  if (replyData) {
                    updatedChild.replyLetter_num = replyData.Letter_num || "";
                  } else {
                    updatedChild.replyLetter_num = "";
                  }
                } else {
                  // If replyId is null or empty
                  updatedChild.replyLetter_num = "";
                }
              }

              // ✅ Reset for normal type
              if (updatedChild.inputtype === "normal") {
                updatedChild.Letter_num = "NA";
                updatedChild.document_name = "NA";
                updatedChild.document_file = null;
              }

              return updatedChild;
            },
          ),
        };
      }),
    );
  };

  const handleRemovesubmissionDataState = async (parentIndex, childIndex) => {
    const updated = [...formData];
    const removedItem = updated[parentIndex].submissionDataState[childIndex];

    // 🧠 Check if it's a document
    if (removedItem.inputtype === "document" && removedItem.id) {
      const existingDoc = (documentData || []).find(
        (doc) => doc.input_id === removedItem.id,
      );

      // ⚠️ Show confirmation before deleting
      const confirmDelete = window.confirm(
        `Are you sure you want to delete this document: "${removedItem.document_name || existingDoc?.name || "Unnamed Document"}"?`,
      );

      if (!confirmDelete) {
        toast.info("Deletion cancelled.");
        return;
      }

      if (existingDoc) {
        try {
          // 🔥 Delete document from backend
          await axios.delete(`${BASE_URL}/dpr/document/${existingDoc.id}/`, AUTH());
          toast.success(`Document "${existingDoc.name}" deleted successfully.`);
        } catch (err) {
          console.error("❌ Error deleting document:", err);
          toast.error(`Failed to delete document: ${existingDoc.name}`);
        }
      }
    }

    // 🧹 Remove from local state
    updated[parentIndex].submissionDataState.splice(childIndex, 1);
    setFormData(updated);
  };

  // ✅ Validate
  const validateform = () => {
    const newErrors = {};
    formData.forEach((item, idx) => {
      if (!item.submissionName?.trim()) {
        newErrors[`submissionName_${idx}`] = "Submission name is required!";
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setSubmitting(true);
    const loadingToastId = toast.loading("Updating submission... Please wait...");

    try {
      const updatedData = { ...allData };

      if (updatedData?.workstat && Array.isArray(updatedData.workstat)) {
        const targetWorkstat = updatedData.workstat.find((w) => w.id === id);

        if (submissionItem && submissionItem?.length > 0) {
          const targetSubmission = submissionItem?.find(
            (sub) =>
              String(sub.submission_id).trim() === String(submission_id).trim() ||
              String(sub.id).trim() === String(submission_id).trim(),
          );
          if (targetSubmission) {
            const updatedsubmissionDataState =
              formData[0].submissionDataState.map((item) =>
                item.id ? item : { ...item, id: uuidv4() },
              );
            targetSubmission.submissionData = updatedsubmissionDataState;
            targetSubmission.paymentData =
              formData[0].paymentData || targetSubmission.paymentData || {};
          } else {
            // Add new submission entry
            targetWorkstat.submission_data.push({
              submission_id,
              submissionName: formData[0].submissionName || "",
              commentData: [],
              replyData: [],
              submissionData: formData[0].submissionDataState.map((d) => ({
                ...d,
                id: d.id || uuidv4(),
              })),
            });
          }
        }
      }

      const payload = { workstat: updatedData.workstat };

      const res = await axios.put(
        `${BASE_URL}/dpr/project/${project}/`,
        payload,
        AUTH(),
      );

      if (res.status === 200 || res.status === 201) {
        toast.success("Submission data updated successfully!");

        // sirf wahi docs jinki nayi File select hui hai
        const documentEntries = formData
          .flatMap((sub) =>
            sub.submissionDataState.filter((d) => d.inputtype === "document"),
          )
          .filter((d) => d.document_file instanceof File);

        if (!documentEntries.length) {
          toast.dismiss(loadingToastId);
          setShow(false);
          getProject();
          return;
        }

        const filesToConfirm = [];

        for (const doc of documentEntries) {
          try {
            // API 1 (chunks) + API 2 (complete)
            const uploaded = await uploadDocumentChunked(doc.document_file, (pct) =>
              toast.update(loadingToastId, {
                render: `Uploading ${doc.document_name || doc.document_file.name}… ${pct}%`,
              }),
            );

            filesToConfirm.push({
              file_id: uploaded.file_id,
              section_id: id, // workstat/section id, agar alag ho to yahan badlo
              file_path: uploaded.file_path,
              document_name: doc.document_name || doc.document_file.name,
              original_filename: doc.document_file.name,
              input_id: doc.id, // backend se confirm karo ki ye accept hota hai
            });
          } catch (err) {
            console.error("❌ Document upload failed:", err);
            toast.error(`Failed for document: ${doc.document_name}`);
          }
        }

        // API 3 — ek hi baar mai bulk confirm
        if (filesToConfirm.length > 0) {
          try {
            await confirmUploads(project, filesToConfirm);
          } catch (err) {
            console.error("❌ Confirm upload failed:", err);
            toast.error("Documents confirm nahi ho paye, please retry.");
          }
        }

        getProject();
        getDocuments();
        setShow(false);
      } else {
        toast.error("Update failed, please try again.");
      }
    } catch (err) {
      console.error("Error updating project:", err);
      toast.error("Something went wrong while updating submission");
    } finally {
      toast.dismiss(loadingToastId);
      setSubmitting(false);
    }
  };

  return (
    <>
      <button onClick={handleShow}>
        <AddwithBlueCircle />
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave"
        size="lg"
      >
        <Modal.Header closeButton className="justify-center">
          <Modal.Title className="font-weight600 font-size-heading text-center w-100">
            Add / Edit Submission Details
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ padding: "16px 20px", overflowX: "hidden" }}>
          <form onSubmit={handleFormSubmit}>
            {formData.map((item, index) => (
              <div
                key={index}
                style={{
                  border: "0.5px solid #e0e0e0",
                  borderRadius: "6px",
                  marginBottom: "12px",
                  background: "#fff",
                  overflow: "hidden",
                }}
              >
                {/* Header */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "10px 14px",
                    background: "#f5f7fa",
                    borderBottom: "0.5px solid #e0e0e0",
                  }}
                >
                  <span style={{ fontSize: "13px", fontWeight: 600, color: "#1e293b" }}>
                    Submission {index + 1}
                  </span>
                </div>

                {/* Body */}
                <div style={{ padding: "14px 16px" }}>
                  {/* Submission Name */}
                  <div style={{ marginBottom: "14px" }}>
                    <label
                      style={{
                        fontSize: "12px",
                        fontWeight: 500,
                        color: "#374151",
                        display: "block",
                        marginBottom: "6px",
                      }}
                    >
                      Submission Name{" "}
                      <span style={{ color: "#dc2626" }}>(Read-Only)</span>
                    </label>
                    <textarea
                      name="submissionName"
                      placeholder="Enter Submission Name"
                      onChange={(e) => handleInputChange(e, index)}
                      value={item.submissionName}
                      readOnly
                      style={{
                        width: "100%",
                        padding: "8px 5px",
                        border: errors[`submissionName_${index}`]
                          ? "1px solid #dc2626"
                          : "0.5px solid #e0e0e0",
                        borderRadius: "5px",
                        fontSize: "13px",
                        color: "#1e293b",
                        background: "#f9fafb",
                        outline: "none",
                        boxSizing: "border-box",
                        resize: "vertical",
                        minHeight: "72px",
                      }}
                    />
                    {errors[`submissionName_${index}`] && (
                      <span
                        style={{
                          display: "block",
                          marginTop: "4px",
                          fontSize: "11px",
                          color: "#dc2626",
                        }}
                      >
                        {errors[`submissionName_${index}`]}
                      </span>
                    )}
                  </div>

                  {/* Submission Data Section */}
                  <div>
                    <h6
                      style={{
                        fontSize: "13px",
                        fontWeight: 600,
                        color: "#1e293b",
                        marginBottom: "10px",
                      }}
                    >
                      Submission Data
                    </h6>

                    {(item.submissionDataState || []).map((sub, subIndex) => (
                      <div
                        key={sub.id}
                        style={{
                          border: "0.5px solid #e0e0e0",
                          borderRadius: "6px",
                          marginBottom: "10px",
                          background: "#fff",
                          overflow: "hidden",
                        }}
                      >
                        {/* Sub-item Header */}
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "8px 12px",
                            background: "#f5f7fa",
                            borderBottom: "0.5px solid #e0e0e0",
                          }}
                        >
                          <span style={{ fontSize: "12px", fontWeight: 600, color: "#1e293b" }}>
                            Submission Data {subIndex + 1}
                          </span>
                          <button
                            type="button"
                            onClick={() => handleRemovesubmissionDataState(index, subIndex)}
                            style={{
                              fontSize: "11px",
                              fontWeight: 500,
                              color: "#dc2626",
                              background: "#fee2e2",
                              border: "none",
                              borderRadius: "4px",
                              padding: "3px 10px",
                              cursor: "pointer",
                            }}
                          >
                            Remove
                          </button>
                        </div>

                        {/* Sub-item Body */}
                        <div style={{ padding: "12px 14px" }}>
                          {/* Revision Number */}
                          <div style={{ marginBottom: "12px" }}>
                            <label
                              style={{
                                fontSize: "12px",
                                fontWeight: 500,
                                color: "#374151",
                                display: "block",
                                marginBottom: "6px",
                              }}
                            >
                              Revision Number
                            </label>
                            <input
                              name="rev_no"
                              placeholder="Enter Value"
                              value={sub.rev_no}
                              onChange={(e) => handlesubmissionDataStateChange(e, index, subIndex)}
                              style={{
                                width: "100%",
                                padding: "8px 5px",
                                border: errors[`rev_no_${index}_${subIndex}`]
                                  ? "1px solid #dc2626"
                                  : "0.5px solid #e0e0e0",
                                borderRadius: "5px",
                                fontSize: "13px",
                                color: "#1e293b",
                                background: "#f9fafb",
                                outline: "none",
                                boxSizing: "border-box",
                              }}
                            />
                          </div>

                          {/* In Reply To */}
                          <div style={{ marginBottom: "12px" }}>
                            <label
                              style={{
                                fontSize: "12px",
                                fontWeight: 500,
                                color: "#374151",
                                display: "block",
                                marginBottom: "6px",
                              }}
                            >
                              In Reply To
                            </label>
                            <select
                              name="replyId"
                              value={sub.replyId}
                              onChange={(e) => handlesubmissionDataStateChange(e, index, subIndex)}
                              style={{
                                width: "100%",
                                padding: "8px 5px",
                                border: "0.5px solid #e0e0e0",
                                borderRadius: "5px",
                                fontSize: "13px",
                                color: "#1e293b",
                                background: "#f9fafb",
                                outline: "none",
                                boxSizing: "border-box",
                                cursor: "pointer",
                              }}
                            >
                              <option value="null">Select Reply</option>
                              {iddData.map((i) => (
                                <option key={i.id} value={i.id}>
                                  {i.Letter_num}
                                </option>
                              ))}
                            </select>
                          </div>

                          {/* Date */}
                          <div style={{ marginBottom: "12px" }}>
                            <label
                              style={{
                                fontSize: "12px",
                                fontWeight: 500,
                                color: "#374151",
                                display: "block",
                                marginBottom: "6px",
                              }}
                            >
                              Date
                            </label>
                            <input
                              type="date"
                              name="date"
                              placeholder="Enter Value"
                              value={sub.date}
                              min={loaDate}
                              onChange={(e) => handlesubmissionDataStateChange(e, index, subIndex)}
                              style={{
                                width: "100%",
                                padding: "8px 5px",
                                border: errors[`date_${index}_${subIndex}`]
                                  ? "1px solid #dc2626"
                                  : "0.5px solid #e0e0e0",
                                borderRadius: "5px",
                                fontSize: "13px",
                                color: "#1e293b",
                                background: "#f9fafb",
                                outline: "none",
                                boxSizing: "border-box",
                              }}
                            />
                          </div>

                          {/* Input Type */}
                          <div style={{ marginBottom: "12px" }}>
                            <label
                              style={{
                                fontSize: "12px",
                                fontWeight: 500,
                                color: "#374151",
                                display: "block",
                                marginBottom: "6px",
                              }}
                            >
                              Input Type
                            </label>
                            <select
                              name="inputtype"
                              value={sub.inputtype}
                              onChange={(e) => handlesubmissionDataStateChange(e, index, subIndex)}
                              style={{
                                width: "100%",
                                padding: "8px 5px",
                                border: "0.5px solid #e0e0e0",
                                borderRadius: "5px",
                                fontSize: "13px",
                                color: "#1e293b",
                                background: "#f9fafb",
                                outline: "none",
                                boxSizing: "border-box",
                                cursor: "pointer",
                              }}
                            >
                              <option value="">Select Type</option>
                              <option value="normal">Normal Input</option>
                              <option value="document">Document</option>
                            </select>
                          </div>

                          {/* Letter Number */}
                          <div style={{ marginBottom: "12px" }}>
                            <label
                              style={{
                                fontSize: "12px",
                                fontWeight: 500,
                                color: "#374151",
                                display: "block",
                                marginBottom: "6px",
                              }}
                            >
                              Letter Number{" "}
                              {sub.inputtype === "normal" && (
                                <span style={{ color: "#dc2626" }}>(Read-Only)</span>
                              )}
                            </label>
                            <input
                              type="text"
                              name="Letter_num"
                              disabled={sub.inputtype === "normal"}
                              placeholder="Enter Value"
                              value={sub.inputtype === "document" ? sub.Letter_num : "NA"}
                              onChange={(e) => handlesubmissionDataStateChange(e, index, subIndex)}
                              style={{
                                width: "100%",
                                padding: "8px 5px",
                                border: errors[`Letter_num_${index}_${subIndex}`]
                                  ? "1px solid #dc2626"
                                  : "0.5px solid #e0e0e0",
                                borderRadius: "5px",
                                fontSize: "13px",
                                color: "#1e293b",
                                background: sub.inputtype === "normal" ? "#f1f5f9" : "#f9fafb",
                                outline: "none",
                                boxSizing: "border-box",
                              }}
                            />
                          </div>

                          {/* Submitted To */}
                          <div style={{ marginBottom: "12px" }}>
                            <label
                              style={{
                                fontSize: "12px",
                                fontWeight: 500,
                                color: "#374151",
                                display: "block",
                                marginBottom: "6px",
                              }}
                            >
                              Submitted To
                            </label>
                            <input
                              type="text"
                              name="submitted_to"
                              placeholder="Enter Client Email id"
                              value={sub.submitted_to}
                              onChange={(e) => handlesubmissionDataStateChange(e, index, subIndex)}
                              style={{
                                width: "100%",
                                padding: "8px 5px",
                                border: errors[`submitted_to_${index}_${subIndex}`]
                                  ? "1px solid #dc2626"
                                  : "0.5px solid #e0e0e0",
                                borderRadius: "5px",
                                fontSize: "13px",
                                color: "#1e293b",
                                background: "#f9fafb",
                                outline: "none",
                                boxSizing: "border-box",
                              }}
                            />
                          </div>

                          {/* Description */}
                          <div style={{ marginBottom: "12px" }}>
                            <label
                              style={{
                                fontSize: "12px",
                                fontWeight: 500,
                                color: "#374151",
                                display: "block",
                                marginBottom: "6px",
                              }}
                            >
                              Description
                            </label>
                            <input
                              type="text"
                              name="description"
                              placeholder="Enter Description"
                              value={sub.description}
                              onChange={(e) => handlesubmissionDataStateChange(e, index, subIndex)}
                              style={{
                                width: "100%",
                                padding: "8px 5px",
                                border: errors[`description_${index}_${subIndex}`]
                                  ? "1px solid #dc2626"
                                  : "0.5px solid #e0e0e0",
                                borderRadius: "5px",
                                fontSize: "13px",
                                color: "#1e293b",
                                background: "#f9fafb",
                                outline: "none",
                                boxSizing: "border-box",
                              }}
                            />
                          </div>

                          {/* Document Fields */}
                          {sub.inputtype === "document" && (
                            <>
                              <div style={{ marginBottom: "12px" }}>
                                <label
                                  style={{
                                    fontSize: "12px",
                                    fontWeight: 500,
                                    color: "#374151",
                                    display: "block",
                                    marginBottom: "6px",
                                  }}
                                >
                                  Document Name
                                </label>
                                <input
                                  name="document_name"
                                  placeholder="Document Name"
                                  value={sub.document_name}
                                  onChange={(e) => handlesubmissionDataStateChange(e, index, subIndex)}
                                  style={{
                                    width: "100%",
                                    padding: "8px 5px",
                                    border: "0.5px solid #e0e0e0",
                                    borderRadius: "5px",
                                    fontSize: "13px",
                                    color: "#1e293b",
                                    background: "#f9fafb",
                                    outline: "none",
                                    boxSizing: "border-box",
                                  }}
                                />
                              </div>
                              <div style={{ marginBottom: "12px" }}>
                                <label
                                  style={{
                                    fontSize: "12px",
                                    fontWeight: 500,
                                    color: "#374151",
                                    display: "block",
                                    marginBottom: "6px",
                                  }}
                                >
                                  Upload File
                                </label>
                                <input
                                  type="file"
                                  name="document_file"
                                  onChange={(e) => handlesubmissionDataStateChange(e, index, subIndex)}
                                  style={{
                                    width: "100%",
                                    padding: "8px 5px",
                                    border: "0.5px solid #e0e0e0",
                                    borderRadius: "5px",
                                    fontSize: "13px",
                                    color: "#1e293b",
                                    background: "#f9fafb",
                                    outline: "none",
                                    boxSizing: "border-box",
                                  }}
                                />
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    ))}

                    {/* Add Submission Data */}
                    <div style={{ textAlign: "center", marginBottom: "8px" }}>
                      <button
                        type="button"
                        onClick={() => handleAddsubmissionDataState(index)}
                        style={{
                          padding: "6px 16px",
                          borderRadius: "5px",
                          border: "0.5px solid #2576bc",
                          background: "#fff",
                          color: "#2576bc",
                          fontSize: "12px",
                          fontWeight: 500,
                          cursor: "pointer",
                        }}
                      >
                        + Add Submission Data
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}

            {/* Footer */}
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
                paddingTop: "12px",
                borderTop: "0.5px solid #e0e0e0",
              }}
            >
              <button
                type="submit"
                disabled={submitting}
                style={{
                  padding: "7px 18px",
                  borderRadius: "5px",
                  border: "none",
                  background: "#2576bc",
                  color: "#fff",
                  fontSize: "12px",
                  fontWeight: 500,
                  opacity: submitting ? 0.6 : 1,
                  cursor: submitting ? "not-allowed" : "pointer",
                }}
              >
                {submitting ? "Saving..." : "Update"}
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

const AddCommentData = ({
  i,
  documentData,
  getProject,
  project,
  allData,
  id,
  submission_id,
  submissionItem,
  getDocuments,
}) => {
  const [errors, setErrors] = useState({});
  const [show, setShow] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [formData, setFormData] = useState([
    {
      submissionName: "",
      submission_id: "",
      commentData: [],
      replyData: [],
      submissionData: [],
    },
  ]);
  const [formData2, setFormData2] = useState();

  const [documentFormData, setDocumentFormData] = useState([
    {
      input_id: "null",
      document_file: null,
      name: null,
      project: "null",
    },
  ]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDocumentFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    setDocumentFormData((prev) => ({
      ...prev,
      document_file: e.target.files[0],
    }));
  };

  const [idData, setIdData] = useState({});
  const loaDate = allData?.project_details_data?.loa_date || "";

  // 🟢 Open modal & prefill data
  const handleShow = () => {
    if (allData?.workstat && Array.isArray(allData.workstat)) {
      // 1️⃣ Find the current workstage by matching workstat id
      const targetWorkstage = allData?.workstat.find(
        (w) => w.id === submissionItem.id,
      );

      if (submissionItem && submissionItem?.length > 0) {
        const filteredSubmission = submissionItem.filter(
          (item) => item.submission_id === submission_id,
        );

        if (filteredSubmission.length > 0) {
          setIdData(filteredSubmission[0]);
          setFormData(
            filteredSubmission.map((item) => ({
              submissionName: item.submissionName || "",
              commentData: item.commentData || [],
              replyData: item.replyData || [],
              submissionData: item.submissionData || [],
              submission_id: item.submission_id || "",
            })),
          );
        } else {
          // no match — reset to blank form
          setFormData([
            {
              submissionName: "",
              submission_id: "",
              commentData: [],
              replyData: [],
              submissionData: [],
            },
          ]);
        }
      }
    }

    setFormData2(allData);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setErrors({});
  };

  const [iddData, setIddData] = useState([]);
  useEffect(() => {
    if (
      Array.isArray(idData.submissionData) &&
      idData.submissionData.length > 0
    ) {
      setIddData(idData.submissionData);
    }
  }, [idData]);

  // 🟡 handle submission name input
  const handleInputChange = (e, index) => {
    const { name, value } = e.target;

    const updated = [...formData];
    updated[index][name] = value;
    setFormData(updated);

    // Clear field error immediately
    setErrors((prev) => {
      const newErrors = { ...prev };

      if (value.trim()) {
        delete newErrors[`${name}_${index}`];
      }

      if (newErrors._global) {
        delete newErrors._global;
      }

      return newErrors;
    });
  };

  // ➕ Add new submission section
  const handleAddSubmission = () => {
    setFormData((prev) => [
      ...prev,
      {
        submissionName: "",
        commentData: [],
        replyData: [],
        submissionData: [],
      },
    ]);
  };

  // ❌ Remove a submission section
  const handleRemoveSubmission = (index) => {
    setFormData((prev) => prev.filter((_, i) => i !== index));
  };

  // 🟢 Add new submissionData field (normal/document)
  const handleAddSubmissionData = (index) => {
    const updated = [...formData];
    const currentInputType = updated[index]?.inputtype;

    const newEntry = {
      id: uuidv4(),
      submissionId: "",
      inputtype: currentInputType || "",
      date: "",
      Letter_num: currentInputType === "normal" ? "NA" : "",
      from: "",
      description: "",
      rev_number: ``,
      document_file: "",
      document_name: currentInputType === "normal" ? "NA" : "",
      CommentInput: "",
      submission_value: "",
    };
    updated[index].commentData.push(newEntry);
    setFormData(updated);
  };

  // 🟠 Handle changes inside submissionData array
  const handleSubmissionDataChange = (e, parentIndex, childIndex) => {
    const { name, value, files } = e.target;

    setFormData((prev) =>
      prev.map((parent, pIndex) => {
        if (pIndex !== parentIndex) return parent;

        return {
          ...parent,
          commentData: parent.commentData.map((child, cIndex) => {
            if (cIndex !== childIndex) return child;

            let updatedChild = { ...child };

            // ✅ FIRST update the changed field
            if (name === "document_file") {
              if (files?.length > 0) {
                const file = files[0];
                updatedChild.document_file = file;
                updatedChild.document_name = file.name;
              } else {
                updatedChild.document_file = null;
                updatedChild.document_name = "";
              }
            } else {
              updatedChild[name] = value;
            }

            // ✅ THEN find submission (after submissionId updated)
            if (name === "submissionId") {
              const submissionData = iddData.find(
                (item) => String(item.id) === String(value),
              );

              if (submissionData) {
                updatedChild.from = submissionData.submitted_to;
                updatedChild.rev_number = submissionData.rev_no;
              }
            }

            // ✅ Normal type reset
            if (updatedChild.inputtype === "normal") {
              updatedChild.Letter_num = "NA";
              updatedChild.document_name = "NA";
              updatedChild.document_file = null;
            }

            return updatedChild;
          }),
        };
      }),
    );
  };

  const handleRemoveSubmissionData = async (parentIndex, childIndex) => {
    const updated = [...formData];
    const removedItem = updated[parentIndex].commentData[childIndex];

    // 🧠 Check if it's a document
    if (removedItem.inputtype === "document" && removedItem.id) {
      const existingDoc = (documentData || []).find(
        (doc) => doc.input_id === removedItem.id,
      );

      // ⚠️ Show confirmation before deleting
      const confirmDelete = window.confirm(
        `Are you sure you want to delete this document: "${removedItem.document_name || existingDoc?.name || "Unnamed Document"}"?`,
      );

      if (!confirmDelete) {
        toast.info("Deletion cancelled.");
        return;
      }

      if (existingDoc) {
        try {
          // 🔥 Delete document from backend
          await axios.delete(`${BASE_URL}/dpr/document/${existingDoc.id}/`, AUTH());
          toast.success(`Document "${existingDoc.name}" deleted successfully.`);
        } catch (err) {
          console.error("❌ Error deleting document:", err);
          toast.error(`Failed to delete document: ${existingDoc.name}`);
        }
      }
    }

    // 🧹 Remove from local state
    updated[parentIndex].commentData.splice(childIndex, 1);
    setFormData(updated);
  };

  // ✅ Validate
  const validateform = () => {
    const newErrors = {};
    formData.forEach((item, idx) => {
      if (!item.submissionName?.trim()) {
        newErrors[`submissionName_${idx}`] = "Submission name is required!";
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setSubmitting(true);
    const loadingToastId = toast.loading("Updating ... Please wait...");

    try {
      const updatedData = { ...allData };

      // 🟢 1️⃣ Update submission data inside project
      if (updatedData?.workstat && Array.isArray(updatedData.workstat)) {
        const targetWorkstat = updatedData.workstat.find((w) => w.id === i.id);

        if (submissionItem && submissionItem?.length > 0) {
          const targetSubmission = submissionItem.find(
            (sub) => sub.submission_id === submission_id,
          );

          if (targetSubmission) {
            // Update existing submissionData
            const updatedSubmissionData = formData[0].commentData.map((item) =>
              item.id ? item : { ...item, id: uuidv4() },
            );
            targetSubmission.commentData = updatedSubmissionData;
          } else {
            // Add new submission entry
            targetWorkstat.submission_data.push({
              submission_id,
              submissionName: formData[0].submissionName || "",
              submissionData: [],
              replyData: [],
              commentData: formData[0].commentData.map((d) => ({
                ...d,
                id: d.id || uuidv4(),
              })),
            });
          }
        }
      }

      const payload = {
        workstat: updatedData.workstat,
      };

      // 🟢 2️⃣ Update project
      const res = await axios.put(
        `${BASE_URL}/dpr/project/${project}/`,
        payload,
        AUTH(),
      );

      if (res.status === 200 || res.status === 201) {
        toast.success("Submission data updated successfully!");

        // 🟢 3️⃣ sirf wahi docs jinki nayi File select hui hai
        const documentEntries = formData
          .flatMap((sub) =>
            sub.commentData.filter((d) => d.inputtype === "document"),
          )
          .filter((d) => d.document_file instanceof File);

        if (!documentEntries.length) {
          toast.dismiss(loadingToastId);
          setShow(false);
          getProject();
          return;
        }

        const filesToConfirm = [];

        // 🧠 4️⃣ API 1 (chunks) + API 2 (complete)
        for (const doc of documentEntries) {
          try {
            const uploaded = await uploadDocumentChunked(doc.document_file, (pct) =>
              toast.update(loadingToastId, {
                render: `Uploading ${doc.document_name || doc.document_file.name}… ${pct}%`,
              }),
            );

            filesToConfirm.push({
              file_id: uploaded.file_id,
              section_id: id, // workstat/section id, agar alag ho to yahan badlo
              file_path: uploaded.file_path,
              document_name: doc.document_name || doc.document_file.name,
              original_filename: doc.document_file.name,
              input_id: doc.id,
            });
          } catch (err) {
            console.error("❌ Document upload failed:", err);
            toast.error(`Failed for document: ${doc.document_name}`);
          }
        }

        // 🟢 5️⃣ API 3 — confirm
        if (filesToConfirm.length > 0) {
          try {
            await confirmUploads(project, filesToConfirm);
          } catch (err) {
            console.error("❌ Confirm upload failed:", err);
            toast.error("Documents confirm nahi ho paye, please retry.");
          }
        }

        getProject();
        getDocuments();
        setShow(false);
      } else {
        toast.error("Update failed, please try again.");
      }
    } catch (err) {
      console.error("Error updating project:", err);
      toast.error("Something went wrong while updating submission");
    } finally {
      toast.dismiss(loadingToastId);
      setSubmitting(false);
    }
  };

  return (
    <>
      <button onClick={handleShow}>
        <AddwithBlueCircle />
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave"
        size="lg"
      >
        <Modal.Header closeButton className="justify-center">
          <Modal.Title className="font-weight600 font-size-heading text-center w-100">
            Add / Edit Comment Details
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ padding: "16px 20px", overflowX: "hidden" }}>
          <form onSubmit={handleFormSubmit}>
            {formData.map((item, index) => (
              <div
                key={index}
                style={{
                  border: "0.5px solid #e0e0e0",
                  borderRadius: "6px",
                  marginBottom: "12px",
                  background: "#fff",
                  overflow: "hidden",
                }}
              >
                {/* Header */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "10px 14px",
                    background: "#f5f7fa",
                    borderBottom: "0.5px solid #e0e0e0",
                  }}
                >
                  <span style={{ fontSize: "13px", fontWeight: 600, color: "#1e293b" }}>
                    Submission {index + 1}
                  </span>
                </div>

                {/* Body */}
                <div style={{ padding: "14px 16px" }}>
                  {/* Submission Name */}
                  <div style={{ marginBottom: "14px" }}>
                    <label
                      style={{
                        fontSize: "12px",
                        fontWeight: 500,
                        color: "#374151",
                        display: "block",
                        marginBottom: "6px",
                      }}
                    >
                      Submission Name{" "}
                      <span style={{ color: "#dc2626" }}>(Read-Only)</span>
                    </label>
                    <textarea
                      name="submissionName"
                      placeholder="Enter Submission Name"
                      onChange={(e) => handleInputChange(e, index)}
                      value={item.submissionName}
                      readOnly
                      style={{
                        width: "100%",
                        padding: "8px 5px",
                        border: errors[`submissionName_${index}`]
                          ? "1px solid #dc2626"
                          : "0.5px solid #e0e0e0",
                        borderRadius: "5px",
                        fontSize: "13px",
                        color: "#1e293b",
                        background: "#f9fafb",
                        outline: "none",
                        boxSizing: "border-box",
                        resize: "vertical",
                        minHeight: "72px",
                      }}
                    />
                    {errors[`submissionName_${index}`] && (
                      <span
                        style={{
                          display: "block",
                          marginTop: "4px",
                          fontSize: "11px",
                          color: "#dc2626",
                        }}
                      >
                        {errors[`submissionName_${index}`]}
                      </span>
                    )}
                  </div>

                  {/* Comment Data Section */}
                  <div>
                    <h6
                      style={{
                        fontSize: "13px",
                        fontWeight: 600,
                        color: "#1e293b",
                        marginBottom: "10px",
                      }}
                    >
                      Comment Data
                    </h6>

                    {item.commentData.map((sub, subIndex) => (
                      <div
                        key={sub.id}
                        style={{
                          border: "0.5px solid #e0e0e0",
                          borderRadius: "6px",
                          marginBottom: "10px",
                          background: "#fff",
                          overflow: "hidden",
                        }}
                      >
                        {/* Sub-item Header */}
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "8px 12px",
                            background: "#f5f7fa",
                            borderBottom: "0.5px solid #e0e0e0",
                          }}
                        >
                          <span style={{ fontSize: "12px", fontWeight: 600, color: "#1e293b" }}>
                            Comment {subIndex + 1}
                          </span>
                          <button
                            type="button"
                            onClick={() => handleRemoveSubmissionData(index, subIndex)}
                            style={{
                              fontSize: "11px",
                              fontWeight: 500,
                              color: "#dc2626",
                              background: "#fee2e2",
                              border: "none",
                              borderRadius: "4px",
                              padding: "3px 10px",
                              cursor: "pointer",
                            }}
                          >
                            Remove
                          </button>
                        </div>

                        {/* Sub-item Body */}
                        <div style={{ padding: "12px 14px" }}>
                          {/* Comments On */}
                          <div style={{ marginBottom: "12px" }}>
                            <label
                              style={{
                                fontSize: "12px",
                                fontWeight: 500,
                                color: "#374151",
                                display: "block",
                                marginBottom: "6px",
                              }}
                            >
                              Comments on
                            </label>
                            <select
                              name="submissionId"
                              value={sub.submissionId}
                              onChange={(e) => handleSubmissionDataChange(e, index, subIndex)}
                              style={{
                                width: "100%",
                                padding: "8px 5px",
                                border: "0.5px solid #e0e0e0",
                                borderRadius: "5px",
                                fontSize: "13px",
                                color: "#1e293b",
                                background: "#f9fafb",
                                outline: "none",
                                boxSizing: "border-box",
                                cursor: "pointer",
                              }}
                            >
                              <option value="">Select Value</option>
                              {iddData.map((i) => (
                                <option key={i.id} value={i.id}>
                                  {i.rev_no}
                                </option>
                              ))}
                            </select>
                          </div>

                          {/* Date */}
                          <div style={{ marginBottom: "12px" }}>
                            <label
                              style={{
                                fontSize: "12px",
                                fontWeight: 500,
                                color: "#374151",
                                display: "block",
                                marginBottom: "6px",
                              }}
                            >
                              Date
                            </label>
                            <input
                              type="date"
                              name="date"
                              placeholder="Enter Value"
                              value={sub.date}
                              min={loaDate}
                              onChange={(e) => handleSubmissionDataChange(e, index, subIndex)}
                              style={{
                                width: "100%",
                                padding: "8px 5px",
                                border: errors[`date_${index}_${subIndex}`]
                                  ? "1px solid #dc2626"
                                  : "0.5px solid #e0e0e0",
                                borderRadius: "5px",
                                fontSize: "13px",
                                color: "#1e293b",
                                background: "#f9fafb",
                                outline: "none",
                                boxSizing: "border-box",
                              }}
                            />
                          </div>

                          {/* Input Type */}
                          <div style={{ marginBottom: "12px" }}>
                            <label
                              style={{
                                fontSize: "12px",
                                fontWeight: 500,
                                color: "#374151",
                                display: "block",
                                marginBottom: "6px",
                              }}
                            >
                              Input Type
                            </label>
                            <select
                              name="inputtype"
                              value={sub.inputtype}
                              onChange={(e) => handleSubmissionDataChange(e, index, subIndex)}
                              style={{
                                width: "100%",
                                padding: "8px 5px",
                                border: "0.5px solid #e0e0e0",
                                borderRadius: "5px",
                                fontSize: "13px",
                                color: "#1e293b",
                                background: "#f9fafb",
                                outline: "none",
                                boxSizing: "border-box",
                                cursor: "pointer",
                              }}
                            >
                              <option value="">Select Type</option>
                              <option value="normal">Normal Input</option>
                              <option value="document">Document</option>
                            </select>
                          </div>

                          {/* Letter Number */}
                          <div style={{ marginBottom: "12px" }}>
                            <label
                              style={{
                                fontSize: "12px",
                                fontWeight: 500,
                                color: "#374151",
                                display: "block",
                                marginBottom: "6px",
                              }}
                            >
                              Letter Number{" "}
                              {sub.inputtype === "normal" && (
                                <span style={{ color: "#dc2626" }}>(Read-Only)</span>
                              )}
                            </label>
                            <input
                              type="text"
                              name="Letter_num"
                              disabled={sub.inputtype === "normal"}
                              placeholder="Enter Value"
                              value={sub.inputtype === "document" ? sub.Letter_num : "NA"}
                              onChange={(e) => handleSubmissionDataChange(e, index, subIndex)}
                              style={{
                                width: "100%",
                                padding: "8px 5px",
                                border: errors[`Letter_num_${index}_${subIndex}`]
                                  ? "1px solid #dc2626"
                                  : "0.5px solid #e0e0e0",
                                borderRadius: "5px",
                                fontSize: "13px",
                                color: "#1e293b",
                                background: sub.inputtype === "normal" ? "#f1f5f9" : "#f9fafb",
                                outline: "none",
                                boxSizing: "border-box",
                              }}
                            />
                          </div>

                          {/* From */}
                          <div style={{ marginBottom: "12px" }}>
                            <label
                              style={{
                                fontSize: "12px",
                                fontWeight: 500,
                                color: "#374151",
                                display: "block",
                                marginBottom: "6px",
                              }}
                            >
                              From
                            </label>
                            <input
                              type="text"
                              name="from"
                              placeholder="Enter Client Email id"
                              value={sub.from}
                              onChange={(e) => handleSubmissionDataChange(e, index, subIndex)}
                              style={{
                                width: "100%",
                                padding: "8px 5px",
                                border: errors[`from_${index}_${subIndex}`]
                                  ? "1px solid #dc2626"
                                  : "0.5px solid #e0e0e0",
                                borderRadius: "5px",
                                fontSize: "13px",
                                color: "#1e293b",
                                background: "#f9fafb",
                                outline: "none",
                                boxSizing: "border-box",
                              }}
                            />
                          </div>

                          {/* Description */}
                          <div style={{ marginBottom: "12px" }}>
                            <label
                              style={{
                                fontSize: "12px",
                                fontWeight: 500,
                                color: "#374151",
                                display: "block",
                                marginBottom: "6px",
                              }}
                            >
                              Description
                            </label>
                            <input
                              type="text"
                              name="description"
                              placeholder="Enter Description"
                              value={sub.description}
                              onChange={(e) => handleSubmissionDataChange(e, index, subIndex)}
                              style={{
                                width: "100%",
                                padding: "8px 5px",
                                border: errors[`description_${index}_${subIndex}`]
                                  ? "1px solid #dc2626"
                                  : "0.5px solid #e0e0e0",
                                borderRadius: "5px",
                                fontSize: "13px",
                                color: "#1e293b",
                                background: "#f9fafb",
                                outline: "none",
                                boxSizing: "border-box",
                              }}
                            />
                          </div>

                          {/* Document Fields */}
                          {sub.inputtype === "document" && (
                            <>
                              <div style={{ marginBottom: "12px" }}>
                                <label
                                  style={{
                                    fontSize: "12px",
                                    fontWeight: 500,
                                    color: "#374151",
                                    display: "block",
                                    marginBottom: "6px",
                                  }}
                                >
                                  Document Name
                                </label>
                                <input
                                  name="document_name"
                                  placeholder="Document Name"
                                  value={sub.document_name}
                                  onChange={(e) => handleSubmissionDataChange(e, index, subIndex)}
                                  style={{
                                    width: "100%",
                                    padding: "8px 5px",
                                    border: "0.5px solid #e0e0e0",
                                    borderRadius: "5px",
                                    fontSize: "13px",
                                    color: "#1e293b",
                                    background: "#f9fafb",
                                    outline: "none",
                                    boxSizing: "border-box",
                                  }}
                                />
                              </div>
                              <div style={{ marginBottom: "12px" }}>
                                <label
                                  style={{
                                    fontSize: "12px",
                                    fontWeight: 500,
                                    color: "#374151",
                                    display: "block",
                                    marginBottom: "6px",
                                  }}
                                >
                                  Upload File
                                </label>
                                <input
                                  type="file"
                                  name="document_file"
                                  onChange={(e) => handleSubmissionDataChange(e, index, subIndex)}
                                  style={{
                                    width: "100%",
                                    padding: "8px 5px",
                                    border: "0.5px solid #e0e0e0",
                                    borderRadius: "5px",
                                    fontSize: "13px",
                                    color: "#1e293b",
                                    background: "#f9fafb",
                                    outline: "none",
                                    boxSizing: "border-box",
                                  }}
                                />
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    ))}

                    {/* Add Comment Data */}
                    <div style={{ textAlign: "center", marginBottom: "8px" }}>
                      <button
                        type="button"
                        onClick={() => handleAddSubmissionData(index)}
                        style={{
                          padding: "6px 16px",
                          borderRadius: "5px",
                          border: "0.5px solid #2576bc",
                          background: "#fff",
                          color: "#2576bc",
                          fontSize: "12px",
                          fontWeight: 500,
                          cursor: "pointer",
                        }}
                      >
                        + Add Comment Data
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}

            {/* Footer */}
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
                paddingTop: "12px",
                borderTop: "0.5px solid #e0e0e0",
              }}
            >
              <button
                type="submit"
                disabled={submitting}
                style={{
                  padding: "7px 18px",
                  borderRadius: "5px",
                  border: "none",
                  background: "#2576bc",
                  color: "#fff",
                  fontSize: "12px",
                  fontWeight: 500,
                  opacity: submitting ? 0.6 : 1,
                  cursor: submitting ? "not-allowed" : "pointer",
                }}
              >
                {submitting ? "Saving..." : "Update"}
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

const AddReplyData = ({
  i,
  documentData,
  getProject,
  project,
  allData,
  id,
  submission_id,
  submissionItem,
  getDocuments,
}) => {
  const [errors, setErrors] = useState({});
  const [show, setShow] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [formData, setFormData] = useState([
    {
      submissionName: "",
      submission_id: "",
      commentData: [],
      replyData: [],
      submissionData: [],
    },
  ]);
  const [formData2, setFormData2] = useState();

  const [documentFormData, setDocumentFormData] = useState([
    {
      input_id: "null",
      document_file: null,
      name: null,
      project: "null",
    },
  ]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDocumentFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    setDocumentFormData((prev) => ({
      ...prev,
      document_file: e.target.files[0],
    }));
  };

  const [idData, setIdData] = useState({});
  const loaDate = allData?.project_details_data?.loa_date || "";

  // 🟢 Open modal & prefill data
  const handleShow = () => {
    if (allData?.workstat && Array.isArray(allData.workstat)) {
      // 1️⃣ Find the current workstage by matching workstat id
      const targetWorkstage = allData?.workstat.find(
        (w) => w.id === submissionItem.id,
      );

      if (submissionItem && submissionItem?.length > 0) {
        const filteredSubmission = submissionItem.filter(
          (item) => item.submission_id === submission_id,
        );

        if (filteredSubmission.length > 0) {
          setIdData(filteredSubmission[0]);
          setFormData(
            filteredSubmission.map((item) => ({
              submissionName: item.submissionName || "",
              commentData: item.commentData || [],
              replyData: item.replyData || [],
              submissionData: item.submissionData || [],
              submission_id: item.submission_id || "",
            })),
          );
        } else {
          // no match — reset to blank form
          setFormData([
            {
              submissionName: "",
              submission_id: "",
              commentData: [],
              replyData: [],
              submissionData: [],
            },
          ]);
        }
      }
    }

    setFormData2(allData);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setErrors({});
  };

  const [iddData, setIddData] = useState([]);
  useEffect(() => {
    if (Array.isArray(idData.commentData) && idData.commentData.length > 0) {
      setIddData(idData.commentData);
    }
  }, [idData]);

  // 🟡 handle submission name input
  const handleInputChange = (e, index) => {
    const { name, value } = e.target;

    const updated = [...formData];
    updated[index][name] = value;
    setFormData(updated);

    // Clear field error immediately
    setErrors((prev) => {
      const newErrors = { ...prev };

      if (value.trim()) {
        delete newErrors[`${name}_${index}`];
      }

      if (newErrors._global) {
        delete newErrors._global;
      }

      return newErrors;
    });
  };

  // ➕ Add new submission section
  const handleAddSubmission = () => {
    setFormData((prev) => [
      ...prev,
      {
        submissionName: "",
        commentData: [],
        replyData: [],
        submissionData: [],
      },
    ]);
  };

  // ❌ Remove a submission section
  const handleRemoveSubmission = (index) => {
    setFormData((prev) => prev.filter((_, i) => i !== index));
  };

  // 🟢 Add new submissionData field (normal/document)
  const handleAddSubmissionData = (index) => {
    const updated = [...formData];
    const currentInputType = updated[index]?.inputtype;

    const newEntry = {
      id: uuidv4(),
      commentId: "",
      inputtype: currentInputType || "",
      document_file: "",
      date: "",
      to: "",
      description: "",
      comment_letter_num: ``,
      Letter_num: currentInputType === "normal" ? "NA" : "",
      document_name: currentInputType === "normal" ? "NA" : "",
      ReplyInput: "",
      comment_value: "",
    };
    updated[index].replyData.push(newEntry);
    setFormData(updated);
  };

  // 🟠 Handle changes inside submissionData array
  const handleSubmissionDataChange = (e, parentIndex, childIndex) => {
    const { name, value, files } = e.target;

    setFormData((prev) =>
      prev.map((parent, pIndex) => {
        if (pIndex !== parentIndex) return parent;

        return {
          ...parent,
          replyData: parent.replyData.map((child, cIndex) => {
            if (cIndex !== childIndex) return child;

            let updatedChild = { ...child };

            // ✅ FIRST update the changed field
            if (name === "document_file") {
              if (files?.length > 0) {
                const file = files[0];
                updatedChild.document_file = file;
                updatedChild.document_name = file.name;
              } else {
                updatedChild.document_file = null;
                updatedChild.document_name = "";
              }
            } else {
              updatedChild[name] = value;
            }

            // ✅ THEN find submission (after submissionId updated)
            if (name === "commentId") {
              const commentData = iddData.find(
                (item) => String(item.id) === String(value),
              );

              if (commentData) {
                updatedChild.to = commentData.from;
                updatedChild.comment_letter_num = commentData.Letter_num;
              }
            }

            // ✅ Normal type reset
            if (updatedChild.inputtype === "normal") {
              updatedChild.Letter_num = "NA";
              updatedChild.document_name = "NA";
              updatedChild.document_file = null;
            }

            return updatedChild;
          }),
        };
      }),
    );
  };

  const handleRemoveSubmissionData = async (parentIndex, childIndex) => {
    const updated = [...formData];
    const removedItem = updated[parentIndex].replyData[childIndex];

    // 🧠 Check if it's a document
    if (removedItem.inputtype === "document" && removedItem.id) {
      const existingDoc = (documentData || []).find(
        (doc) => doc.input_id === removedItem.id,
      );

      // ⚠️ Show confirmation before deleting
      const confirmDelete = window.confirm(
        `Are you sure you want to delete this document: "${removedItem.document_name || existingDoc?.name || "Unnamed Document"}"?`,
      );

      if (!confirmDelete) {
        toast.info("Deletion cancelled.");
        return;
      }

      if (existingDoc) {
        try {
          // 🔥 Delete document from backend
          await axios.delete(`${BASE_URL}/dpr/document/${existingDoc.id}/`, AUTH());
          toast.success(`Document "${existingDoc.name}" deleted successfully.`);
        } catch (err) {
          console.error("❌ Error deleting document:", err);
          toast.error(`Failed to delete document: ${existingDoc.name}`);
        }
      }
    }

    // 🧹 Remove from local state
    updated[parentIndex].replyData.splice(childIndex, 1);
    setFormData(updated);
  };

  // ✅ Validate
  const validateform = () => {
    const newErrors = {};
    formData.forEach((item, idx) => {
      if (!item.submissionName?.trim()) {
        newErrors[`submissionName_${idx}`] = "Submission name is required!";
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setSubmitting(true);
    const loadingToastId = toast.loading("Updating ... Please wait...");

    try {
      const updatedData = { ...allData };

      // 🟢 1️⃣ Update submission data inside project
      if (updatedData?.workstat && Array.isArray(updatedData.workstat)) {
        const targetWorkstat = updatedData.workstat.find((w) => w.id === i.id);

        if (submissionItem && submissionItem?.length > 0) {
          const targetSubmission = submissionItem.find(
            (sub) => sub.submission_id === submission_id,
          );

          if (targetSubmission) {
            // Update existing submissionData
            const updatedSubmissionData = formData[0].replyData.map((item) =>
              item.id ? item : { ...item, id: uuidv4() },
            );
            targetSubmission.replyData = updatedSubmissionData;
          } else {
            // Add new submission entry
            targetWorkstat.submission_data.push({
              submission_id,
              submissionName: formData[0].submissionName || "",
              submissionData: [],
              commentData: [],
              replyData: formData[0].replyData.map((d) => ({
                ...d,
                id: d.id || uuidv4(),
              })),
            });
          }
        }
      }

      const payload = {
        workstat: updatedData.workstat,
      };

      // 🟢 2️⃣ Update project
      const res = await axios.put(
        `${BASE_URL}/dpr/project/${project}/`,
        payload,
        AUTH(),
      );

      if (res.status === 200 || res.status === 201) {
        toast.success("Submission data updated successfully!");

        // 🟢 3️⃣ sirf wahi docs jinki nayi File select hui hai
        const documentEntries = formData
          .flatMap((sub) =>
            sub.replyData.filter((d) => d.inputtype === "document"),
          )
          .filter((d) => d.document_file instanceof File);

        if (!documentEntries.length) {
          toast.dismiss(loadingToastId);
          setShow(false);
          getProject();
          return;
        }

        const filesToConfirm = [];

        // 🧠 4️⃣ API 1 (chunks) + API 2 (complete)
        for (const doc of documentEntries) {
          try {
            const uploaded = await uploadDocumentChunked(doc.document_file, (pct) =>
              toast.update(loadingToastId, {
                render: `Uploading ${doc.document_name || doc.document_file.name}… ${pct}%`,
              }),
            );

            filesToConfirm.push({
              file_id: uploaded.file_id,
              section_id: id, // workstat/section id, agar alag ho to yahan badlo
              file_path: uploaded.file_path,
              document_name: doc.document_name || doc.document_file.name,
              original_filename: doc.document_file.name,
              input_id: doc.id,
            });
          } catch (err) {
            console.error("❌ Document upload failed:", err);
            toast.error(`Failed for document: ${doc.document_name}`);
          }
        }

        // 🟢 5️⃣ API 3 — confirm
        if (filesToConfirm.length > 0) {
          try {
            await confirmUploads(project, filesToConfirm);
          } catch (err) {
            console.error("❌ Confirm upload failed:", err);
            toast.error("Documents confirm nahi ho paye, please retry.");
          }
        }

        getProject();
        getDocuments();
        setShow(false);
      } else {
        toast.error("Update failed, please try again.");
      }
    } catch (err) {
      console.error("Error updating project:", err);
      toast.error("Something went wrong while updating submission");
    } finally {
      toast.dismiss(loadingToastId);
      setSubmitting(false);
    }
  };

  return (
    <>
      <button onClick={handleShow}>
        <AddwithBlueCircle />
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave"
        size="lg"
      >
        <Modal.Header closeButton className="justify-center">
          <Modal.Title className="font-weight600 font-size-heading text-center w-100">
            Add / Edit Reply Details
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ padding: "16px 20px", overflowX: "hidden" }}>
          <form onSubmit={handleFormSubmit}>
            {formData.map((item, index) => (
              <div
                key={index}
                style={{
                  border: "0.5px solid #e0e0e0",
                  borderRadius: "6px",
                  marginBottom: "12px",
                  background: "#fff",
                  overflow: "hidden",
                }}
              >
                {/* Header */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "10px 14px",
                    background: "#f5f7fa",
                    borderBottom: "0.5px solid #e0e0e0",
                  }}
                >
                  <span style={{ fontSize: "13px", fontWeight: 600, color: "#1e293b" }}>
                    Submission {index + 1}
                  </span>
                  {formData.length > 1 && (
                    <button
                      type="button"
                      onClick={() => handleRemoveSubmission(index)}
                      style={{
                        fontSize: "11px",
                        fontWeight: 500,
                        color: "#dc2626",
                        background: "#fee2e2",
                        border: "none",
                        borderRadius: "4px",
                        padding: "3px 10px",
                        cursor: "pointer",
                      }}
                    >
                      Remove
                    </button>
                  )}
                </div>

                {/* Body */}
                <div style={{ padding: "14px 16px" }}>
                  {/* Submission Name */}
                  <div style={{ marginBottom: "14px" }}>
                    <label
                      style={{
                        fontSize: "12px",
                        fontWeight: 500,
                        color: "#374151",
                        display: "block",
                        marginBottom: "6px",
                      }}
                    >
                      Submission Name{" "}
                      <span style={{ color: "#dc2626" }}>(Read-Only)</span>
                    </label>
                    <textarea
                      name="submissionName"
                      placeholder="Enter Submission Name"
                      onChange={(e) => handleInputChange(e, index)}
                      value={item.submissionName}
                      disabled
                      style={{
                        width: "100%",
                        padding: "8px 5px",
                        border: errors[`submissionName_${index}`]
                          ? "1px solid #dc2626"
                          : "0.5px solid #e0e0e0",
                        borderRadius: "5px",
                        fontSize: "13px",
                        color: "#1e293b",
                        background: "#f1f5f9",
                        outline: "none",
                        boxSizing: "border-box",
                        resize: "vertical",
                        minHeight: "72px",
                        cursor: "not-allowed",
                      }}
                    />
                    {errors[`submissionName_${index}`] && (
                      <span
                        style={{
                          display: "block",
                          marginTop: "4px",
                          fontSize: "11px",
                          color: "#dc2626",
                        }}
                      >
                        {errors[`submissionName_${index}`]}
                      </span>
                    )}
                  </div>

                  {/* Reply Data Section */}
                  <div>
                    <h6
                      style={{
                        fontSize: "13px",
                        fontWeight: 600,
                        color: "#1e293b",
                        marginBottom: "10px",
                      }}
                    >
                      Reply Data
                    </h6>

                    {item.replyData.map((sub, subIndex) => (
                      <div
                        key={sub.id}
                        style={{
                          border: "0.5px solid #e0e0e0",
                          borderRadius: "6px",
                          marginBottom: "10px",
                          background: "#fff",
                          overflow: "hidden",
                        }}
                      >
                        {/* Sub-item Header */}
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "8px 12px",
                            background: "#f5f7fa",
                            borderBottom: "0.5px solid #e0e0e0",
                          }}
                        >
                          <span style={{ fontSize: "12px", fontWeight: 600, color: "#1e293b" }}>
                            Reply {subIndex + 1}
                          </span>
                          <button
                            type="button"
                            onClick={() => handleRemoveSubmissionData(index, subIndex)}
                            style={{
                              fontSize: "11px",
                              fontWeight: 500,
                              color: "#dc2626",
                              background: "#fee2e2",
                              border: "none",
                              borderRadius: "4px",
                              padding: "3px 10px",
                              cursor: "pointer",
                            }}
                          >
                            Remove
                          </button>
                        </div>

                        {/* Sub-item Body */}
                        <div style={{ padding: "12px 14px" }}>
                          {/* Reply Of */}
                          <div style={{ marginBottom: "12px" }}>
                            <label
                              style={{
                                fontSize: "12px",
                                fontWeight: 500,
                                color: "#374151",
                                display: "block",
                                marginBottom: "6px",
                              }}
                            >
                              Reply Of
                            </label>
                            <select
                              name="commentId"
                              value={sub.commentId}
                              onChange={(e) => handleSubmissionDataChange(e, index, subIndex)}
                              style={{
                                width: "100%",
                                padding: "8px 5px",
                                border: "0.5px solid #e0e0e0",
                                borderRadius: "5px",
                                fontSize: "13px",
                                color: "#1e293b",
                                background: "#f9fafb",
                                outline: "none",
                                boxSizing: "border-box",
                                cursor: "pointer",
                              }}
                            >
                              <option value="">Select Value</option>
                              {iddData.map((i) => (
                                <option key={i.id} value={i.id}>
                                  {i.Letter_num}
                                </option>
                              ))}
                            </select>
                          </div>

                          {/* Date */}
                          <div style={{ marginBottom: "12px" }}>
                            <label
                              style={{
                                fontSize: "12px",
                                fontWeight: 500,
                                color: "#374151",
                                display: "block",
                                marginBottom: "6px",
                              }}
                            >
                              Date
                            </label>
                            <input
                              type="date"
                              name="date"
                              placeholder="Enter Value"
                              value={sub.date}
                              min={loaDate}
                              onChange={(e) => handleSubmissionDataChange(e, index, subIndex)}
                              style={{
                                width: "100%",
                                padding: "8px 5px",
                                border: errors[`date_${index}_${subIndex}`]
                                  ? "1px solid #dc2626"
                                  : "0.5px solid #e0e0e0",
                                borderRadius: "5px",
                                fontSize: "13px",
                                color: "#1e293b",
                                background: "#f9fafb",
                                outline: "none",
                                boxSizing: "border-box",
                              }}
                            />
                          </div>

                          {/* Input Type */}
                          <div style={{ marginBottom: "12px" }}>
                            <label
                              style={{
                                fontSize: "12px",
                                fontWeight: 500,
                                color: "#374151",
                                display: "block",
                                marginBottom: "6px",
                              }}
                            >
                              Input Type
                            </label>
                            <select
                              name="inputtype"
                              value={sub.inputtype}
                              onChange={(e) => handleSubmissionDataChange(e, index, subIndex)}
                              style={{
                                width: "100%",
                                padding: "8px 5px",
                                border: "0.5px solid #e0e0e0",
                                borderRadius: "5px",
                                fontSize: "13px",
                                color: "#1e293b",
                                background: "#f9fafb",
                                outline: "none",
                                boxSizing: "border-box",
                                cursor: "pointer",
                              }}
                            >
                              <option value="">Select Type</option>
                              <option value="normal">Normal Input</option>
                              <option value="document">Document</option>
                            </select>
                          </div>

                          {/* Letter Number */}
                          <div style={{ marginBottom: "12px" }}>
                            <label
                              style={{
                                fontSize: "12px",
                                fontWeight: 500,
                                color: "#374151",
                                display: "block",
                                marginBottom: "6px",
                              }}
                            >
                              Letter Number{" "}
                              {sub.inputtype === "normal" && (
                                <span style={{ color: "#dc2626" }}>(Read-Only)</span>
                              )}
                            </label>
                            <input
                              type="text"
                              name="Letter_num"
                              disabled={sub.inputtype === "normal"}
                              placeholder="Enter Value"
                              value={sub.inputtype === "document" ? sub.Letter_num : "NA"}
                              onChange={(e) => handleSubmissionDataChange(e, index, subIndex)}
                              style={{
                                width: "100%",
                                padding: "8px 5px",
                                border: errors[`Letter_num_${index}_${subIndex}`]
                                  ? "1px solid #dc2626"
                                  : "0.5px solid #e0e0e0",
                                borderRadius: "5px",
                                fontSize: "13px",
                                color: "#1e293b",
                                background: sub.inputtype === "normal" ? "#f1f5f9" : "#f9fafb",
                                outline: "none",
                                boxSizing: "border-box",
                              }}
                            />
                          </div>

                          {/* To */}
                          <div style={{ marginBottom: "12px" }}>
                            <label
                              style={{
                                fontSize: "12px",
                                fontWeight: 500,
                                color: "#374151",
                                display: "block",
                                marginBottom: "6px",
                              }}
                            >
                              To
                            </label>
                            <input
                              type="text"
                              name="to"
                              placeholder="Enter Client Email id"
                              value={sub.to}
                              onChange={(e) => handleSubmissionDataChange(e, index, subIndex)}
                              style={{
                                width: "100%",
                                padding: "8px 5px",
                                border: errors[`to_${index}_${subIndex}`]
                                  ? "1px solid #dc2626"
                                  : "0.5px solid #e0e0e0",
                                borderRadius: "5px",
                                fontSize: "13px",
                                color: "#1e293b",
                                background: "#f9fafb",
                                outline: "none",
                                boxSizing: "border-box",
                              }}
                            />
                          </div>

                          {/* Description */}
                          <div style={{ marginBottom: "12px" }}>
                            <label
                              style={{
                                fontSize: "12px",
                                fontWeight: 500,
                                color: "#374151",
                                display: "block",
                                marginBottom: "6px",
                              }}
                            >
                              Description
                            </label>
                            <input
                              type="text"
                              name="description"
                              placeholder="Enter Description"
                              value={sub.description}
                              onChange={(e) => handleSubmissionDataChange(e, index, subIndex)}
                              style={{
                                width: "100%",
                                padding: "8px 5px",
                                border: errors[`description_${index}_${subIndex}`]
                                  ? "1px solid #dc2626"
                                  : "0.5px solid #e0e0e0",
                                borderRadius: "5px",
                                fontSize: "13px",
                                color: "#1e293b",
                                background: "#f9fafb",
                                outline: "none",
                                boxSizing: "border-box",
                              }}
                            />
                          </div>

                          {/* Document Fields */}
                          {sub.inputtype === "document" && (
                            <>
                              <div style={{ marginBottom: "12px" }}>
                                <label
                                  style={{
                                    fontSize: "12px",
                                    fontWeight: 500,
                                    color: "#374151",
                                    display: "block",
                                    marginBottom: "6px",
                                  }}
                                >
                                  Document Name
                                </label>
                                <input
                                  name="document_name"
                                  placeholder="Enter Document Name"
                                  value={sub.document_name}
                                  onChange={(e) => handleSubmissionDataChange(e, index, subIndex)}
                                  style={{
                                    width: "100%",
                                    padding: "8px 5px",
                                    border: "0.5px solid #e0e0e0",
                                    borderRadius: "5px",
                                    fontSize: "13px",
                                    color: "#1e293b",
                                    background: "#f9fafb",
                                    outline: "none",
                                    boxSizing: "border-box",
                                  }}
                                />
                              </div>
                              <div style={{ marginBottom: "12px" }}>
                                <label
                                  style={{
                                    fontSize: "12px",
                                    fontWeight: 500,
                                    color: "#374151",
                                    display: "block",
                                    marginBottom: "6px",
                                  }}
                                >
                                  Upload File
                                </label>
                                <input
                                  type="file"
                                  name="document_file"
                                  onChange={(e) => handleSubmissionDataChange(e, index, subIndex)}
                                  style={{
                                    width: "100%",
                                    padding: "8px 5px",
                                    border: "0.5px solid #e0e0e0",
                                    borderRadius: "5px",
                                    fontSize: "13px",
                                    color: "#1e293b",
                                    background: "#f9fafb",
                                    outline: "none",
                                    boxSizing: "border-box",
                                  }}
                                />
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    ))}

                    {/* Add Reply Data */}
                    <div style={{ textAlign: "center", marginBottom: "8px" }}>
                      <button
                        type="button"
                        onClick={() => handleAddSubmissionData(index)}
                        style={{
                          padding: "6px 16px",
                          borderRadius: "5px",
                          border: "0.5px solid #2576bc",
                          background: "#fff",
                          color: "#2576bc",
                          fontSize: "12px",
                          fontWeight: 500,
                          cursor: "pointer",
                        }}
                      >
                        + Add Reply Data
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}

            {/* Footer */}
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
                paddingTop: "12px",
                borderTop: "0.5px solid #e0e0e0",
              }}
            >
              <button
                type="submit"
                disabled={submitting}
                style={{
                  padding: "7px 18px",
                  borderRadius: "5px",
                  border: "none",
                  background: "#2576bc",
                  color: "#fff",
                  fontSize: "12px",
                  fontWeight: 500,
                  opacity: submitting ? 0.6 : 1,
                  cursor: submitting ? "not-allowed" : "pointer",
                }}
              >
                {submitting ? "Saving..." : "Update"}
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

const AddinputData = ({
  i,
  getProject,
  project,
  allData,
  id,
  documentData,
  getDocuments,
}) => {
  const [errors, setErrors] = useState({});
  const [show, setShow] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [sectionFormData, setSectionFormData] = useState({
    remaining_amount: "",
    about_to_bill: "",
    section_cost: "",
  });
  const [formData, setFormData] = useState([
    {
      id: "",
      status: "",
      input_type: "",
      total_value: "",
      covered_value: "",
      remaining_value: "",
      document_name: "",
      document_file: "",
      cost: "",
      about_to_bill: "",
      remaining_amount: "",
      work_done: "",
      pending_work: "",
      stage: [],
      remarks: [],
    },
  ]);
  const [formData2, setFormData2] = useState();

  const [formDataStage, setFormDataStage] = useState([
    {
      id: "",
      stage_name: "",
      stage_percentage: "",
      stage_amount: "",
      completed_percentage: "",
      remaining_percentage: "",
      completed_work: "",
      remaining_work: "",
      status: "pedning",
      remarks: [
        {
          id: "",
          remarks: "",
          remarks_date: "",
        },
      ],
    },
  ]);

  const [stageRemarks, setStageRemarks] = useState([
    {
      id: "",
      remarks: "",
      remarks_date: "",
    },
  ]);


  // 🟢 Open modal and pre-fill with existing submission data (if present)
  const handleShow = () => {
    if (allData?.workstat && Array.isArray(allData.workstat)) {
      const target = allData.workstat.find((w) => w.id === id);

      if (target && target.normal_input?.length > 0) {
        // Pre-fill existing submission data
        setFormData(
          target.normal_input.map((item) => ({
            id: item.id || "",
            status: item.status || "",
            input_type: item.input_type || "",
            total_value: item.total_value || "",
            covered_value: item.covered_value || "",
            remaining_value: item.remaining_value || "",
            document_name: item.document_name || "",
            scope: item.scope || "",
            about_to_bill: item.about_to_bill || "",
            remaining_amount: item.remaining_amount || "",
            work_done: item.work_done || "",
            pending_work: item.pending_work || "",
            actual: item.actual || "",
            remarks: item.remarks || [],
            cost: item.cost || "",
            stage: item.stage || [],
          })),
        );
      } else {
        // No existing data → empty one input field
        setFormData([
          {
            id: "",
            status: "",
            about_to_bill: "",
            remaining_amount: "",
            work_done: "",
            pending_work: "",
            input_type: "",
            total_value: "",
            covered_value: "",
            remaining_value: "",
            document_name: "",
            document_file: "",
            actual: "",
            scope: "",
            stage: [],
            cost: "",
            remarks: [],
          },
        ]);
      }
    }

    setFormData2(allData);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setErrors({});
    setStageRemarks([]);

    // Reset only original stages
    if (formData[0]?.stage?.length > 0) {
      const originalStages = formData[0].stage.map((item) => ({
        id: item.id || "",
        stage_name: item.stage_name || "",
        stage_percentage: item.stage_percentage || "",
        stage_amount: item.stage_amount || "",
        completed_percentage: item.completed_percentage || "",
        remaining_percentage: item.remaining_percentage || "",
        completed_work: item.completed_work || "",
        remaining_work: item.remaining_work || "",
        status: item.status || "pending",
        remarks: item.remarks || [],
      }));

      setFormDataStage(originalStages);
    }
    if (formData[0]?.remarks?.length > 0) {
      const originalStages = formData[0].remarks.map((item) => ({
        id: item.id || "",
        remarks_date: item.remarks_date || "",
        remarks: item.remarks || [],
      }));

      setStageRemarks(originalStages);
    } else {
      setFormDataStage([]);
      setStageRemarks([]);
    }
  };

  useEffect(() => {
    setFormData((prev) =>
      prev.map((item) => ({
        ...item,
        total_value: i.actual,
      })),
    );
  }, [i, formData[0].input_type]);

  useEffect(() => {
    const cost = i.cost;
    const workDone =
      Number(
        Number(formData[0].covered_value) / Number(formData[0].total_value),
      ) * 100;
    const pending_work = 100 - workDone;

    const about_to_bill = (workDone / 100) * cost;
    const remaining_amount = cost - about_to_bill;

    setFormData((prev) =>
      prev.map((item) => ({
        ...item,
        work_done: workDone,
        pending_work: pending_work,
        about_to_bill: about_to_bill,
        remaining_amount: remaining_amount || 0,
      })),
    );
  }, [i, formData[0].covered_value, formData[0].total_value]);

  const handleInputChange = (e, index) => {
    const { name, value, files } = e.target;

    setFormData((prev) => {
      const updated = [...prev];
      const item = { ...updated[index] };

      if (name === "document_file") {
        item[name] = files?.length ? files[0] : null;
      } else if (name === "covered_value" || name === "total_value") {
        const numericValue = Number(value) || 0;
        item[name] = numericValue;

        const total =
          name === "total_value" ? numericValue : Number(item.total_value) || 0;

        let covered =
          name === "covered_value"
            ? numericValue
            : Number(item.covered_value) || 0;

        // ✅ Prevent covered > total (Better UX: clamp)
        covered = Math.min(covered, total);
        item.covered_value = covered;

        // ✅ Remaining
        const remaining = total - covered;
        item.remaining_value = remaining;

        // ✅ Status Logic
        item.status = remaining === 0 ? "completed" : "pending";
      } else {
        item[name] = value;
      }

      updated[index] = item;
      return updated;
    });
  };

  const handleRemarkChangeNormal = (e, remarkIndex) => {
    const { name, value } = e.target;

    const updated = [...stageRemarks];
    updated[remarkIndex][name] = value;

    setStageRemarks(updated);
  };
  const handleRemarkChange = (e, stageIndex, remarkIndex) => {
    const { name, value } = e.target;

    const updated = [...formDataStage];
    updated[stageIndex].remarks[remarkIndex][name] = value;

    setFormDataStage(updated);
  };

  const truncateTo2 = (num) => {
    return (Math.floor(num * 100) / 100).toFixed(2);
  };

  const handleInputChangeStage = (e, index) => {
    const { name, value, files } = e.target;
    const totalCost = Number(i.cost) || 0;
    const updated = [...formDataStage];

    if (name === "document_file") {
      updated[index][name] = files?.[0] || null;
    } else {
      updated[index][name] = value;
    }

    // ✅ Convert to numbers safely
    const stagePercentage = Number(updated[index].stage_percentage) || 0;
    const completedPercentage =
      Number(updated[index].completed_percentage) || 0;

    // ✅ Remaining %
    updated[index].remaining_percentage =
      100 - completedPercentage >= 0 ? Number(100 - completedPercentage) : 0;

    const remainingPercentage = updated[index].remaining_percentage;

    const stageAmount = (stagePercentage / 100) * totalCost;
    const completedWork = (completedPercentage / 100) * stageAmount;

    updated[index].stage_amount = truncateTo2(stageAmount);
    updated[index].completed_work = truncateTo2(completedWork);

    updated[index].remaining_work = truncateTo2(stageAmount - completedWork);

    if (remainingPercentage === 0) {
      updated[index].status = "completed";
    } else {
      updated[index].status = "pending";
    }

    // ✅ TOTAL VALIDATION (must be 100)
    const totalStagePercent = updated.reduce(
      (sum, item) => sum + (Number(item.stage_percentage) || 0),
      0,
    );

    if (totalStagePercent > 100) {
      toast.warning("Total Stage Weightage cannot exceed 100");
      return; // ❌ stop update
    }

    setFormDataStage(updated);

    // ✅ Optional strict validation (when submitting)
    if (totalStagePercent === 100) {
      console.log("Perfect! Total is 100%");
    }
  };
  const stageInitialized = useRef(false);

  useEffect(() => {
    if (!stageInitialized.current && formData[0]?.stage?.length > 0) {
      const mappedStages = formData[0].stage.map((item) => ({
        id: item.id || "",
        stage_name: item.stage_name || "",
        stage_percentage: item.stage_percentage || "",
        stage_amount: item.stage_amount || "",
        completed_percentage: item.completed_percentage || "",
        remaining_percentage: item.remaining_percentage || "",
        completed_work: item.completed_work || "",
        remaining_work: item.remaining_work || "",
        status: item.status || "pending",
        remarks: item.remarks || [],
      }));

      setFormDataStage(mappedStages);
      stageInitialized.current = true;
    }
  }, [formData]);

  useEffect(() => {
    if (formData[0]?.input_type === "Stage type") {
      const filterpending = formDataStage.filter(
        (item) => item.status === "pending",
      );
      console.log(filterpending, "pending");
      if (filterpending.length === 0) {
        setFormData((prev) =>
          prev.map((item) => ({
            ...item,
            status: "completed",
          })),
        );
      } else if (filterpending.length > 0) {
        setFormData((prev) =>
          prev.map((item) => ({
            ...item,
            status: "pending",
          })),
        );
      }
    }
  }, [formDataStage]);

  const handleAddSubmission = () => {
    setFormData((prev) => [
      ...prev,
      {
        id: uuidv4(),
        status: "",
        input_type: "",
        total_value: "",
        covered_value: "",
        remaining_value: "",
        document_name: "",
        document_file: "",
      },
    ]);
  };
  const handleAddRemarksNormal = () => {
    setStageRemarks((prev) => [
      ...prev,
      {
        id: uuidv4(),
        remarks: "",
        remarks_date: "",
      },
    ]);
  };
  const handleAddstage = () => {
    setFormDataStage((prev) => [
      ...prev,
      {
        id: uuidv4(),
        stage_name: "",
        stage_percentage: "",
        stage_amount: "",
        completed_percentage: "",
        remaining_percentage: "",
        completed_work: "",
        remaining_work: "",
        status: "pending",
        remarks: [
          {
            id: "",
            remarks: "",
            remarks_date: "",
          },
        ],
      },
    ]);
  };
  const handleAddStageRemarks = (stageIndex) => {
    const updated = [...formDataStage];

    updated[stageIndex].remarks.push({
      remarks: "",
      remarks_date: "",
    });

    setFormDataStage(updated);
  };

  // 🔴 Remove a submission section
  const handleRemoveSubmission = async (index) => {
    const updated = [...formData];
    const removedItem = updated[index];

    // 🧠 If the removed item is a document and has an ID, handle backend deletion
    if (removedItem.input_type === "document" && removedItem.id) {
      const existingDoc = (documentData || []).find(
        (doc) => doc.input_id === removedItem.id,
      );

      const confirmDelete = window.confirm(
        `Are you sure you want to delete this document: "${removedItem.document_name || existingDoc?.name || "Unnamed Document"
        }"?`,
      );

      if (!confirmDelete) {
        toast.info("Deletion cancelled.");
        return;
      }

      if (existingDoc) {
        try {
          await axios.delete(`${BASE_URL}/dpr/document/${existingDoc.id}/`, AUTH());
          toast.success(`Document "${existingDoc.name}" deleted successfully.`);
          console.log("🗑️ Deleted document:", existingDoc);
        } catch (err) {
          console.error("❌ Error deleting document:", err);
          toast.error(`Failed to delete document: ${existingDoc.name}`);
        }
      }
    }

    // 🧹 Remove item from local formData
    updated.splice(index, 1);
    setFormData(updated);
  };
  const handleRemoveStage = async (index) => {
    const updated = [...formDataStage];
    const updatedStage = [...(formData[0]?.stage || [])];
    updated.splice(index, 1);
    updatedStage.splice(index, 1);
    setFormDataStage(updated);
    setFormData((prev) =>
      prev.map((item) => ({
        ...item,
        stage: updatedStage,
      })),
    );
  };
  const handleRemoveNormalremarks = async (index) => {
    const updated = [...stageRemarks];
    const updatedRemarks = [...(formData[0]?.remarks || [])];
    updated.splice(index, 1);
    updatedRemarks.splice(index, 1);
    setStageRemarks(updated);
    setFormData((prev) =>
      prev.map((item) => ({
        ...item,
        remarks: updatedRemarks,
      })),
    );
  };
  const handleRemoveStageRemarks = (index, remarkIndex) => {
    const updated = [...formDataStage]; // ✅ correct state

    if (!updated[index] || !Array.isArray(updated[index].remarks)) return;

    updated[index] = {
      ...updated[index],
      remarks: updated[index].remarks.filter((_, i) => i !== remarkIndex),
    };

    setFormDataStage(updated); // ✅ correct setter
  };

  const validateform = () => {
    const newErrors = {};

    // ✅ Normal Input Validation
    formData.forEach((item, idx) => {
      if (!item.status?.trim()) {
        newErrors[`status_${idx}`] = "Status is required!";
      }

      if (!item.input_type?.trim()) {
        newErrors[`input_type_${idx}`] = "Input type is required!";
      }

      if (item.input_type === "Normal Input") {
        if (!item.total_value) {
          newErrors[`total_value_${idx}`] = "Total value is required!";
        } else if (isNaN(item.total_value)) {
          newErrors[`total_value_${idx}`] = "Total value must be a number!";
        }

        if (!item.covered_value && item.input_type === "Normal Input") {
          newErrors[`covered_value_${idx}`] = "Covered value is required!";
        } else if (isNaN(item.covered_value)) {
          newErrors[`covered_value_${idx}`] = "Covered value must be a number!";
        }
      }
    });

    // ✅ ⭐ Stage Validation (NEW)
    if (formDataStage?.length) {
      let totalStagePercent = 0;

      formDataStage.forEach((stage, idx) => {
        if (
          !stage.stage_name?.trim() &&
          formData[0]?.input_type === "Stage type"
        ) {
          newErrors[`stage_name_${idx}`] = "Stage name is required!";
        }

        if (
          Number(stage.completed_percentage) > 100 &&
          formData[0]?.input_type === "Stage type"
        ) {
          newErrors[`completed_percentage_${idx}`] =
            "Completed % cannot exceed Stage 100%";
        }

        if (
          !stage.stage_percentage &&
          formData[0]?.input_type === "Stage type"
        ) {
          newErrors[`stage_percentage_${idx}`] = "Stage % is required!";
        } else if (
          isNaN(stage.stage_percentage) &&
          formData[0]?.input_type === "Stage type"
        ) {
          newErrors[`stage_percentage_${idx}`] = "Must be a number!";
        }

        if (
          !stage.completed_percentage &&
          stage.completed_percentage !== 0 &&
          formData[0]?.input_type === "Stage type"
        ) {
          newErrors[`completed_percentage_${idx}`] = "Completed % is required!";
        } else if (
          isNaN(stage.completed_percentage) &&
          formData[0]?.input_type === "Stage type"
        ) {
          newErrors[`completed_percentage_${idx}`] = "Must be a number!";
        }

        totalStagePercent += Number(stage.stage_percentage) || 0;
      });

      // ⭐ MOST IMPORTANT VALIDATION
      if (
        totalStagePercent !== 100 &&
        formData[0]?.input_type === "Stage type"
      ) {
        newErrors["stage_total"] = "Total Stage Weightage must be exactly 100%";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const handleFormSubmitt = async (e) => {
    e.preventDefault();
if (!validateform()) return;
  if (submitting) return;
  setSubmitting(true);
    const loadingToastId = toast.loading("Submitting Data... Please wait...");

    try {
      const updatedData = { ...allData };
const withIds = formData.map((it) => ({ ...it, id: it.id || uuidv4() }));
      // 🟢 1️⃣ Update workstat -> normal_input
      // if (
      //     updatedData?.workstat &&
      //     Array.isArray(updatedData.workstat)
      // ) {
      //     const target = updatedData.workstat.find(
      //         (w) => w.id === id
      //     );

      //     console.log(target, "targetttt")

      //     if (target) {

      //         target.normal_input = formData.map((item) => ({
      //             id: item.id || uuidv4(),
      //             status: item.status || "",
      //             input_type: item.input_type || "",
      //             total_value: item.total_value || "",
      //             covered_value: item.covered_value || "",
      //             remaining_value: item.remaining_value || "",
      //             document_name: item.document_name || "",
      //             stage: [],

      //         }));

      //     } else {
      //         console.warn(`Workstat detail not found for ID: ${id}`);
      //     }
      // }

      if (updatedData?.workstat && Array.isArray(updatedData.workstat)) {
        const target = updatedData.workstat.find((w) => w.id === id);


        if (target) {
          // ✅ Map stages once
          const mappedStagesRemarks = stageRemarks.map((remarks) => ({
            id: remarks.id || uuidv4(),
            remarks_date: remarks.remarks_date || null,
            remarks: remarks.remarks || "",
          }));
          const mappedStages = formDataStage.map((stageItem) => ({
            id: stageItem.id || uuidv4(),
            status: stageItem.status || "pending",
            stage_name: stageItem.stage_name || "",
            stage_percentage: stageItem.stage_percentage || "",
            stage_amount: stageItem.stage_amount || "",
            completed_percentage: stageItem.completed_percentage || "",
            remaining_percentage: stageItem.remaining_percentage || "",
            completed_work: stageItem.completed_work || "",
            remaining_work: stageItem.remaining_work || "",
            remarks: stageItem.remarks || [],
          }));

          target.normal_input = withIds.map((item) => ({
            id: item.id,
            status: item.status || "",
            input_type: item.input_type || "",
            total_value: item.total_value || "",
            covered_value: item.covered_value || "",
            remaining_value: item.remaining_value || "",
            about_to_bill: item.about_to_bill || "",
            remaining_amount: item.remaining_amount || "",
            work_done: item.work_done || "",
            pending_work: item.pending_work || "",
            document_name: item.document_name || "",
            cost: target.cost || "",
            scope: target.scope || "",
            remarks: mappedStagesRemarks || [],
            actual: target.actual || "",
            // ✅ Add stage only for Stage type
            stage: item.input_type === "Stage type" ? mappedStages : [],
          }));
        } else {
          console.warn(`Workstat detail not found for ID: ${id}`);
        }
      }

      const payload = {
        workstat: updatedData.workstat,
      };
      // 🟢 3️⃣ Update project data
      const res = await axios.put(
        `${BASE_URL}/dpr/project/${project}/`,
        payload,
        AUTH()
      );

      if (res.status === 200 || res.status === 201) {
        toast.success("Data updated successfully!");

        // 🟢 4️⃣ Handle document uploads/updates (only for input_type === "document")
        // sirf wahi docs jinki nayi File select hui hai
        const documentEntries = withIds.filter(
          (item) =>
            item.input_type === "document" && item.document_file instanceof File,
        );

        if (documentEntries.length) {
          const filesToConfirm = [];

          // API 1 (chunks) + API 2 (complete)
          for (const doc of documentEntries) {
            try {
              const uploaded = await uploadDocumentChunked(doc.document_file, (pct) =>
                toast.update(loadingToastId, {
                  render: `Uploading ${doc.document_name || doc.document_file.name}… ${pct}%`,
                }),
              );

              filesToConfirm.push({
                file_id: uploaded.file_id,
                section_id: id, // workstat/section id, agar alag ho to yahan badlo
                file_path: uploaded.file_path,
                document_name: doc.document_name || doc.document_file.name,
                original_filename: doc.document_file.name,
                input_id: doc.id,
              });
            } catch (err) {
              console.error("❌ Document upload failed:", err);
              toast.error(`Failed for document: ${doc.document_name}`);
            }
          }

          // API 3 — confirm
          if (filesToConfirm.length > 0) {
            try {
              await confirmUploads(project, filesToConfirm);
            } catch (err) {
              console.error("❌ Confirm upload failed:", err);
              toast.error("Documents confirm nahi ho paye, please retry.");
            }
          }
        }

        // 🟢 5️⃣ Refresh and close modal
        getProject();
        if (typeof getDocuments === "function") getDocuments();
        setShow(false);
      } else {
        toast.error("Update failed, please try again.");
      }
    } catch (err) {
      console.error("❌ Error updating project:", err);
      toast.error("Something went wrong while updating submission");
    } finally {
  toast.dismiss(loadingToastId);
  setSubmitting(false);
}
  };



  return (
    <>
      <button
        title="Add Data"
        onClick={handleShow}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "5px",
          padding: "5px 12px",
          borderRadius: "5px",
          border: "0.5px solid #2576bc",
          background: "#fff",
          color: "#2576bc",
          fontSize: "12px",
          fontWeight: 500,
          cursor: "pointer",
        }}
      >
        + Data
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave"
        size="lg"
      >
        <Modal.Header
          closeButton
          className="justify-center task-Tab-heading font-weight500 font-size-heading"
        >
          <Modal.Title>Add / Edit {i.name} Details</Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ padding: "16px 20px", overflowX: "hidden" }}>
          <form onSubmit={handleFormSubmitt}>
            {formData.map((item, index) => (
              <div
                key={item.id || index}
                style={{
                  border: "0.5px solid #e0e0e0",
                  borderRadius: "6px",
                  marginBottom: "12px",
                  background: "#fff",
                  overflow: "hidden",
                }}
              >
                {/* Header */}
                <div
                  style={{
                    padding: "10px 14px",
                    background: "#f5f7fa",
                    borderBottom: "0.5px solid #e0e0e0",
                  }}
                >
                  <span style={{ fontSize: "13px", fontWeight: 600, color: "#1e293b" }}>
                    Entry {index + 1}
                  </span>
                </div>

                {/* Body */}
                <div style={{ padding: "14px 16px" }}>

                  {/* Input Type */}
                  <div style={{ marginBottom: "12px" }}>
                    <label
                      style={{
                        fontSize: "12px",
                        fontWeight: 500,
                        color: "#374151",
                        display: "block",
                        marginBottom: "6px",
                      }}
                    >
                      Input Type <span style={{ color: "#dc2626" }}>*</span>
                    </label>
                    <select
                      name="input_type"
                      value={item.input_type}
                      onChange={(e) => handleInputChange(e, index)}
                      style={{
                        width: "100%",
                        padding: "8px 5px",
                        border: errors[`input_type_${index}`]
                          ? "1px solid #dc2626"
                          : "0.5px solid #e0e0e0",
                        borderRadius: "5px",
                        fontSize: "13px",
                        color: "#1e293b",
                        background: "#f9fafb",
                        outline: "none",
                        boxSizing: "border-box",
                        cursor: "pointer",
                      }}
                    >
                      <option value="">Select Type</option>
                      <option value="Normal Input">Normal Input</option>
                      <option value="document">Document</option>
                      <option value="Stage type">Stage type</option>
                    </select>
                    {errors[`input_type_${index}`] && (
                      <span
                        style={{
                          display: "block",
                          marginTop: "4px",
                          fontSize: "11px",
                          color: "#dc2626",
                        }}
                      >
                        {errors[`input_type_${index}`]}
                      </span>
                    )}
                  </div>

                  {/* Status */}
                  <div style={{ marginBottom: "14px" }}>
                    <label
                      style={{
                        fontSize: "12px",
                        fontWeight: 500,
                        color: "#374151",
                        display: "block",
                        marginBottom: "6px",
                      }}
                    >
                      Status{" "}
                      {item.input_type === "document" ? (
                        <span style={{ color: "#dc2626" }}>*</span>
                      ) : (
                        <span style={{ color: "#dc2626" }}>(Read-Only)</span>
                      )}
                    </label>
                    <select
                      name="status"
                      value={item.status}
                      disabled={item.input_type !== "document"}
                      onChange={(e) => handleInputChange(e, index)}
                      style={{
                        width: "100%",
                        padding: "8px 5px",
                        border: errors[`status_${index}`]
                          ? "1px solid #dc2626"
                          : "0.5px solid #e0e0e0",
                        borderRadius: "5px",
                        fontSize: "13px",
                        color: "#1e293b",
                        background: item.input_type !== "document" ? "#f1f5f9" : "#f9fafb",
                        outline: "none",
                        boxSizing: "border-box",
                        cursor: item.input_type !== "document" ? "not-allowed" : "pointer",
                      }}
                    >
                      <option value="">Select Status</option>
                      <option value="pending">Pending</option>
                      <option value="completed">Completed</option>
                    </select>
                    {errors[`status_${index}`] && (
                      <span
                        style={{
                          display: "block",
                          marginTop: "4px",
                          fontSize: "11px",
                          color: "#dc2626",
                        }}
                      >
                        {errors[`status_${index}`]}
                      </span>
                    )}
                  </div>

                  {/* Normal Input Fields */}
                  {item.input_type === "Normal Input" && (
                    <>
                      {/* Total Value */}
                      <div style={{ marginBottom: "12px" }}>
                        <label
                          style={{
                            fontSize: "12px",
                            fontWeight: 500,
                            color: "#374151",
                            display: "block",
                            marginBottom: "6px",
                          }}
                        >
                          Total Value <span style={{ color: "#dc2626" }}>*</span>
                        </label>
                        <input
                          type="text"
                          name="total_value"
                          value={item.total_value}
                          onChange={(e) => handleInputChange(e, index)}
                          onFocus={(e) => {
                            if (String(item.covered_value) === "0") {
                              handleInputChange({ target: { name: "covered_value", value: "" } }, index);
                            }
                          }}
                          placeholder="Enter total value"
                          style={{
                            width: "100%",
                            padding: "8px 5px",
                            border: errors[`total_value_${index}`]
                              ? "1px solid #dc2626"
                              : "0.5px solid #e0e0e0",
                            borderRadius: "5px",
                            fontSize: "13px",
                            color: "#1e293b",
                            background: "#f9fafb",
                            outline: "none",
                            boxSizing: "border-box",
                          }}
                        />
                        {errors[`total_value_${index}`] && (
                          <span
                            style={{
                              display: "block",
                              marginTop: "4px",
                              fontSize: "11px",
                              color: "#dc2626",
                            }}
                          >
                            {errors[`total_value_${index}`]}
                          </span>
                        )}
                      </div>

                      {/* Covered Value */}
                      <div style={{ marginBottom: "12px" }}>
                        <label
                          style={{
                            fontSize: "12px",
                            fontWeight: 500,
                            color: "#374151",
                            display: "block",
                            marginBottom: "6px",
                          }}
                        >
                          Covered Value <span style={{ color: "#dc2626" }}>*</span>
                        </label>
                        <input
                          type="text"
                          name="covered_value"
                          value={item.covered_value}
                          onChange={(e) => handleInputChange(e, index)}
                          onFocus={(e) => {
                            if (String(item.covered_value) === "0") {
                              handleInputChange({ target: { name: "covered_value", value: "" } }, index);
                            }
                          }}
                          placeholder="Enter covered value"
                          style={{
                            width: "100%",
                            padding: "8px 5px",
                            border: errors[`covered_value_${index}`]
                              ? "1px solid #dc2626"
                              : "0.5px solid #e0e0e0",
                            borderRadius: "5px",
                            fontSize: "13px",
                            color: "#1e293b",
                            background: "#f9fafb",
                            outline: "none",
                            boxSizing: "border-box",
                          }}
                        />
                        {errors[`covered_value_${index}`] && (
                          <span
                            style={{
                              display: "block",
                              marginTop: "4px",
                              fontSize: "11px",
                              color: "#dc2626",
                            }}
                          >
                            {errors[`covered_value_${index}`]}
                          </span>
                        )}
                      </div>

                      {/* Remaining Value */}
                      <div style={{ marginBottom: "14px" }}>
                        <label
                          style={{
                            fontSize: "12px",
                            fontWeight: 500,
                            color: "#374151",
                            display: "block",
                            marginBottom: "6px",
                          }}
                        >
                          Remaining Value <span style={{ color: "#dc2626" }}>*</span>
                        </label>
                        <input
                          type="text"
                          name="remaining_value"
                          value={item.remaining_value}
                          onChange={(e) => handleInputChange(e, index)}
                          onFocus={(e) => {
                            if (String(item.remaining_value) === "0") {
                              handleInputChange({ target: { name: "remaining_value", value: "" } }, index);
                            }
                          }}
                          placeholder="Enter remaining value"
                          style={{
                            width: "100%",
                            padding: "8px 5px",
                            border: errors[`remaining_value_${index}`]
                              ? "1px solid #dc2626"
                              : "0.5px solid #e0e0e0",
                            borderRadius: "5px",
                            fontSize: "13px",
                            color: "#1e293b",
                            background: "#f9fafb",
                            outline: "none",
                            boxSizing: "border-box",
                          }}
                        />
                        {errors[`remaining_value_${index}`] && (
                          <span
                            style={{
                              display: "block",
                              marginTop: "4px",
                              fontSize: "11px",
                              color: "#dc2626",
                            }}
                          >
                            {errors[`remaining_value_${index}`]}
                          </span>
                        )}
                      </div>

                      {/* Normal Remarks */}
                      {stageRemarks.map((remarkItem, remarkIndex) => (
                        <div
                          key={remarkItem.id || remarkIndex}
                          style={{
                            border: "0.5px solid #e0e0e0",
                            borderRadius: "6px",
                            marginBottom: "10px",
                            background: "#fff",
                            overflow: "hidden",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              padding: "8px 12px",
                              background: "#f5f7fa",
                              borderBottom: "0.5px solid #e0e0e0",
                            }}
                          >
                            <span style={{ fontSize: "12px", fontWeight: 600, color: "#1e293b" }}>
                              Remark {remarkIndex + 1}
                            </span>
                            {stageRemarks.length > 1 && (
                              <button
                                type="button"
                                onClick={() => handleRemoveNormalremarks(remarkIndex)}
                                style={{
                                  fontSize: "11px",
                                  fontWeight: 500,
                                  color: "#dc2626",
                                  background: "#fee2e2",
                                  border: "none",
                                  borderRadius: "4px",
                                  padding: "3px 10px",
                                  cursor: "pointer",
                                }}
                              >
                                Remove
                              </button>
                            )}
                          </div>
                          <div style={{ padding: "12px 14px" }}>
                            <div style={{ marginBottom: "12px" }}>
                              <label
                                style={{
                                  fontSize: "12px",
                                  fontWeight: 500,
                                  color: "#374151",
                                  display: "block",
                                  marginBottom: "6px",
                                }}
                              >
                                Remarks
                              </label>
                              <textarea
                                name="remarks"
                                value={remarkItem.remarks}
                                onChange={(e) => handleRemarkChangeNormal(e, remarkIndex)}
                                placeholder="Enter remark"
                                style={{
                                  width: "100%",
                                  padding: "8px 5px",
                                  border: "0.5px solid #e0e0e0",
                                  borderRadius: "5px",
                                  fontSize: "13px",
                                  color: "#1e293b",
                                  background: "#f9fafb",
                                  outline: "none",
                                  boxSizing: "border-box",
                                  resize: "vertical",
                                  minHeight: "72px",
                                }}
                              />
                            </div>
                            <div>
                              <label
                                style={{
                                  fontSize: "12px",
                                  fontWeight: 500,
                                  color: "#374151",
                                  display: "block",
                                  marginBottom: "6px",
                                }}
                              >
                                Remark Date
                              </label>
                              <input
                                type="date"
                                name="remarks_date"
                                value={remarkItem.remarks_date}

                                onChange={(e) => handleRemarkChangeNormal(e, remarkIndex)}
                                style={{
                                  width: "100%",
                                  padding: "8px 5px",
                                  border: "0.5px solid #e0e0e0",
                                  borderRadius: "5px",
                                  fontSize: "13px",
                                  color: "#1e293b",
                                  background: "#f9fafb",
                                  outline: "none",
                                  boxSizing: "border-box",
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      ))}

                      <div style={{ textAlign: "center", marginBottom: "8px" }}>
                        <button
                          type="button"
                          onClick={() => handleAddRemarksNormal(index)}
                          style={{
                            padding: "6px 16px",
                            borderRadius: "5px",
                            border: "0.5px solid #2576bc",
                            background: "#fff",
                            color: "#2576bc",
                            fontSize: "12px",
                            fontWeight: 500,
                            cursor: "pointer",
                          }}
                        >
                          + Add More Remarks
                        </button>
                      </div>
                    </>
                  )}

                  {/* Stage Type Fields */}
                  {item.input_type === "Stage type" && (
                    <>
                      {formDataStage.map((stageItem, stageIndex) => (
                        <div
                          key={stageItem.id || stageIndex}
                          style={{
                            border: "0.5px solid #e0e0e0",
                            borderRadius: "6px",
                            marginBottom: "10px",
                            background: "#fff",
                            overflow: "hidden",
                          }}
                        >
                          {/* Stage Sub-header */}
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              padding: "8px 12px",
                              background: "#f5f7fa",
                              borderBottom: "0.5px solid #e0e0e0",
                            }}
                          >
                            <span style={{ fontSize: "12px", fontWeight: 600, color: "#1e293b" }}>
                              Stage {stageIndex + 1}
                            </span>
                            {formDataStage.length > 1 && (
                              <button
                                type="button"
                                onClick={() => handleRemoveStage(stageIndex)}
                                style={{
                                  fontSize: "11px",
                                  fontWeight: 500,
                                  color: "#dc2626",
                                  background: "#fee2e2",
                                  border: "none",
                                  borderRadius: "4px",
                                  padding: "3px 10px",
                                  cursor: "pointer",
                                }}
                              >
                                Remove
                              </button>
                            )}
                          </div>

                          <div style={{ padding: "12px 14px" }}>
                            {/* Stage Name */}
                            <div style={{ marginBottom: "12px" }}>
                              <label
                                style={{
                                  fontSize: "12px",
                                  fontWeight: 500,
                                  color: "#374151",
                                  display: "block",
                                  marginBottom: "6px",
                                }}
                              >
                                Stage Name <span style={{ color: "#dc2626" }}>*</span>
                              </label>
                              <input
                                type="text"
                                name="stage_name"
                                value={stageItem.stage_name}
                                onChange={(e) => handleInputChangeStage(e, stageIndex)}
                                onFocus={(e) => {
                                  if (String(stageItem.stage_amount) === "0") {
                                    handleInputChangeStage({ target: { name: "stage_amount", value: "" } }, stageIndex);
                                  }
                                }}
                                placeholder="Enter stage name"
                                style={{
                                  width: "100%",
                                  padding: "8px 5px",
                                  border: errors[`stage_name_${stageIndex}`]
                                    ? "1px solid #dc2626"
                                    : "0.5px solid #e0e0e0",
                                  borderRadius: "5px",
                                  fontSize: "13px",
                                  color: "#1e293b",
                                  background: "#f9fafb",
                                  outline: "none",
                                  boxSizing: "border-box",
                                }}
                              />
                              {errors[`stage_name_${stageIndex}`] && (
                                <span
                                  style={{
                                    display: "block",
                                    marginTop: "4px",
                                    fontSize: "11px",
                                    color: "#dc2626",
                                  }}
                                >
                                  {errors[`stage_name_${stageIndex}`]}
                                </span>
                              )}
                            </div>

                            {/* Stage Weightage */}
                            <div style={{ marginBottom: "12px" }}>
                              <label
                                style={{
                                  fontSize: "12px",
                                  fontWeight: 500,
                                  color: "#374151",
                                  display: "block",
                                  marginBottom: "6px",
                                }}
                              >
                                Stage Weightage <span style={{ color: "#dc2626" }}>*</span>
                              </label>
                              <input
                                type="number"
                                name="stage_percentage"
                                value={stageItem.stage_percentage}
                                onChange={(e) => handleInputChangeStage(e, stageIndex)}
                                onFocus={(e) => {
                                  if (String(item.covered_value) === "0") {
                                    handleInputChange({ target: { name: "covered_value", value: "" } }, index);
                                  }
                                }}
                                placeholder="Enter Work Percentage"
                                style={{
                                  width: "100%",
                                  padding: "8px 5px",
                                  border: errors[`stage_percentage_${stageIndex}`]
                                    ? "1px solid #dc2626"
                                    : "0.5px solid #e0e0e0",
                                  borderRadius: "5px",
                                  fontSize: "13px",
                                  color: "#1e293b",
                                  background: "#f9fafb",
                                  outline: "none",
                                  boxSizing: "border-box",
                                }}
                              />
                              {errors[`stage_percentage_${stageIndex}`] && (
                                <span
                                  style={{
                                    display: "block",
                                    marginTop: "4px",
                                    fontSize: "11px",
                                    color: "#dc2626",
                                  }}
                                >
                                  {errors[`stage_percentage_${stageIndex}`]}
                                </span>
                              )}
                            </div>

                            {/* Work Completed % */}
                            <div style={{ marginBottom: "12px" }}>
                              <label
                                style={{
                                  fontSize: "12px",
                                  fontWeight: 500,
                                  color: "#374151",
                                  display: "block",
                                  marginBottom: "6px",
                                }}
                              >
                                Work Completed Percentage <span style={{ color: "#dc2626" }}>*</span>
                              </label>
                              <input
                                type="number"
                                name="completed_percentage"
                                value={stageItem.completed_percentage}
                                onChange={(e) => handleInputChangeStage(e, stageIndex)}
                                onFocus={(e) => {
                                  if (String(item.covered_value) === "0") {
                                    handleInputChange({ target: { name: "covered_value", value: "" } }, index);
                                  }
                                }}
                                placeholder="Enter Work Completed %"
                                style={{
                                  width: "100%",
                                  padding: "8px 5px",
                                  border: errors[`completed_percentage_${stageIndex}`]
                                    ? "1px solid #dc2626"
                                    : "0.5px solid #e0e0e0",
                                  borderRadius: "5px",
                                  fontSize: "13px",
                                  color: "#1e293b",
                                  background: "#f9fafb",
                                  outline: "none",
                                  boxSizing: "border-box",
                                }}
                              />
                              {errors[`completed_percentage_${stageIndex}`] && (
                                <span
                                  style={{
                                    display: "block",
                                    marginTop: "4px",
                                    fontSize: "11px",
                                    color: "#dc2626",
                                  }}
                                >
                                  {errors[`completed_percentage_${stageIndex}`]}
                                </span>
                              )}
                            </div>

                            {/* Work Remaining % */}
                            <div style={{ marginBottom: "12px" }}>
                              <label
                                style={{
                                  fontSize: "12px",
                                  fontWeight: 500,
                                  color: "#374151",
                                  display: "block",
                                  marginBottom: "6px",
                                }}
                              >
                                Work Remaining Percentage <span style={{ color: "#dc2626" }}>*</span>
                              </label>
                              <input
                                type="number"
                                name="remaining_percentage"
                                value={stageItem.remaining_percentage}
                                onChange={(e) => handleInputChangeStage(e, stageIndex)}
                                placeholder="Enter Work Remaining %"
                                style={{
                                  width: "100%",
                                  padding: "8px 5px",
                                  border: errors[`remaining_percentage_${stageIndex}`]
                                    ? "1px solid #dc2626"
                                    : "0.5px solid #e0e0e0",
                                  borderRadius: "5px",
                                  fontSize: "13px",
                                  color: "#1e293b",
                                  background: "#f9fafb",
                                  outline: "none",
                                  boxSizing: "border-box",
                                }}
                              />
                              {errors[`remaining_percentage_${stageIndex}`] && (
                                <span
                                  style={{
                                    display: "block",
                                    marginTop: "4px",
                                    fontSize: "11px",
                                    color: "#dc2626",
                                  }}
                                >
                                  {errors[`remaining_percentage_${stageIndex}`]}
                                </span>
                              )}
                            </div>

                            {/* Work Cost */}
                            <div style={{ marginBottom: "14px" }}>
                              <label
                                style={{
                                  fontSize: "12px",
                                  fontWeight: 500,
                                  color: "#374151",
                                  display: "block",
                                  marginBottom: "6px",
                                }}
                              >
                                Work Cost <span style={{ color: "#dc2626" }}>*</span>
                              </label>
                              <input
                                type="number"
                                name="stage_amount"
                                value={stageItem.stage_amount}
                                onChange={(e) => handleInputChangeStage(e, stageIndex)}
                                onFocus={(e) => {
                                  if (String(stageItem.stage_amount) === "0") {
                                    handleInputChangeStage({ target: { name: "stage_amount", value: "" } }, stageIndex);
                                  }
                                }}
                                placeholder="Enter Work Cost"
                                style={{
                                  width: "100%",
                                  padding: "8px 5px",
                                  border: errors[`stage_amount_${stageIndex}`]
                                    ? "1px solid #dc2626"
                                    : "0.5px solid #e0e0e0",
                                  borderRadius: "5px",
                                  fontSize: "13px",
                                  color: "#1e293b",
                                  background: "#f9fafb",
                                  outline: "none",
                                  boxSizing: "border-box",
                                }}
                              />
                              {errors[`stage_amount_${stageIndex}`] && (
                                <span
                                  style={{
                                    display: "block",
                                    marginTop: "4px",
                                    fontSize: "11px",
                                    color: "#dc2626",
                                  }}
                                >
                                  {errors[`stage_amount_${stageIndex}`]}
                                </span>
                              )}
                            </div>

                            {/* Stage Remarks */}
                            {stageItem.remarks.map((remarkItem, remarkIndex) => (
                              <div
                                key={remarkItem.id || remarkIndex}
                                style={{
                                  border: "0.5px solid #e0e0e0",
                                  borderRadius: "6px",
                                  marginBottom: "10px",
                                  background: "#fff",
                                  overflow: "hidden",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    padding: "8px 12px",
                                    background: "#f5f7fa",
                                    borderBottom: "0.5px solid #e0e0e0",
                                  }}
                                >
                                  <span style={{ fontSize: "12px", fontWeight: 600, color: "#1e293b" }}>
                                    Remark {remarkIndex + 1}
                                  </span>
                                  {stageItem.remarks.length > 1 && (
                                    <button
                                      type="button"
                                      onClick={() => handleRemoveStageRemarks(stageIndex, remarkIndex)}
                                      style={{
                                        fontSize: "11px",
                                        fontWeight: 500,
                                        color: "#dc2626",
                                        background: "#fee2e2",
                                        border: "none",
                                        borderRadius: "4px",
                                        padding: "3px 10px",
                                        cursor: "pointer",
                                      }}
                                    >
                                      Remove
                                    </button>
                                  )}
                                </div>
                                <div style={{ padding: "12px 14px" }}>
                                  <div style={{ marginBottom: "12px" }}>
                                    <label
                                      style={{
                                        fontSize: "12px",
                                        fontWeight: 500,
                                        color: "#374151",
                                        display: "block",
                                        marginBottom: "6px",
                                      }}
                                    >
                                      Remarks
                                    </label>
                                    <textarea
                                      name="remarks"
                                      value={remarkItem.remarks}
                                      onChange={(e) => handleRemarkChange(e, stageIndex, remarkIndex)}
                                      placeholder="Enter remark"
                                      style={{
                                        width: "100%",
                                        padding: "8px 5px",
                                        border: "0.5px solid #e0e0e0",
                                        borderRadius: "5px",
                                        fontSize: "13px",
                                        color: "#1e293b",
                                        background: "#f9fafb",
                                        outline: "none",
                                        boxSizing: "border-box",
                                        resize: "vertical",
                                        minHeight: "72px",
                                      }}
                                    />
                                  </div>
                                  <div>
                                    <label
                                      style={{
                                        fontSize: "12px",
                                        fontWeight: 500,
                                        color: "#374151",
                                        display: "block",
                                        marginBottom: "6px",
                                      }}
                                    >
                                      Remark Date
                                    </label>
                                    <input
                                      type="date"
                                      name="remarks_date"
                                      value={remarkItem.remarks_date}
                                      onChange={(e) => handleRemarkChange(e, stageIndex, remarkIndex)}
                                      style={{
                                        width: "100%",
                                        padding: "8px 5px",
                                        border: "0.5px solid #e0e0e0",
                                        borderRadius: "5px",
                                        fontSize: "13px",
                                        color: "#1e293b",
                                        background: "#f9fafb",
                                        outline: "none",
                                        boxSizing: "border-box",
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            ))}

                            <div style={{ textAlign: "center", marginBottom: "8px" }}>
                              <button
                                type="button"
                                onClick={() => handleAddStageRemarks(stageIndex)}
                                style={{
                                  padding: "6px 16px",
                                  borderRadius: "5px",
                                  border: "0.5px solid #2576bc",
                                  background: "#fff",
                                  color: "#2576bc",
                                  fontSize: "12px",
                                  fontWeight: 500,
                                  cursor: "pointer",
                                }}
                              >
                                + Add More Remarks
                              </button>
                            </div>
                          </div>
                        </div>
                      ))}

                      <div style={{ textAlign: "center", marginBottom: "8px" }}>
                        <button
                          type="button"
                          onClick={handleAddstage}
                          style={{
                            padding: "6px 16px",
                            borderRadius: "5px",
                            border: "0.5px solid #2576bc",
                            background: "#fff",
                            color: "#2576bc",
                            fontSize: "12px",
                            fontWeight: 500,
                            cursor: "pointer",
                          }}
                        >
                          + Add Stage
                        </button>
                      </div>
                    </>
                  )}

                  {/* Document Fields */}
                  {item.input_type === "document" && (
                    <>
                      <div style={{ marginBottom: "12px" }}>
                        <label
                          style={{
                            fontSize: "12px",
                            fontWeight: 500,
                            color: "#374151",
                            display: "block",
                            marginBottom: "6px",
                          }}
                        >
                          Document Name
                        </label>
                        <input
                          name="document_name"
                          value={item.document_name}
                          onChange={(e) => handleInputChange(e, index)}
                          placeholder="Enter document name"
                          style={{
                            width: "100%",
                            padding: "8px 5px",
                            border: "0.5px solid #e0e0e0",
                            borderRadius: "5px",
                            fontSize: "13px",
                            color: "#1e293b",
                            background: "#f9fafb",
                            outline: "none",
                            boxSizing: "border-box",
                          }}
                        />
                      </div>
                      <div>
                        <label
                          style={{
                            fontSize: "12px",
                            fontWeight: 500,
                            color: "#374151",
                            display: "block",
                            marginBottom: "6px",
                          }}
                        >
                          Upload Document
                        </label>
                        <input
                          type="file"
                          name="document_file"
                          onChange={(e) => handleInputChange(e, index)}
                          style={{
                            width: "100%",
                            padding: "8px 5px",
                            border: "0.5px solid #e0e0e0",
                            borderRadius: "5px",
                            fontSize: "13px",
                            color: "#1e293b",
                            background: "#f9fafb",
                            outline: "none",
                            boxSizing: "border-box",
                          }}
                        />
                      </div>
                    </>
                  )}
                </div>
              </div>
            ))}

            {/* Footer */}
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
                paddingTop: "12px",
                borderTop: "0.5px solid #e0e0e0",
              }}
            >
              <button
                type="button"
                onClick={handleClose}
                style={{
                  padding: "7px 18px",
                  borderRadius: "5px",
                  border: "0.5px solid #e0e0e0",
                  background: "#fff",
                  color: "#64748b",
                  fontSize: "12px",
                  fontWeight: 500,
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>
              <button
                type="submit"
  disabled={submitting}
                style={{
                  padding: "7px 18px",
                  borderRadius: "5px",
                  border: "none",
                  background: "#2576bc",
                  color: "#fff",
                  fontSize: "12px",
                  fontWeight: 500,
                  cursor: "pointer",
                opacity: submitting ? 0.6 : 1, cursor: submitting ? "not-allowed" : "pointer" }}
>
  {submitting ? "Saving..." : "Update"}
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

const AddStagesData = ({
  i,
  getProject,
  project,
  allData,
  id,
  documentData,
  getDocuments,
}) => {
  const [errors, setErrors] = useState({});
  const [show, setShow] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [formData, setFormData] = useState([
    {
      id: "",
      stage_name: "",
      percentage: "",
      stage_amount: "",
      completed_percentage: "",
      remaining_percentage: "",
      completed_work: "",
      remaining_work: "",
      status: "pending",

      remarks: [
        {
          id: "",
          remarks: "",
          remarks_date: "",
        },
      ],
      document_name: "",
      document_file: "",
    },
  ]);

  const [formData2, setFormData2] = useState();

  const handleShow = () => {
    if (allData?.workstat && Array.isArray(allData.workstat)) {
      const target = allData.workstat.find((w) => w.id === id);

      if (target && target.stage?.length > 0) {
        setFormData(
          target.stage.map((item) => ({
            id: item.id || "",
            status: item.status || "",
            stage_name: item.stage_name || "",
            percentage: item.percentage || "",
            remarks_type: item.remarks_type || "",
            stage_amount: item.stage_amount || "",
            completed_percentage: item.completed_percentage || "",
            remaining_percentage: item.remaining_percentage || "",
            completed_work: item.completed_work || "",
            remaining_work: item.remaining_work || "",

            remarks: item.remarks || [],
            document_name: item.document_name || "",
          })),
        );
      } else {
        setFormData([
          {
            id: "",
            stage_name: "",
            percentage: "",
            stage_amount: "",
            completed_percentage: "",
            remaining_percentage: "",
            completed_work: "",
            remaining_work: "",
            status: "pending",
            remarks: [
              {
                id: "",
                remarks: "",
                remarks_date: "",
              },
            ],
            document_name: "",
            document_file: "",
          },
        ]);
      }
    }
    setFormData2(allData);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setErrors({});
  };

  const truncateTo2 = (num) => {
    return (Math.floor(num * 100) / 100).toFixed(2);
  };

  const handleRemarkChange = (e, index, remarkIndex) => {
    const { name, value } = e.target;

    const updated = [...formData];
    updated[index].remarks[remarkIndex][name] = value;

    setFormData(updated);
  };

  const handleRemoveStageRemarks = (index, remarkIndex) => {
    const updated = [...formData]; // or formDataStage

    if (!updated[index] || !Array.isArray(updated[index].remarks)) return;

    updated[index] = {
      ...updated[index],
      remarks: updated[index].remarks.filter((_, i) => i !== remarkIndex),
    };

    setFormData(updated); // or setFormDataStage
  };

  const handleInputChange = (e, index) => {
    const { name, value, files } = e.target;
    const totalCost = Number(i.cost) || 0;
    const updated = [...formData];

    if (name === "document_file") {
      updated[index][name] = files?.[0] || null;
    } else {
      updated[index][name] = value;
    }

    // ✅ Convert to numbers safely
    const stagePercentage = Number(updated[index].percentage) || 0;
    const completedPercentage =
      Number(updated[index].completed_percentage) || 0;

    // ✅ Remaining %
    updated[index].remaining_percentage =
      100 - completedPercentage >= 0 ? Number(100 - completedPercentage) : 0;

    const remainingPercentage = updated[index].remaining_percentage;

    const stageAmount = (stagePercentage / 100) * totalCost;
    const completedWork = (completedPercentage / 100) * stageAmount;

    updated[index].stage_amount = truncateTo2(stageAmount);
    updated[index].completed_work = truncateTo2(completedWork);

    updated[index].remaining_work = truncateTo2(stageAmount - completedWork);
    // 🔥 PAYMENT CALCULATION (ADD HERE)
    const aboutToBill = Number(completedWork.toFixed(2));
    const remainingAmount = Number((stageAmount - completedWork).toFixed(2));

    updated[index].paymentData = {
      aboutToBillAmount: aboutToBill,
      remainingAmount: remainingAmount,
    };

    if (remainingPercentage === 0) {
      updated[index].status = "completed";
    } else {
      updated[index].status = "pending";
    }

    // ✅ TOTAL VALIDATION (must be 100)
    const totalStagePercent = updated.reduce(
      (sum, item) => sum + (Number(item.percentage) || 0),
      0,
    );

    if (totalStagePercent > 100) {
      toast.warning("Total Stage Weightage cannot exceed 100");
      return; // ❌ stop update
    }

    setFormData(updated);
  };

  const handleAddSubmission = () => {
    setFormData((prev) => [
      ...prev,
      {
        id: uuidv4(),
        stage_name: "",
        percentage: "",
        stage_amount: "",
        completed_percentage: "",
        remaining_percentage: "",
        completed_work: "",
        remaining_work: "",
        status: "pending",
        remarks: [
          {
            id: "",
            remarks: "",
            remarks_date: "",
          },
        ],
        document_name: "",
        document_file: "",
      },
    ]);
  };

  const handleAddStageRemarks = (index) => {
    const updated = [...formData];

    updated[index].remarks.push({
      remarks: "",
      remarks_date: "",
    });

    setFormData(updated);
  };

  const handleRemoveSubmission = async (index) => {
    const updated = [...formData];
    const removedItem = updated[index];

    if (removedItem.remarks_type === "document" && removedItem.id) {
      const existingDoc = (documentData || []).find((doc) => doc.input_id === removedItem.id);

      const confirmDelete = window.confirm(
        `Are you sure you want to delete this document: "${removedItem.document_name || existingDoc?.name || "Unnamed Document"
        }"?`,
      );

      if (!confirmDelete) {
        toast.info("Deletion cancelled.");
        return;
      }

      if (existingDoc) {
        try {
          await axios.delete(`${BASE_URL}/dpr/document/${existingDoc.id}/`, AUTH());
          toast.success(`Document "${existingDoc.name}" deleted successfully.`);
        } catch (err) {
          console.error("❌ Error deleting document:", err);
          toast.error(`Failed to delete document: ${existingDoc.name}`);
        }
      }
    }

    updated.splice(index, 1);
    setFormData(updated);
  };

  const validateform = () => {
    const newErrors = {};

    formData.forEach((item, idx) => {
      if (!item.status?.trim()) {
        newErrors[`status_${idx}`] = "Status is required!";
      }
      if (!item.stage_name?.trim()) {
        newErrors[`stage_name_${idx}`] = "Stage Name is required!";
      }
      if (!item.percentage?.trim()) {
        newErrors[`percentage_${idx}`] = "percentage is required!";
      }
    });

    if (formData?.length) {
      let totalStagePercent = 0;

      formData.forEach((stage, idx) => {
        if (!stage.stage_name?.trim()) {
          newErrors[`stage_name_${idx}`] = "Stage name is required!";
        }

        if (Number(stage.completed_percentage) > 100) {
          newErrors[`completed_percentage_${idx}`] =
            "Completed % cannot exceed Stage 100%";
        }

        if (!stage.percentage) {
          newErrors[`percentage_${idx}`] = "Stage % is required!";
        } else if (isNaN(stage.percentage)) {
          newErrors[`percentage_${idx}`] = "Must be a number!";
        }

        if (!stage.completed_percentage && stage.completed_percentage !== 0) {
          newErrors[`completed_percentage_${idx}`] = "Completed % is required!";
        } else if (isNaN(stage.completed_percentage)) {
          newErrors[`completed_percentage_${idx}`] = "Must be a number!";
        }

        totalStagePercent += Number(stage.percentage) || 0;
      });

      // ⭐ MOST IMPORTANT VALIDATION
      if (totalStagePercent !== 100) {
        newErrors["percentage"] = "Total Stage Weightage must be exactly 100%";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleFormSubmitt = async (e) => {
    e.preventDefault();
    if (!validateform()) return;
    if (submitting) return;
    setSubmitting(true);

    const loadingToastId = toast.loading("Submitting Data... Please wait...");

    try {
      const updatedData = { ...allData };
      const withIds = formData.map((it) => ({ ...it, id: it.id || uuidv4() }));

      // 🟢 1️⃣ Update workstat -> stage
      if (updatedData?.workstat && Array.isArray(updatedData.workstat)) {
        const target = updatedData.workstat.find((w) => w.id === id);

        if (target) {
          target.stage = withIds.map((item) => ({
            id: item.id,
            status: item.status || "pending",
            stage_name: item.stage_name || "",
            completed_percentage: item.completed_percentage || "",
            remaining_percentage: item.remaining_percentage || "",
            completed_work: item.completed_work || "",
            remaining_work: item.remaining_work || "",
            stage_amount: item.stage_amount || "",
            percentage: item.percentage || "",
            remarks_type: item.remarks_type || "",
            remarks: item.remarks || [],
            document_name: item.document_name || "",
          }));
        } else {
          console.warn(`Workstat detail not found for ID: ${id}`);
        }
      }

      const payload = {
        workstat: updatedData.workstat,
      };

      const res = await axios.put(
        `${BASE_URL}/dpr/project/${project}/`,
        payload,
        AUTH(),
      );

      if (res.status === 200 || res.status === 201) {
        toast.success("Data updated successfully!");

        // sirf wahi stages jinki nayi File select hui hai
        const documentEntries = withIds.filter(
          (item) => item.document_file instanceof File,
        );

        if (documentEntries.length) {
          const filesToConfirm = [];

          // API 1 (chunks) + API 2 (complete)
          for (const doc of documentEntries) {
            try {
              const uploaded = await uploadDocumentChunked(doc.document_file, (pct) =>
                toast.update(loadingToastId, {
                  render: `Uploading ${doc.document_name || doc.document_file.name}… ${pct}%`,
                }),
              );

              filesToConfirm.push({
                file_id: uploaded.file_id,
                section_id: id, // workstat/section id, agar alag ho to yahan badlo
                file_path: uploaded.file_path,
                document_name: doc.document_name || doc.document_file.name,
                original_filename: doc.document_file.name,
                input_id: doc.id,
              });
            } catch (err) {
              console.error("❌ Document upload failed:", err);
              toast.error(`Failed for document: ${doc.document_name}`);
            }
          }

          // API 3 — confirm
          if (filesToConfirm.length > 0) {
            try {
              await confirmUploads(project, filesToConfirm);
            } catch (err) {
              console.error("❌ Confirm upload failed:", err);
              toast.error("Documents confirm nahi ho paye, please retry.");
            }
          }
        }

        getProject();
        if (typeof getDocuments === "function") getDocuments();
        setShow(false);
      } else {
        toast.error("Update failed, please try again.");
      }
    } catch (err) {
      console.error("❌ Error updating project:", err);
      toast.error("Something went wrong while updating submission");
    } finally {
      toast.dismiss(loadingToastId);
      setSubmitting(false);
    }
  };

  const totalStageCost = formData.reduce(
    (sum, item) => sum + Number(item.stage_amount || 0),
    0,
  );

  const totalCompleted = formData.reduce(
    (sum, item) => sum + Number(item.paymentData?.aboutToBillAmount || 0),
    0,
  );

  return (
    <>
      <button
        title="Add Data"
        onClick={handleShow}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "5px",
          padding: "5px 12px",
          borderRadius: "5px",
          border: "0.5px solid #2576bc",
          background: "#fff",
          color: "#2576bc",
          fontSize: "12px",
          fontWeight: 500,
          cursor: "pointer",
        }}
      >
        + Data
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave"
        size="lg"
      >
        <Modal.Header
          closeButton
          className="justify-center task-Tab-heading font-weight500 font-size-heading"
        >
          <Modal.Title>Add / Edit Stage Details</Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ padding: "16px 20px", overflowX: "hidden" }}>
          <form onSubmit={handleFormSubmitt}>
            {formData.map((item, index) => (
              <div
                key={item.id || index}
                style={{
                  border: "0.5px solid #e0e0e0",
                  borderRadius: "6px",
                  marginBottom: "12px",
                  background: "#fff",
                  overflow: "hidden",
                }}
              >
                {/* Header */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "10px 14px",
                    background: "#f5f7fa",
                    borderBottom: "0.5px solid #e0e0e0",
                  }}
                >
                  <span style={{ fontSize: "13px", fontWeight: 600, color: "#1e293b" }}>
                    Stage {index + 1}
                  </span>
                  {formData.length > 1 && (
                    <button
                      type="button"
                      onClick={() => handleRemoveSubmission(index)}
                      style={{
                        fontSize: "11px",
                        fontWeight: 500,
                        color: "#dc2626",
                        background: "#fee2e2",
                        border: "none",
                        borderRadius: "4px",
                        padding: "3px 10px",
                        cursor: "pointer",
                      }}
                    >
                      Remove
                    </button>
                  )}
                </div>

                {/* Body */}
                <div style={{ padding: "14px 16px" }}>
                  {/* Stage Name */}
                  <div style={{ marginBottom: "12px" }}>
                    <label
                      style={{
                        fontSize: "12px",
                        fontWeight: 500,
                        color: "#374151",
                        display: "block",
                        marginBottom: "6px",
                      }}
                    >
                      Stage Name <span style={{ color: "#dc2626" }}>*</span>
                    </label>
                    <input
                      type="text"
                      name="stage_name"
                      value={item.stage_name}
                      onChange={(e) => handleInputChange(e, index)}
                      onFocus={(e) => {
                        if (String(item.stage_amount) === "0") {
                          handleInputChange({ target: { name: "stage_amount", value: "" } }, index);
                        }
                      }}
                      placeholder="Enter stage name"
                      style={{
                        width: "100%",
                        padding: "8px 5px",
                        border: errors[`stage_name_${index}`]
                          ? "1px solid #dc2626"
                          : "0.5px solid #e0e0e0",
                        borderRadius: "5px",
                        fontSize: "13px",
                        color: "#1e293b",
                        background: "#f9fafb",
                        outline: "none",
                        boxSizing: "border-box",
                      }}
                    />
                    {errors[`stage_name_${index}`] && (
                      <span
                        style={{
                          display: "block",
                          marginTop: "4px",
                          fontSize: "11px",
                          color: "#dc2626",
                        }}
                      >
                        {errors[`stage_name_${index}`]}
                      </span>
                    )}
                  </div>

                  {/* Stage Weightage */}
                  <div style={{ marginBottom: "12px" }}>
                    <label
                      style={{
                        fontSize: "12px",
                        fontWeight: 500,
                        color: "#374151",
                        display: "block",
                        marginBottom: "6px",
                      }}
                    >
                      Stage Weightage <span style={{ color: "#dc2626" }}>*</span>
                    </label>
                    <input
                      type="text"
                      name="percentage"
                      value={item.percentage}
                      onChange={(e) => handleInputChange(e, index)}
                      onFocus={(e) => {
                        if (String(item.percentage) === "0") {
                          handleInputChange({ target: { name: "percentage", value: "" } }, index);
                        }
                      }}
                      placeholder="Enter Weightage"
                      style={{
                        width: "100%",
                        padding: "8px 5px",
                        border: errors[`percentage_${index}`]
                          ? "1px solid #dc2626"
                          : "0.5px solid #e0e0e0",
                        borderRadius: "5px",
                        fontSize: "13px",
                        color: "#1e293b",
                        background: "#f9fafb",
                        outline: "none",
                        boxSizing: "border-box",
                      }}
                    />
                    {errors[`percentage_${index}`] && (
                      <span
                        style={{
                          display: "block",
                          marginTop: "4px",
                          fontSize: "11px",
                          color: "#dc2626",
                        }}
                      >
                        {errors[`percentage_${index}`]}
                      </span>
                    )}
                  </div>

                  {/* Work Completed Percentage */}
                  <div style={{ marginBottom: "12px" }}>
                    <label
                      style={{
                        fontSize: "12px",
                        fontWeight: 500,
                        color: "#374151",
                        display: "block",
                        marginBottom: "6px",
                      }}
                    >
                      Work Completed Percentage <span style={{ color: "#dc2626" }}>*</span>
                    </label>
                    <input
                      type="number"
                      name="completed_percentage"
                      value={item.completed_percentage}
                      onChange={(e) => handleInputChange(e, index)}
                      placeholder="Enter Work Completed %"
                      style={{
                        width: "100%",
                        padding: "8px 5px",
                        border: errors[`completed_percentage_${index}`]
                          ? "1px solid #dc2626"
                          : "0.5px solid #e0e0e0",
                        borderRadius: "5px",
                        fontSize: "13px",
                        color: "#1e293b",
                        background: "#f9fafb",
                        outline: "none",
                        boxSizing: "border-box",
                      }}
                    />
                    {errors[`completed_percentage_${index}`] && (
                      <span
                        style={{
                          display: "block",
                          marginTop: "4px",
                          fontSize: "11px",
                          color: "#dc2626",
                        }}
                      >
                        {errors[`completed_percentage_${index}`]}
                      </span>
                    )}
                  </div>

                  {/* Work Remaining Percentage */}
                  <div style={{ marginBottom: "12px" }}>
                    <label
                      style={{
                        fontSize: "12px",
                        fontWeight: 500,
                        color: "#374151",
                        display: "block",
                        marginBottom: "6px",
                      }}
                    >
                      Work Remaining Percentage <span style={{ color: "#dc2626" }}>*</span>
                    </label>
                    <input
                      type="number"
                      name="remaining_percentage"
                      value={item.remaining_percentage}
                      onChange={(e) => handleInputChange(e, index)}
                      placeholder="Enter Work Remaining %"
                      style={{
                        width: "100%",
                        padding: "8px 5px",
                        border: errors[`remaining_percentage_${index}`]
                          ? "1px solid #dc2626"
                          : "0.5px solid #e0e0e0",
                        borderRadius: "5px",
                        fontSize: "13px",
                        color: "#1e293b",
                        background: "#f9fafb",
                        outline: "none",
                        boxSizing: "border-box",
                      }}
                    />
                    {errors[`remaining_percentage_${index}`] && (
                      <span
                        style={{
                          display: "block",
                          marginTop: "4px",
                          fontSize: "11px",
                          color: "#dc2626",
                        }}
                      >
                        {errors[`remaining_percentage_${index}`]}
                      </span>
                    )}
                  </div>

                  {/* Work Cost */}
                  <div style={{ marginBottom: "12px" }}>
                    <label
                      style={{
                        fontSize: "12px",
                        fontWeight: 500,
                        color: "#374151",
                        display: "block",
                        marginBottom: "6px",
                      }}
                    >
                      Work Cost <span style={{ color: "#dc2626" }}>*</span>
                    </label>
                    <input
                      type="number"
                      name="stage_amount"
                      value={item.stage_amount}
                      onChange={(e) => handleInputChange(e, index)}
                      placeholder="Enter Work Cost"
                      style={{
                        width: "100%",
                        padding: "8px 5px",
                        border: errors[`stage_amount_${index}`]
                          ? "1px solid #dc2626"
                          : "0.5px solid #e0e0e0",
                        borderRadius: "5px",
                        fontSize: "13px",
                        color: "#1e293b",
                        background: "#f9fafb",
                        outline: "none",
                        boxSizing: "border-box",
                      }}
                    />
                    {errors[`stage_amount_${index}`] && (
                      <span
                        style={{
                          display: "block",
                          marginTop: "4px",
                          fontSize: "11px",
                          color: "#dc2626",
                        }}
                      >
                        {errors[`stage_amount_${index}`]}
                      </span>
                    )}
                  </div>

                  {/* Status (Read-Only) */}
                  <div style={{ marginBottom: "14px" }}>
                    <label
                      style={{
                        fontSize: "12px",
                        fontWeight: 500,
                        color: "#374151",
                        display: "block",
                        marginBottom: "6px",
                      }}
                    >
                      Status <span style={{ color: "#dc2626" }}>(Read-Only)</span>
                    </label>
                    <select
                      name="status"
                      value={item.status}
                      disabled
                      onChange={(e) => handleInputChange(e, index)}
                      style={{
                        width: "100%",
                        padding: "8px 5px",
                        border: "0.5px solid #e0e0e0",
                        borderRadius: "5px",
                        fontSize: "13px",
                        color: "#1e293b",
                        background: "#f1f5f9",
                        outline: "none",
                        boxSizing: "border-box",
                        cursor: "not-allowed",
                      }}
                    >
                      <option value="">Select Status</option>
                      <option value="pending">Pending</option>
                      <option value="completed">Completed</option>
                    </select>
                  </div>

                  {/* Remarks */}
                  {item.remarks.map((remarkItem, remarkIndex) => (
                    <div
                      key={remarkItem.id || remarkIndex}
                      style={{
                        border: "0.5px solid #e0e0e0",
                        borderRadius: "6px",
                        marginBottom: "10px",
                        background: "#fff",
                        overflow: "hidden",
                      }}
                    >
                      {/* Remark Header */}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          padding: "8px 12px",
                          background: "#f5f7fa",
                          borderBottom: "0.5px solid #e0e0e0",
                        }}
                      >
                        <span style={{ fontSize: "12px", fontWeight: 600, color: "#1e293b" }}>
                          Remark {remarkIndex + 1}
                        </span>
                        {item.remarks.length > 1 && (
                          <button
                            type="button"
                            onClick={() => handleRemoveStageRemarks(index, remarkIndex)}
                            style={{
                              fontSize: "11px",
                              fontWeight: 500,
                              color: "#dc2626",
                              background: "#fee2e2",
                              border: "none",
                              borderRadius: "4px",
                              padding: "3px 10px",
                              cursor: "pointer",
                            }}
                          >
                            Remove
                          </button>
                        )}
                      </div>

                      {/* Remark Body */}
                      <div style={{ padding: "12px 14px" }}>
                        <div style={{ marginBottom: "12px" }}>
                          <label
                            style={{
                              fontSize: "12px",
                              fontWeight: 500,
                              color: "#374151",
                              display: "block",
                              marginBottom: "6px",
                            }}
                          >
                            Remarks
                          </label>
                          <textarea
                            name="remarks"
                            value={remarkItem.remarks}
                            onChange={(e) => handleRemarkChange(e, index, remarkIndex)}
                            placeholder="Enter remark"
                            style={{
                              width: "100%",
                              padding: "8px 5px",
                              border: errors[`remarks_${remarkIndex}`]
                                ? "1px solid #dc2626"
                                : "0.5px solid #e0e0e0",
                              borderRadius: "5px",
                              fontSize: "13px",
                              color: "#1e293b",
                              background: "#f9fafb",
                              outline: "none",
                              boxSizing: "border-box",
                              resize: "vertical",
                              minHeight: "72px",
                            }}
                          />
                        </div>
                        <div>
                          <label
                            style={{
                              fontSize: "12px",
                              fontWeight: 500,
                              color: "#374151",
                              display: "block",
                              marginBottom: "6px",
                            }}
                          >
                            Remark Date
                          </label>
                          <input
                            type="date"
                            name="remarks_date"
                            value={remarkItem.remarks_date}
                            onChange={(e) => handleRemarkChange(e, index, remarkIndex)}
                            style={{
                              width: "100%",
                              padding: "8px 5px",
                              border: errors[`remarks_date_${remarkIndex}`]
                                ? "1px solid #dc2626"
                                : "0.5px solid #e0e0e0",
                              borderRadius: "5px",
                              fontSize: "13px",
                              color: "#1e293b",
                              background: "#f9fafb",
                              outline: "none",
                              boxSizing: "border-box",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  ))}

                  {/* Add More Remarks */}
                  <div style={{ textAlign: "center", marginBottom: "14px" }}>
                    <button
                      type="button"
                      onClick={() => handleAddStageRemarks(index)}
                      style={{
                        padding: "6px 16px",
                        borderRadius: "5px",
                        border: "0.5px solid #2576bc",
                        background: "#fff",
                        color: "#2576bc",
                        fontSize: "12px",
                        fontWeight: 500,
                        cursor: "pointer",
                      }}
                    >
                      + Add More Remarks
                    </button>
                  </div>

                  {/* Document Name */}
                  <div style={{ marginBottom: "12px" }}>
                    <label
                      style={{
                        fontSize: "12px",
                        fontWeight: 500,
                        color: "#374151",
                        display: "block",
                        marginBottom: "6px",
                      }}
                    >
                      Document Name
                    </label>
                    <input
                      name="document_name"
                      value={item.document_name}
                      onChange={(e) => handleInputChange(e, index)}
                      placeholder="Enter document name"
                      style={{
                        width: "100%",
                        padding: "8px 5px",
                        border: "0.5px solid #e0e0e0",
                        borderRadius: "5px",
                        fontSize: "13px",
                        color: "#1e293b",
                        background: "#f9fafb",
                        outline: "none",
                        boxSizing: "border-box",
                      }}
                    />
                  </div>

                  {/* Upload Document */}
                  <div>
                    <label
                      style={{
                        fontSize: "12px",
                        fontWeight: 500,
                        color: "#374151",
                        display: "block",
                        marginBottom: "6px",
                      }}
                    >
                      Upload Document
                    </label>
                    <input
                      type="file"
                      name="document_file"
                      onChange={(e) => handleInputChange(e, index)}
                      style={{
                        width: "100%",
                        padding: "8px 5px",
                        border: "0.5px solid #e0e0e0",
                        borderRadius: "5px",
                        fontSize: "13px",
                        color: "#1e293b",
                        background: "#f9fafb",
                        outline: "none",
                        boxSizing: "border-box",
                      }}
                    />
                  </div>
                </div>
              </div>
            ))}

            {/* Add Stage */}
            <div style={{ textAlign: "center", marginBottom: "16px" }}>
              <button
                type="button"
                onClick={handleAddSubmission}
                style={{
                  padding: "6px 16px",
                  borderRadius: "5px",
                  border: "0.5px solid #2576bc",
                  background: "#fff",
                  color: "#2576bc",
                  fontSize: "12px",
                  fontWeight: 500,
                  cursor: "pointer",
                }}
              >
                + Add Stage
              </button>
            </div>

            {/* Footer */}
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
                paddingTop: "12px",
                borderTop: "0.5px solid #e0e0e0",
              }}
            >
              <button
                type="button"
                onClick={handleClose}
                style={{
                  padding: "7px 18px",
                  borderRadius: "5px",
                  border: "0.5px solid #e0e0e0",
                  background: "#fff",
                  color: "#64748b",
                  fontSize: "12px",
                  fontWeight: 500,
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={submitting}
                style={{
                  padding: "7px 18px",
                  borderRadius: "5px",
                  border: "none",
                  background: "#2576bc",
                  color: "#fff",
                  fontSize: "12px",
                  fontWeight: 500,
                  cursor: "pointer",
                }}
              >
                {submitting ? "Saving..." : "Submit"}
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};


const SubmissionTable = ({
  documentData,
  submissionData = [],
  project,
  getProject,
  allData,
  i,
  id,
  getDocuments,
}) => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [submissionDataState, setSubmissionData] = useState(submissionData);

  useEffect(() => {
    const sorted = [...(submissionData || [])].sort((a, b) => {
      const dateA = new Date(a.date || a.created_at || 0);
      const dateB = new Date(b.date || b.created_at || 0);
      return dateB - dateA;  // newest first
    });
    setSubmissionData(sorted);
  }, [submissionData]);

  useEffect(() => {
    setActiveIndex(null);
  }, [project]);

  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [currentPayment, setCurrentPayment] = useState(null);
  const [showPaymentViewModal, setShowPaymentViewModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [letterSortOrder, setLetterSortOrder] = useState("asc"); 

  const handleSavePayment = () => {
    if (!currentPayment || currentPayment.index === undefined) return;
    const updated = [...submissionDataState];
    const { index, cost, ...paymentOnly } = currentPayment;
    updated[index] = { ...updated[index], paymentData: paymentOnly };
    setSubmissionData(updated);
    setIsEditMode(false);
    setShowPaymentModal(false);
    setShowPaymentViewModal(false);
  };

  if (!submissionDataState || submissionDataState.length === 0) {
    return <p className="text-gray-600">No submission data available.</p>;
  }

  // ── shared style helpers ──
  const sectionWrap = {
    border: "0.5px solid #e0e0e0",
    borderRadius: "6px",
    overflow: "hidden",
    marginBottom: "14px",
  };

  const sectionHeader = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "10px 14px",
    background: "#f5f7fa",
    borderBottom: "0.5px solid #e0e0e0",
  };

  return (
    <>
      <div style={{ width: "100%" }}>
        <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "8px", marginBottom: "10px" }}>
  <label style={{ fontSize: "12px", fontWeight: 500, color: "#374151" }}>
    Sort letters by date
  </label>
  <select
    value={letterSortOrder}
    onChange={(e) => setLetterSortOrder(e.target.value)}
    style={{
      padding: "5px 8px",
      border: "0.5px solid #e0e0e0",
      borderRadius: "5px",
      fontSize: "12px",
      background: "#f9fafb",
      cursor: "pointer",
    }}
  >
    <option value="asc">Oldest first</option>
    <option value="desc">Newest first</option>
  </select>
</div>

        {/* ── Submission toggle pills ── */}
        <div
          style={{
            display: "flex",
            gap: "10px",
            borderBottom: "1px solid #e5e7eb",
            paddingBottom: "8px",
            marginBottom: "14px",
            overflowX: "auto",
            whiteSpace: "nowrap",
          }}
        >
          {submissionDataState.map((sub, idx) => {
            const isActive = activeIndex === idx;
            const status = sub.status?.toLowerCase();
            const colorMap = {
              completed: "#16a34a",
              pending: "#dc2626",
              default: "#374151",
            };
            const color = colorMap[status] || colorMap.default;

            return (
              <button
                key={idx}
                onClick={() => setActiveIndex(isActive ? null : idx)}
                style={{
                  flexShrink: 0,
                  padding: "8px 14px",
                  borderRadius: "20px",
                  border: isActive ? "1px solid #4f46e5" : "1px solid #e5e7eb",
                  background: isActive ? "#eef2ff" : "#fff",
                  color: isActive ? "#4f46e5" : color,
                  fontWeight: 500,
                  fontSize: "13px",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                }}
                onMouseEnter={(e) => {
                  if (!isActive) e.target.style.background = "#f9fafb";
                }}
                onMouseLeave={(e) => {
                  if (!isActive) e.target.style.background = "#fff";
                }}
              >
                {sub.submissionName || `Submission ${idx + 1}`} (
                {sub.status || "No Status"})
              </button>
            );
          })}
        </div>

        {/* ── Active submission panels ── */}
        {activeIndex !== null && (() => {
          const active = submissionDataState[activeIndex];
          const submissionRows = sortByLetterDate(active?.submissionData, letterSortOrder);
const commentRows    = sortByLetterDate(active?.commentData, letterSortOrder);
const replyRows      = sortByLetterDate(active?.replyData, letterSortOrder);
          return (
            <div style={{ display: "flex", flexDirection: "column", gap: "0px" }}>

              {/* ===== Submission Details ===== */}
              <div style={sectionWrap}>
                <div style={sectionHeader}>
                  <h5 className="font-weight600" style={{ margin: 0, fontSize: "13px", color: "#1e293b" }}>
                    Submission Details
                  </h5>
                  <AddsubmissionData
                    submissionItem={submissionDataState}
                    project={project}
                    getProject={getProject}
                    allData={allData}
                    i={i.submission_data}
                    id={id}
                    getDocuments={getDocuments}
                    documentData={documentData}
                    submission_id={active?.submission_id}
                  />
                </div>
                <div
                  className="info-box-div-bg scroll-container-table child-table-scroll-progres scroll-hover box-shadow"
                  style={{ overflowX: "auto", borderRadius: "0 0 6px 6px" }}
                >
                  <div style={{ minWidth: "max-content" }}>
                    <table className="custom-table" style={{ width: "100%" }}>
                      <thead className="table-heading">
                        <tr className="custom-table-head-tr">
                          <th className="table-heading-text text-start">S.No.</th>
                          <th className="table-heading-text text-start">Revision No.</th>
                          <th className="table-heading-text text-start">In Reply To</th>
                          <th className="table-heading-text text-start">Date</th>
                          <th className="table-heading-text text-start">Letter No.</th>
                          <th className="table-heading-text text-start">Submitted To</th>
                          <th className="table-heading-text text-start">Description</th>
                          <th className="table-heading-text text-start">File</th>
                        </tr>
                      </thead>
                      <tbody>
                        {active?.submissionData?.length > 0 ? (
                          submissionRows.map((s, i) => (
                            <tr className="custom-table-head-td global-table-td" key={i}>
                              <td className="table-body text-left-sr">{i + 1}</td>
                              <td className="table-body text-start">{s.rev_no || "-"}</td>
                              <td className="table-body text-start">
                                <div style={{ maxWidth: "200px", whiteSpace: "wrap" }}>{s.replyLetter_num || "-"}</div>
                              </td>
                              <td className="table-body text-start">{s.date || "-"}</td>
                              <td className="table-body text-start">
                                <div style={{ maxWidth: "200px", whiteSpace: "wrap" }}>{s.Letter_num || "-"}</div>
                              </td>
                              <td className="table-body text-start">{s.submitted_to || "-"}</td>
                              <td className="table-body text-start">
                                <div style={{ maxWidth: "200px", whiteSpace: "wrap" }}>{s.description || "-"}</div>
                              </td>
                              <td className="table-body text-start">
  <DocLinks documentData={documentData} inputId={s.id} inputtype={s.inputtype} />
</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="8" className="text-center text-gray-500 border py-2">No Data</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              {/* ===== Comment Details ===== */}
              <div style={sectionWrap}>
                <div style={sectionHeader}>
                  <h4 className="font-weight600" style={{ margin: 0, fontSize: "13px", color: "#1e293b" }}>
                    Comment Details
                  </h4>
                  <AddCommentData
                    submissionItem={submissionDataState}
                    project={project}
                    getProject={getProject}
                    allData={allData}
                    i={i.submission_data}
                    id={id}
                    getDocuments={getDocuments}
                    documentData={documentData}
                    submission_id={active?.submission_id}
                  />
                </div>
                <div
                  className="box-shadow info-box-div-bg scroll-container-table child-table-scroll-progres scroll-hover"
                  style={{ overflowX: "auto", borderRadius: "0 0 6px 6px" }}
                >
                  <div style={{ minWidth: "max-content" }}>
                    <table className="custom-table" style={{ width: "100%" }}>
                      <thead className="table-heading">
                        <tr className="custom-table-head-tr">
                          <th className="table-heading-text text-left-sr">S.No.</th>
                          <th className="text-start table-heading-text">Comments On</th>
                          <th className="text-start table-heading-text">Date</th>
                          <th className="text-start table-heading-text">Letter No.</th>
                          <th className="text-start table-heading-text">From</th>
                          <th className="text-start table-heading-text">Description</th>
                          <th className="text-start table-heading-text">File</th>
                        </tr>
                      </thead>
                      <tbody>
                        {active?.commentData?.length > 0 ? (
                          commentRows.map((c, i) => (
                            <tr className="custom-table-head-td global-table-td" key={i}>
                              <td className="table-body text-left-sr">{i + 1}.</td>
                              <td className="table-body text-start">
                                <div style={{ maxWidth: "200px", whiteSpace: "wrap" }}>{c.rev_number || "-"}</div>
                              </td>
                              <td className="table-body text-start">{c.date || "-"}</td>
                              <td className="table-body text-start">
                                <div style={{ maxWidth: "200px", whiteSpace: "wrap" }}>{c.Letter_num || "-"}</div>
                              </td>
                              <td className="table-body text-start">{c.from || "-"}</td>
                              <td className="table-body text-start">
                                <div style={{ maxWidth: "200px", whiteSpace: "wrap" }}>{c.description || "-"}</div>
                              </td>
                                        <td className="table-body text-start">
  <DocLinks documentData={documentData} inputId={c.id} inputtype={c.inputtype} />
</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="7" className="text-center text-gray-500 border py-2">No Comments</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              {/* ===== Reply Details ===== */}
              <div style={sectionWrap}>
                <div style={sectionHeader}>
                  <h4 className="font-weight600" style={{ margin: 0, fontSize: "13px", color: "#1e293b" }}>
                    Reply Details
                  </h4>
                  <AddReplyData
                    submissionItem={submissionDataState}
                    project={project}
                    getProject={getProject}
                    allData={allData}
                    i={i.submission_data}
                    id={id}
                    getDocuments={getDocuments}
                    documentData={documentData}
                    submission_id={active?.submission_id}
                  />
                </div>
                <div
                  className="box-shadow info-box-div-bg scroll-container-table child-table-scroll-progres scroll-hover"
                  style={{ overflowX: "auto", borderRadius: "0 0 6px 6px" }}
                >
                  <div style={{ minWidth: "max-content" }}>
                    <table className="custom-table" style={{ width: "100%" }}>
                      <thead className="table-heading">
                        <tr className="custom-table-head-tr">
                          <th className="table-heading-text text-left-sr">S.No.</th>
                          <th className="text-start table-heading-text">Reply of</th>
                          <th className="text-start table-heading-text">Date</th>
                          <th className="text-start table-heading-text">Letter No.</th>
                          <th className="text-start table-heading-text">To</th>
                          <th className="text-start table-heading-text">Description</th>
                          <th className="text-start table-heading-text">File</th>
                        </tr>
                      </thead>
                      <tbody>
                        {active?.replyData?.length > 0 ? (
                          replyRows.map((r, i) => (
                            <tr className="custom-table-head-td global-table-td" key={i}>
                              <td className="table-body text-left-sr">{i + 1}.</td>
                              <td className="table-body text-start">
                                <div style={{ maxWidth: "200px", whiteSpace: "wrap" }}>{r.comment_letter_num || "-"}</div>
                              </td>
                              <td className="table-body text-start">{r.date || "-"}</td>
                              <td className="table-body text-start">
                                <div style={{ maxWidth: "200px", whiteSpace: "wrap" }}>{r.Letter_num || "-"}</div>
                              </td>
                              <td className="table-body text-start">{r.to || "-"}</td>
                              <td className="table-body text-start">
                                <div style={{ maxWidth: "200px", whiteSpace: "wrap" }}>{r.description || "-"}</div>
                              </td>
                                        <td className="table-body text-start">
  <DocLinks documentData={documentData} inputId={r.id} inputtype={r.inputtype} />
</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="7" className="text-center text-gray-500 border py-2">No Replies</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

            </div>
          );
        })()}
      </div>
    </>
  );
};

const RemarksSection = ({ submissionData, stages, input_type }) => {
  const [selectedRemarks, setSelectedRemarks] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showStageModal, setShowStageModal] = useState(false); // New state for stage modal
  const [hoveredRow, setHoveredRow] = useState(null);
  const [selectedRemarkId, setSelectedRemarkId] = useState(null);
  const [stageId, setStageId] = useState("null");

  // Calculate sorted remarks using useMemo
  const sortedRemarks = useMemo(() => {
    if (input_type === "Stage type") {
      if (!Array.isArray(stages)) return [];

      const remarksArray = stages.flatMap((r) => r || []);

      return remarksArray.sort((a, b) => {
        return new Date(a.remarks_date) - new Date(b.remarks_date);
      });
    } else if (input_type === "Normal Input") {
      if (!Array.isArray(submissionData)) return [];

      return [...submissionData].sort((a, b) => {
        return new Date(a.remarks_date) - new Date(b.remarks_date);
      });
    }

    return [];
  }, [input_type, stages, submissionData]);
  const truncateText = (text, maxLength = 45) => {
    if (!text) return "";
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + "...";
  };

  const handleRemarkClick = (remark, id) => {
    setSelectedRemarks(remark);
    setSelectedRemarkId(id);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setTimeout(() => {
      setSelectedRemarks(null);
      setSelectedRemarkId(null);
    }, 300);
  };

  const handleStageModalOpen = () => setShowStageModal(true);
  const handleStageModalClose = () => setShowStageModal(false);

  // Prevent body scroll when modal is open
  useEffect(() => {
    if (showModal || showStageModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [showModal, showStageModal]);

  console.log(stages, "StagesData");

  return (
    <>
      {input_type === "Stage type" ? (
        // Show stage type remarks if needed

        // Your table component here - you can reuse the same table UI
        <RemarksTable
          input_type={input_type}
          sortedRemarks={sortedRemarks}
          hoveredRow={hoveredRow}
          setHoveredRow={setHoveredRow}
          handleRemarkClick={handleRemarkClick}
          truncateText={truncateText}
          show={showStageModal}
          onClose={handleStageModalClose}
          onOpen={handleStageModalOpen}
        />
      ) : (
        <>
          {/* Modern Glassmorphism Table */}
          <RemarksTable
            sortedRemarks={sortedRemarks}
            hoveredRow={hoveredRow}
            setHoveredRow={setHoveredRow}
            handleRemarkClick={handleRemarkClick}
            truncateText={truncateText}
            input_type={input_type}
          />
        </>
      )}

      {/* Premium Modal with Animation */}
      {showModal && selectedRemarks && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            backdropFilter: "blur(8px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
            animation: "fadeIn 0.3s ease",
          }}
          onClick={closeModal}
        >
          <style>
            {`
              @keyframes fadeIn {
                from { opacity: 0; }
                to { opacity: 1; }
              }
              @keyframes slideUp {
                from { transform: translateY(30px); opacity: 0; }
                to { transform: translateY(0); opacity: 1; }
              }
            `}
          </style>
          <div
            style={{
              background: "white",
              borderRadius: "32px",
              maxWidth: "650px",
              width: "90%",
              maxHeight: "85vh",
              overflowY: "auto",
              position: "relative",
              boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
              animation: "slideUp 0.4s cubic-bezier(0.16, 1, 0.3, 1)",
              border: "1px solid rgba(255, 255, 255, 0.5)",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Gradient Header */}
            <div
              style={{
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                padding: "32px 32px 24px",
                borderTopLeftRadius: "32px",
                borderTopRightRadius: "32px",
                position: "relative",
              }}
            >
              <button
                onClick={closeModal}
                style={{
                  position: "absolute",
                  top: "20px",
                  right: "24px",
                  background: "rgba(255, 255, 255, 0.2)",
                  border: "none",
                  width: "36px",
                  height: "36px",
                  borderRadius: "12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "white",
                  fontSize: "24px",
                  cursor: "pointer",
                  backdropFilter: "blur(4px)",
                  transition: "all 0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = "rgba(255, 255, 255, 0.3)";
                  e.target.style.transform = "scale(1.05)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = "rgba(255, 255, 255, 0.2)";
                  e.target.style.transform = "scale(1)";
                }}
              >
                ×
              </button>

              <div
                style={{ display: "flex", alignItems: "center", gap: "16px" }}
              >
                <div
                  style={{
                    background: "rgba(255, 255, 255, 0.2)",
                    width: "56px",
                    height: "56px",
                    borderRadius: "18px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backdropFilter: "blur(4px)",
                  }}
                >
                  <span style={{ fontSize: "28px" }}>💬</span>
                </div>
                <div>
                  <h2
                    style={{
                      margin: 0,
                      color: "white",
                      fontSize: "24px",
                      fontWeight: "700",
                      letterSpacing: "-0.5px",
                    }}
                  >
                    Remark Details
                  </h2>
                  <p
                    style={{
                      margin: "8px 0 0 0",
                      color: "rgba(255, 255, 255, 0.9)",
                      fontSize: "15px",
                    }}
                  >
                    Added on{" "}
                    {new Date(selectedRemarks.remarks_date).toLocaleDateString(
                      "en-IN",
                      {
                        day: "numeric",
                        month: "long",
                        year: "numeric",
                      },
                    )}
                  </p>
                </div>
              </div>
            </div>

            {/* Modal Content */}

            <div
              className="table-box scroll-container-table"
              style={{ padding: "32px", height: "40vh" }}
            >
              <div
                style={{
                  background:
                    "linear-gradient(145deg, #f8faff 0%, #f1f4f9 100%)",
                  padding: "28px",
                  borderRadius: "20px",
                  border: "1px solid rgba(255, 255, 255, 0.8)",
                  marginBottom: "24px",
                }}
              >
                <div
                  className="table-css width-100vw"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    marginBottom: "20px",
                  }}
                >
                  <span
                    style={{
                      background:
                        "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                      color: "white",
                      padding: "6px 16px",
                      borderRadius: "100px",
                      fontSize: "13px",
                      fontWeight: "600",
                      letterSpacing: "0.3px",
                    }}
                  >
                    REMARK CONTENT
                  </span>
                </div>
                <p
                  style={{
                    margin: 0,
                    color: "#1e293b",
                    fontSize: "17px",
                    lineHeight: "1.8",
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-word",
                    fontWeight: "500",
                  }}
                >
                  {selectedRemarks.remarks}
                </p>
              </div>

              {/* Metadata Section */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
                  gap: "16px",
                  padding: "20px",
                  background: "#fafcff",
                  borderRadius: "16px",
                  border: "1px solid #edf2f7",
                }}
              >
                <div
                  style={{ display: "flex", alignItems: "center", gap: "12px" }}
                >
                  <span style={{ fontSize: "20px" }}>📌</span>
                  <div>
                    <div
                      style={{
                        color: "#64748b",
                        fontSize: "12px",
                        fontWeight: "600",
                        textTransform: "uppercase",
                        letterSpacing: "0.5px",
                      }}
                    >
                      Remark ID
                    </div>
                    <div
                      style={{
                        color: "#1e293b",
                        fontSize: "15px",
                        fontWeight: "600",
                      }}
                    >
                      #REM-{String(selectedRemarkId || 1).padStart(3, "0")}
                    </div>
                  </div>
                </div>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "12px" }}
                >
                  <span style={{ fontSize: "20px" }}>📅</span>
                  <div>
                    <div
                      style={{
                        color: "#64748b",
                        fontSize: "12px",
                        fontWeight: "600",
                        textTransform: "uppercase",
                        letterSpacing: "0.5px",
                      }}
                    >
                      Date
                    </div>
                    <div
                      style={{
                        color: "#1e293b",
                        fontSize: "15px",
                        fontWeight: "600",
                      }}
                    >
                      {new Date(
                        selectedRemarks.remarks_date,
                      ).toLocaleDateString("en-IN", {
                        day: "numeric",
                        month: "long",
                        year: "numeric",
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Modal Footer */}
            <div
              style={{
                padding: "24px 32px",
                borderTop: "1px solid #edf2f7",
                display: "flex",
                justifyContent: "flex-end",
                gap: "16px",
                background: "#fafcff",
                borderBottomLeftRadius: "32px",
                borderBottomRightRadius: "32px",
              }}
            >
              <button
                onClick={closeModal}
                style={{
                  background:
                    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  color: "white",
                  border: "none",
                  padding: "12px 32px",
                  borderRadius: "12px",
                  fontSize: "15px",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  boxShadow: "0 4px 14px rgba(102, 126, 234, 0.4)",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
                onMouseEnter={(e) => {
                  e.target.style.background =
                    "linear-gradient(135deg, #5a67d8 0%, #6b46a1 100%)";
                  e.target.style.transform = "scale(1.02)";
                  e.target.style.boxShadow =
                    "0 6px 20px rgba(102, 126, 234, 0.5)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.background =
                    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)";
                  e.target.style.transform = "scale(1)";
                  e.target.style.boxShadow =
                    "0 4px 14px rgba(102, 126, 234, 0.4)";
                }}
              >
                <span>✓</span> Close Remark
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const RemarksTable = ({
  input_type,
  sortedRemarks,
  hoveredRow,
  setHoveredRow,
  handleRemarkClick,
  truncateText,
  show,
  onClose,
  onOpen,
}) => {
  console.log(input_type, "tABLEiNPUTtYPE");
  console.log(sortedRemarks, "tABLEiNPUTtYPE");

  return (
    <>
      {input_type === "Stage type" ? (
        <>
          {/* Button to open modal */}
          <button
            onClick={onOpen} // This should be your handleShow function
            style={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              color: "white",
              border: "none",
              padding: "12px 10px",
              borderRadius: "12px",
              fontSize: "12px",
              fontWeight: "600",
              cursor: "pointer",
              transition: "all 0.3s ease",
              boxShadow: "0 4px 14px rgba(102, 126, 234, 0.4)",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              margin: "20px",
            }}
            onMouseEnter={(e) => {
              e.target.style.background =
                "linear-gradient(135deg, #5a67d8 0%, #6b46a1 100%)";
              e.target.style.transform = "scale(1.02)";
              e.target.style.boxShadow = "0 6px 20px rgba(102, 126, 234, 0.5)";
            }}
            onMouseLeave={(e) => {
              e.target.style.background =
                "linear-gradient(135deg, #667eea 0%, #764ba2 100%)";
              e.target.style.transform = "scale(1)";
              e.target.style.boxShadow = "0 4px 14px rgba(102, 126, 234, 0.4)";
            }}
          >
            <span style={{ fontSize: "12px" }}>💬</span> View Remarks
          </button>

          {/* Custom Modal with Remarks Table */}
          {show && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                height: "100vh",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                backdropFilter: "blur(8px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 9999,
                animation: "fadeIn 0.3s ease",
              }}
              onClick={onClose}
            >
              <style>
                {`
                                    @keyframes fadeIn {
                                        from { opacity: 0; }
                                        to { opacity: 1; }
                                    }
                                    @keyframes slideUp {
                                        from { transform: translateY(30px); opacity: 0; }
                                        to { transform: translateY(0); opacity: 1; }
                                    }
                                `}
              </style>
              <div
                style={{
                  background: "white",
                  borderRadius: "32px",
                  maxWidth: "900px",
                  width: "90%",
                  maxHeight: "80vh",
                  overflow: "auto",
                  position: "relative",
                  boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
                  animation: "slideUp 0.4s cubic-bezier(0.16, 1, 0.3, 1)",
                  border: "1px solid rgba(255, 255, 255, 0.5)",
                }}
                onClick={(e) => e.stopPropagation()}
              >
                {/* Modal Header */}
                <div
                  style={{
                    background:
                      "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                    padding: "24px 32px",
                    borderTopLeftRadius: "32px",
                    borderTopRightRadius: "32px",
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "16px",
                    }}
                  >
                    <div
                      style={{
                        background: "rgba(255, 255, 255, 0.2)",
                        width: "48px",
                        height: "48px",
                        borderRadius: "16px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backdropFilter: "blur(4px)",
                      }}
                    >
                      <span style={{ fontSize: "24px" }}>💬</span>
                    </div>
                    <div>
                      <h2
                        style={{
                          margin: 0,
                          color: "white",
                          fontSize: "22px",
                          fontWeight: "700",
                          letterSpacing: "-0.5px",
                        }}
                      >
                        Stage Remarks
                      </h2>
                      <p
                        style={{
                          margin: "4px 0 0 0",
                          color: "rgba(255, 255, 255, 0.9)",
                          fontSize: "14px",
                        }}
                      >
                        {sortedRemarks?.length}{" "}
                        {sortedRemarks?.length === 1 ? "remark" : "remarks"}{" "}
                        available
                      </p>
                    </div>
                  </div>
                  <button
                    onClick={onClose}
                    style={{
                      background: "rgba(255, 255, 255, 0.2)",
                      border: "none",
                      width: "36px",
                      height: "36px",
                      borderRadius: "12px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "white",
                      fontSize: "24px",
                      cursor: "pointer",
                      backdropFilter: "blur(4px)",
                      transition: "all 0.2s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.background = "rgba(255, 255, 255, 0.3)";
                      e.target.style.transform = "scale(1.05)";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.background = "rgba(255, 255, 255, 0.2)";
                      e.target.style.transform = "scale(1)";
                    }}
                  >
                    ×
                  </button>
                </div>

                {/* Modal Content - Remarks Table */}

                <div
                  className="table-box scroll-container-table"
                  style={{
                    background:
                      "linear-gradient(145deg, #ffffff 0%, #fafcff 100%)",
                    borderRadius: "20px",
                    height: "50vh",
                    border: "1px solid rgba(255, 255, 255, 0.7)",
                  }}
                >
                  <table
                    className="table-css width-100vw "
                    style={{
                      width: "100%",
                      padding: "0px",
                      borderCollapse: "separate",
                      borderSpacing: "0 8px",
                      marginTop: "8px",
                    }}
                  >
                    <thead className="table-heading">
                      <tr className="custom-table-head-tr ">
                        {["Remark", "Details", "Date"].map((header, idx) => (
                          <th
                            key={idx}
                            style={{
                              textAlign: "left",
                              padding: "12px 16px",
                              color: "#4b5563",
                              fontSize: "13px",
                              fontWeight: "600",
                              textTransform: "uppercase",
                              letterSpacing: "0.05em",
                              background: "transparent",
                            }}
                          >
                            {header}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {sortedRemarks.map((remark, idx) => (
                        <tr
                          key={idx}
                          onMouseEnter={() => setHoveredRow(idx)}
                          onMouseLeave={() => setHoveredRow(null)}
                          style={{
                            backgroundColor:
                              hoveredRow === idx ? "#f8faff" : "white",
                            borderRadius: "16px",
                            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                            boxShadow:
                              hoveredRow === idx
                                ? "0 8px 20px rgba(79, 114, 202, 0.12), 0 2px 6px rgba(79, 114, 202, 0.05)"
                                : "0 2px 8px rgba(0, 0, 0, 0.02)",
                            transform:
                              hoveredRow === idx ? "scale(1.01)" : "scale(1)",
                            cursor: "pointer",
                          }}
                          onClick={() => handleRemarkClick(remark, idx + 1)}
                        >
                          <td
                            style={{
                              padding: "16px 16px",
                              borderTopLeftRadius: "16px",
                              borderBottomLeftRadius: "16px",
                              width: "80px",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "12px",
                              }}
                            >
                              <div
                                style={{
                                  width: "32px",
                                  height: "32px",
                                  background:
                                    hoveredRow === idx
                                      ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                                      : "#f3f4f6",
                                  borderRadius: "10px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  color:
                                    hoveredRow === idx ? "white" : "#4b5563",
                                  fontSize: "14px",
                                  fontWeight: "600",
                                  transition: "all 0.3s ease",
                                }}
                              >
                                {idx + 1}
                              </div>
                            </div>
                          </td>
                          <td style={{ padding: "16px 16px" }}>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "4px",
                              }}
                            >
                              <span
                                style={{
                                  color:
                                    hoveredRow === idx ? "#1e293b" : "#334155",
                                  fontSize: "15px",
                                  fontWeight:
                                    hoveredRow === idx ? "600" : "500",
                                  lineHeight: "1.5",
                                  transition: "all 0.2s ease",
                                }}
                              >
                                {truncateText(remark.remarks, 50)}
                              </span>
                              <span
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "6px",
                                  color: "#667eea",
                                  fontSize: "13px",
                                  fontWeight: "500",
                                  opacity: hoveredRow === idx ? 1 : 0.7,
                                  transition: "opacity 0.2s ease",
                                }}
                              >
                                <span style={{ fontSize: "16px" }}>📎</span>{" "}
                                Click to view full remark
                              </span>
                            </div>
                          </td>
                          <td
                            style={{
                              padding: "16px 16px",
                              borderTopRightRadius: "16px",
                              borderBottomRightRadius: "16px",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                              }}
                            >
                              <div
                                style={{
                                  width: "8px",
                                  height: "8px",
                                  borderRadius: "50%",
                                  background:
                                    hoveredRow === idx
                                      ? "linear-gradient(135deg, #48bb78 0%, #38a169 100%)"
                                      : "#cbd5e0",
                                  transition: "all 0.3s ease",
                                }}
                              />
                              <span
                                style={{
                                  color:
                                    hoveredRow === idx ? "#2d3748" : "#4a5568",
                                  fontSize: "14px",
                                  fontWeight:
                                    hoveredRow === idx ? "600" : "500",
                                }}
                              >
                                {new Date(
                                  remark.remarks_date,
                                ).toLocaleDateString("en-IN", {
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                })}
                              </span>
                            </div>
                          </td>
                        </tr>
                      ))}

                      {sortedRemarks.length === 0 && (
                        <tr>
                          <td
                            colSpan="3"
                            style={{ padding: "60px", textAlign: "center" }}
                          >
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                gap: "16px",
                              }}
                            >
                              <span style={{ fontSize: "48px" }}>📝</span>
                              <h4
                                style={{
                                  margin: 0,
                                  color: "#1a1f36",
                                  fontSize: "18px",
                                }}
                              >
                                No remarks yet
                              </h4>
                              <p
                                style={{
                                  margin: 0,
                                  color: "#6b7280",
                                  fontSize: "14px",
                                }}
                              >
                                Remarks will appear here once added
                              </p>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}
        </>
      ) : (
        <div
          style={{
            background: "linear-gradient(145deg, #ffffff 0%, #fafcff 100%)",
            borderRadius: "20px",
            boxShadow:
              "0 10px 40px rgba(0, 0, 0, 0.08), 0 2px 8px rgba(0, 0, 0, 0.02)",
            padding: "20px",
            border: "1px solid rgba(255, 255, 255, 0.7)",
            backdropFilter: "blur(10px)",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: "20px",
              padding: "0 8px",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <div
                style={{
                  background:
                    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  width: "40px",
                  height: "40px",
                  borderRadius: "12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "white",
                  fontSize: "20px",
                }}
              >
                💬
              </div>
              <div>
                <h3
                  style={{
                    margin: 0,
                    color: "#1a1f36",
                    fontSize: "20px",
                    fontWeight: "700",
                  }}
                >
                  Remarks Timeline
                </h3>
                <p
                  style={{
                    margin: "4px 0 0 0",
                    color: "#6b7280",
                    fontSize: "14px",
                  }}
                >
                  {sortedRemarks?.length}{" "}
                  {sortedRemarks?.length === 1 ? "remark" : "remarks"} • Oldest
                  to newest
                </p>
              </div>
            </div>
          </div>

          <table
            style={{
              width: "100%",
              borderCollapse: "separate",
              borderSpacing: "0 8px",
              marginTop: "8px",
            }}
          >
            <thead>
              <tr>
                {["Remark", "Details", "Date"].map((header, idx) => (
                  <th
                    key={idx}
                    style={{
                      textAlign: "left",
                      padding: "12px 16px",
                      color: "#4b5563",
                      fontSize: "13px",
                      fontWeight: "600",
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                      background: "transparent",
                    }}
                  >
                    {header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {sortedRemarks.map((remark, idx) => (
                <tr
                  key={idx}
                  onMouseEnter={() => setHoveredRow(idx)}
                  onMouseLeave={() => setHoveredRow(null)}
                  style={{
                    backgroundColor: hoveredRow === idx ? "#f8faff" : "white",
                    borderRadius: "16px",
                    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                    boxShadow:
                      hoveredRow === idx
                        ? "0 8px 20px rgba(79, 114, 202, 0.12), 0 2px 6px rgba(79, 114, 202, 0.05)"
                        : "0 2px 8px rgba(0, 0, 0, 0.02)",
                    transform: hoveredRow === idx ? "scale(1.01)" : "scale(1)",
                    cursor: "pointer",
                  }}
                  onClick={() => handleRemarkClick(remark, idx + 1)}
                >
                  <td
                    style={{
                      padding: "16px 16px",
                      borderTopLeftRadius: "16px",
                      borderBottomLeftRadius: "16px",
                      width: "80px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                      }}
                    >
                      <div
                        style={{
                          width: "32px",
                          height: "32px",
                          background:
                            hoveredRow === idx
                              ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                              : "#f3f4f6",
                          borderRadius: "10px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: hoveredRow === idx ? "white" : "#4b5563",
                          fontSize: "14px",
                          fontWeight: "600",
                          transition: "all 0.3s ease",
                        }}
                      >
                        {idx + 1}
                      </div>
                    </div>
                  </td>
                  <td style={{ padding: "16px 16px" }}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "4px",
                      }}
                    >
                      <span
                        style={{
                          color: hoveredRow === idx ? "#1e293b" : "#334155",
                          fontSize: "15px",
                          fontWeight: hoveredRow === idx ? "600" : "500",
                          lineHeight: "1.5",
                          transition: "all 0.2s ease",
                        }}
                      >
                        {truncateText(remark.remarks, 50)}
                      </span>
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                          color: "#667eea",
                          fontSize: "13px",
                          fontWeight: "500",
                          opacity: hoveredRow === idx ? 1 : 0.7,
                          transition: "opacity 0.2s ease",
                        }}
                      >
                        <span style={{ fontSize: "16px" }}>📎</span> Click to
                        view full remark
                      </span>
                    </div>
                  </td>
                  <td
                    style={{
                      padding: "16px 16px",
                      borderTopRightRadius: "16px",
                      borderBottomRightRadius: "16px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <div
                        style={{
                          width: "8px",
                          height: "8px",
                          borderRadius: "50%",
                          background:
                            hoveredRow === idx
                              ? "linear-gradient(135deg, #48bb78 0%, #38a169 100%)"
                              : "#cbd5e0",
                          transition: "all 0.3s ease",
                        }}
                      />
                      <span
                        style={{
                          color: hoveredRow === idx ? "#2d3748" : "#4a5568",
                          fontSize: "14px",
                          fontWeight: hoveredRow === idx ? "600" : "500",
                        }}
                      >
                        {new Date(remark.remarks_date).toLocaleDateString(
                          "en-IN",
                          {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          },
                        )}
                      </span>
                    </div>
                  </td>
                </tr>
              ))}

              {sortedRemarks.length === 0 && (
                <tr>
                  <td
                    colSpan="3"
                    style={{ padding: "60px", textAlign: "center" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: "16px",
                      }}
                    >
                      <span style={{ fontSize: "48px" }}>📝</span>
                      <h4
                        style={{
                          margin: 0,
                          color: "#1a1f36",
                          fontSize: "18px",
                        }}
                      >
                        No remarks yet
                      </h4>
                      <p
                        style={{
                          margin: 0,
                          color: "#6b7280",
                          fontSize: "14px",
                        }}
                      >
                        Remarks will appear here once added
                      </p>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
};

const InputTable = ({
  documentData,
  submissionData = [],
  project,
  getProject,
  allData,
  i,
  id,
  getDocuments,
}) => {
  const [activeIndex, setActiveIndex] = useState(null);

  useEffect(() => {
    setActiveIndex(null);
  }, [project]);

  if (!submissionData || submissionData.length === 0) {
    return <p className="text-gray-600">No submission data available.</p>;
  }

  console.log("InputTable Data:", i);
  console.log("sUBMISISON Data:", submissionData);

  return (
    <div className="flex-row justify-between" style={{ width: "100%" }}>
      <div
        className="flex-row justify-between"
        style={{
          width: i.normal_input[0].input_type === "Stage type" ? `100%` : "60%",
          height: "70vh",
        }}
      >
        <div style={{ width: "100%" }}>
          <div
            className="box-shadow info-box-div-bg scroll-container-table child-table-scroll-progres scroll-hover"
            style={{
              height: "70vh",

              overflowY: "auto",
              overflowX: "hidden",
              borderRadius: "6px",
              padding: "4px",
            }}
          >
            {i.normal_input[0].input_type === "Stage type" ? (
              <table className="custom-table" style={{ width: "100%" }}>
                <thead className="table-heading">
                  <tr className="custom-table-head-tr">
                    <th className="table-heading-text text-start">Stages</th>
                    <th className="table-heading-text text-start">
                      Stage Name
                    </th>
                    <th className="table-heading-text text-start">
                      Stage Weightage
                    </th>
                    <th className="table-heading-text text-start">
                      Weightage Cost (in Cr)
                    </th>

                    <th className="table-heading-text text-start">
                      Work Completed
                    </th>
                    <th className="table-heading-text text-start">
                      Work Remaining
                    </th>
                    <th className="table-heading-text text-start">Status</th>
                    <th className="table-heading-text text-start">Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  {submissionData[0].stage.map((i, idx) => (
                    <>
                      <tr
                        className="custom-table-head-td global-table-td"
                        key={idx}
                      >
                        <td className="table-body text-left-sr">
                          Stage {idx + 1}.
                        </td>
                        <td className="table-body text-start">
                          {i.stage_name}
                        </td>
                        <td className="table-body text-start">
                          {i.stage_percentage}
                        </td>
                        <td className="table-body text-start">
                          ₹ {formatCurrencyIndian(i.stage_amount)}
                        </td>

                        <td className="table-body text-start">
                          <tr className="completedText">
                            <td className="table-body text-start">Percent</td>
                            <td
                              className="table-body text-start"
                              style={{ padding: "0px 5px" }}
                            >
                              :
                            </td>
                            <td className="table-body text-start">
                              {i.completed_percentage}%
                            </td>
                          </tr>
                          <tr className="completedText">
                            <td className="table-body text-start">
                              About to Bill
                            </td>
                            <td
                              className="table-body text-start"
                              style={{ padding: "0px 5px" }}
                            >
                              :
                            </td>
                            <td className="table-body text-start">
                              ₹ {formatCurrencyIndian(i.completed_work)}{" "}
                            </td>
                          </tr>
                        </td>
                        <td className="table-body text-start">
                          <tr className="removeText">
                            <td className="table-body text-start">Percent</td>
                            <td
                              className="table-body text-start"
                              style={{ padding: "0px 5px" }}
                            >
                              :
                            </td>
                            <td className="table-body text-start">
                              {i.remaining_percentage
                                ? i.remaining_percentage
                                : 0}
                              %
                            </td>
                          </tr>
                          <tr className="removeText">
                            <td className="table-body text-start">
                              Remaining Amount
                            </td>
                            <td
                              className="table-body text-start"
                              style={{ padding: "0px 5px" }}
                            >
                              :
                            </td>
                            <td className="table-body text-start">
                              ₹ {formatCurrencyIndian(i.remaining_work)}{" "}
                            </td>
                          </tr>
                        </td>

                        <td className="table-body text-start">{i.status}</td>
                        <td className="table-body text-start">
                          <RemarksSection
                            stages={i.remarks}
                            input_type={submissionData[0].input_type}
                          />
                        </td>
                      </tr>
                    </>
                  ))}
                </tbody>
                <tfoot
                  style={{
                    position: "sticky",
                    bottom: 0,
                    zIndex: 2,
                    // height: "0vh",
                    backgroundColor: "#f8f9fa", // Different color to distinguish
                    borderTop: "2px solid #dee2e6",
                  }}
                >
                  <tr className="custom-table-head-td global-table-td">
                    <td
                      className="table-body text-start"
                      style={{ fontWeight: "bold" }}
                      colSpan={2}
                    >
                      Total
                    </td>
                    <td
                      colSpan={1}
                      className="table-body text-start"
                      style={{ fontWeight: "bold" }}
                    >
                      {submissionData[0].stage.reduce(
                        (total, item) =>
                          total + Number(item.stage_percentage || 0),
                        0,
                      )}
                    </td>
                    <td
                      colSpan={1}
                      className="table-body text-start"
                      style={{ fontWeight: "bold" }}
                    >
                      ₹{" "}
                      {formatCurrencyIndian(
                        submissionData[0].stage.reduce(
                          (total, item) =>
                            total + Number(item.stage_amount || 0),
                          0,
                        ),
                      )}
                    </td>
                    <td className="table-body text-start">
                      <tr className="completedText">
                        <td className="table-body text-start">
                          About to Bill{" "}
                        </td>
                        <td
                          className="table-body text-start"
                          style={{ padding: "0px 5px" }}
                        >
                          :
                        </td>
                        <td className="table-body text-start">
                          ₹{" "}
                          {formatCurrencyIndian(
                            submissionData[0].stage.reduce(
                              (total, item) =>
                                total + Number(item.completed_work || 0),
                              0,
                            ),
                          )}
                        </td>
                      </tr>
                    </td>
                    <td className="table-body text-start">
                      <tr className="completedText">
                        <td className="table-body text-start">
                          Remaining Amount{" "}
                        </td>
                        <td
                          className="table-body text-start"
                          style={{ padding: "0px 5px" }}
                        >
                          :
                        </td>
                        <td className="table-body text-start">
                          ₹{" "}
                          {formatCurrencyIndian(
                            submissionData[0].stage.reduce(
                              (total, item) =>
                                total + Number(item.remaining_work || 0),
                              0,
                            ),
                          )}
                        </td>
                      </tr>
                    </td>
                    <td></td>
                    <td></td>
                  </tr>
                </tfoot>
              </table>
            ) : i.normal_input[0].input_type === "Normal Input" ? (
              <table
                className="custom-table"
                style={{
                  width: "100%",
                  borderCollapse: "separate",
                  borderSpacing: "0 10px",
                }}
              >
                <thead className="table-heading">
                  <tr className="custom-table-head-tr">
                    <th
                      className="table-heading-text text-start"
                      style={{
                        padding: "12px 16px",
                        backgroundColor: "#f8f9fa",
                      }}
                    >
                      S.no.
                    </th>
                    <th
                      className="table-heading-text text-start"
                      style={{
                        padding: "12px 16px",
                        backgroundColor: "#f8f9fa",
                      }}
                    >
                      Input Details
                    </th>
                    <th
                      className="table-heading-text text-start"
                      style={{
                        padding: "12px 16px",
                        backgroundColor: "#f8f9fa",
                      }}
                    >
                      Work Completed
                    </th>
                    <th
                      className="table-heading-text text-start"
                      style={{
                        padding: "12px 16px",
                        backgroundColor: "#f8f9fa",
                      }}
                    >
                      Work Remaining
                    </th>
                    <th
                      className="table-heading-text text-start"
                      style={{
                        padding: "12px 16px",
                        backgroundColor: "#f8f9fa",
                      }}
                    >
                      Status
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {submissionData.map((i, idx) => (
                    <tr
                      className="custom-table-head-td global-table-td"
                      key={idx}
                      style={{
                        backgroundColor: "white",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                        borderRadius: "8px",
                        transition: "all 0.3s ease",
                      }}
                    >
                      {/* S.No. Column */}
                      <td
                        className="table-body text-left-sr"
                        style={{
                          padding: "20px 16px",
                          fontWeight: "600",
                          color: "#4a5568",
                          fontSize: "16px",
                          borderTopLeftRadius: "8px",
                          borderBottomLeftRadius: "8px",
                        }}
                      >
                        {idx + 1}.
                      </td>

                      {/* Input Details Column */}
                      {i.input_type === "Normal Input" ? (
                        <td
                          className="table-body text-start"
                          style={{
                            padding: "20px 16px",
                            backgroundColor: "white",
                            verticalAlign: "top",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "12px",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "baseline",
                              }}
                            >
                              <span
                                style={{
                                  minWidth: "100px",
                                  color: "#718096",
                                  fontSize: "14px",
                                }}
                              >
                                Total Value
                              </span>
                              <span
                                style={{ margin: "0 10px", color: "#a0aec0" }}
                              >
                                :
                              </span>
                              <span
                                style={{ fontWeight: "600", color: "#2d3748" }}
                              >
                                {i.total_value}
                              </span>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "baseline",
                              }}
                            >
                              <span
                                style={{
                                  minWidth: "100px",
                                  color: "#718096",
                                  fontSize: "14px",
                                }}
                              >
                                Total Cost
                              </span>
                              <span
                                style={{ margin: "0 10px", color: "#a0aec0" }}
                              >
                                :
                              </span>
                              <span
                                style={{ fontWeight: "600", color: "#2d3748" }}
                              >
                                {formatCurrencyIndian(i.cost)}{" "}
                              </span>
                            </div>
                          </div>
                        </td>
                      ) : (
                        <td
                          className="table-body text-start"
                          style={{
                            padding: "20px 16px",
                            color: "#a0aec0",
                            fontStyle: "italic",
                          }}
                        >
                          No input details available
                        </td>
                      )}

                      {/* Work Completed Column */}
                      <td
                        className="table-body text-start"
                        style={{
                          padding: "20px 16px",
                          backgroundColor: "#f0fff4",
                          verticalAlign: "top",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "12px",
                          }}
                        >
                          <div
                            style={{ display: "flex", alignItems: "baseline" }}
                          >
                            <span
                              style={{
                                minWidth: "100px",
                                color: "#2f855a",
                                fontSize: "14px",
                              }}
                            >
                              Covered Value
                            </span>
                            <span
                              style={{ margin: "0 10px", color: "#9ae6b4" }}
                            >
                              :
                            </span>
                            <span
                              style={{ fontWeight: "600", color: "#22543d" }}
                            >
                              {i.covered_value}
                            </span>
                          </div>
                          <div
                            style={{ display: "flex", alignItems: "baseline" }}
                          >
                            <span
                              style={{
                                minWidth: "100px",
                                color: "#2f855a",
                                fontSize: "14px",
                              }}
                            >
                              Percent
                            </span>
                            <span
                              style={{ margin: "0 10px", color: "#9ae6b4" }}
                            >
                              :
                            </span>
                            <span
                              style={{ fontWeight: "600", color: "#22543d" }}
                            >
                              {i.work_done || 0}%
                            </span>
                          </div>
                          <div
                            style={{ display: "flex", alignItems: "baseline" }}
                          >
                            <span
                              style={{
                                minWidth: "100px",
                                color: "#2f855a",
                                fontSize: "14px",
                              }}
                            >
                              About To Bill
                            </span>
                            <span
                              style={{ margin: "0 10px", color: "#9ae6b4" }}
                            >
                              :
                            </span>
                            <span
                              style={{ fontWeight: "600", color: "#22543d" }}
                            >
                              ₹ {formatCurrencyIndian(i.about_to_bill)}{" "}
                            </span>
                          </div>
                        </div>
                      </td>

                      {/* Work Remaining Column */}
                      <td
                        className="table-body text-start"
                        style={{
                          padding: "20px 16px",
                          backgroundColor: "#fff5f5",
                          verticalAlign: "top",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "12px",
                          }}
                        >
                          <div
                            style={{ display: "flex", alignItems: "baseline" }}
                          >
                            <span
                              style={{
                                minWidth: "120px",
                                color: "#c53030",
                                fontSize: "14px",
                              }}
                            >
                              Remaining Value
                            </span>
                            <span
                              style={{ margin: "0 10px", color: "#feb2b2" }}
                            >
                              :
                            </span>
                            <span
                              style={{ fontWeight: "600", color: "#742a2a" }}
                            >
                              {i.remaining_value}
                            </span>
                          </div>
                          <div
                            style={{ display: "flex", alignItems: "baseline" }}
                          >
                            <span
                              style={{
                                minWidth: "120px",
                                color: "#c53030",
                                fontSize: "14px",
                              }}
                            >
                              Percent
                            </span>
                            <span
                              style={{ margin: "0 10px", color: "#feb2b2" }}
                            >
                              :
                            </span>
                            <span
                              style={{ fontWeight: "600", color: "#742a2a" }}
                            >
                              {i.pending_work || 0}%
                            </span>
                          </div>
                          <div
                            style={{ display: "flex", alignItems: "baseline" }}
                          >
                            <span
                              style={{
                                minWidth: "120px",
                                color: "#c53030",
                                fontSize: "14px",
                              }}
                            >
                              Remaining Amount
                            </span>
                            <span
                              style={{ margin: "0 10px", color: "#feb2b2" }}
                            >
                              :
                            </span>
                            <span
                              style={{ fontWeight: "600", color: "#742a2a" }}
                            >
                              ₹ {formatCurrencyIndian(i.remaining_amount)}{" "}
                            </span>
                          </div>
                        </div>
                      </td>

                      {/* Status Column */}
                      <td
                        className={`table-body text-start`}
                        style={{
                          padding: "20px 16px",
                          backgroundColor: "white",
                          borderTopRightRadius: "8px",
                          borderBottomRightRadius: "8px",
                          verticalAlign: "middle",
                        }}
                      >
                        <span
                          style={{
                            backgroundColor:
                              i.status === "pending" ? "#fed7d7" : "#c6f6d5",
                            color:
                              i.status === "pending" ? "#c53030" : "#22543d",
                            padding: "8px 16px",
                            borderRadius: "20px",
                            fontWeight: "600",
                            fontSize: "14px",
                            display: "inline-block",
                            textTransform: "capitalize",
                          }}
                        >
                          {i.status}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <table
                className="custom-table"
                style={{
                  width: "100%",
                  borderCollapse: "separate",
                  borderSpacing: "0 10px",
                }}
              >
                <thead className="table-heading">
                  <tr className="custom-table-head-tr">
                    <th
                      className="table-heading-text text-start"
                      style={{
                        padding: "12px 16px",
                        backgroundColor: "#f8f9fa",
                      }}
                    >
                      S.no.
                    </th>
                    <th
                      className="table-heading-text text-start"
                      style={{
                        padding: "12px 16px",
                        backgroundColor: "#f8f9fa",
                      }}
                    >
                      Cost
                    </th>
                    <th
                      className="table-heading-text text-start"
                      style={{
                        padding: "12px 16px",
                        backgroundColor: "#f8f9fa",
                      }}
                    >
                      Document Name
                    </th>
                    <th
                      className="table-heading-text text-start"
                      style={{
                        padding: "12px 16px",
                        backgroundColor: "#f8f9fa",
                      }}
                    >
                      Document File
                    </th>
                    <th
                      className="table-heading-text text-start"
                      style={{
                        padding: "12px 16px",
                        backgroundColor: "#f8f9fa",
                      }}
                    >
                      Status
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {submissionData.map((i, idx) => (
                    <tr
                      className="custom-table-head-td global-table-td"
                      key={idx}
                      style={{
                        backgroundColor: "white",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                        borderRadius: "8px",
                        transition: "all 0.3s ease",
                      }}
                    >
                      {/* S.No. Column */}
                      <td
                        className="table-body text-left-sr"
                        style={{
                          padding: "20px 16px",
                          fontWeight: "600",
                          color: "#4a5568",
                          fontSize: "16px",
                          borderTopLeftRadius: "8px",
                          borderBottomLeftRadius: "8px",
                        }}
                      >
                        {idx + 1}.
                      </td>

                      <td
                        className="table-body text-start"
                        style={{
                          padding: "20px 16px",
                          verticalAlign: "top",
                        }}
                      >
                        ₹ {formatCurrencyIndian(i.cost)}
                      </td>
                      <td
                        className="table-body text-start"
                        style={{
                          padding: "20px 16px",
                          verticalAlign: "top",
                        }}
                      >
                        {i.document_name}
                      </td>
                      <td
                        className="table-body text-start"
                        style={{
                          padding: "20px 16px",
                          verticalAlign: "top",
                        }}
                      >
                        {(() => {
                          const docs = documentData.filter(
                            (doc) => doc.input_id === i.id,
                          );
                          return docs.length > 0 ? (
                            docs.map((doc, dIdx) => (
                              <a
                                key={doc.id || dIdx}
                                href={doc.document_file}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ marginRight: "12px" }}
                              >
                                {doc.filename || `Document ${dIdx + 1}`}
                              </a>
                            ))
                          ) : (
                            <span style={{ color: "#999" }}>No documents</span>
                          );
                        })()}
                      </td>

                      {/* Status Column */}
                      <td
                        className={`table-body text-start`}
                        style={{
                          padding: "20px 16px",
                          backgroundColor: "white",
                          borderTopRightRadius: "8px",
                          borderBottomRightRadius: "8px",
                          verticalAlign: "middle",
                        }}
                      >
                        <span
                          style={{
                            backgroundColor:
                              i.status === "pending" ? "#fed7d7" : "#c6f6d5",
                            color:
                              i.status === "pending" ? "#c53030" : "#22543d",
                            padding: "8px 16px",
                            borderRadius: "20px",
                            fontWeight: "600",
                            fontSize: "14px",
                            display: "inline-block",
                            textTransform: "capitalize",
                          }}
                        >
                          {i.status}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
      {i.normal_input[0].input_type === "Normal Input" && (
        <div
          className="flex-row justify-between"
          style={{ width: `37%`, height: "40vh" }}
        >
          <div style={{ width: "100%" }}>
            <div
              className="box-shadow info-box-div-bg scroll-container-table child-table-scroll-progres scroll-hover"
              style={{
                height: "70vh",
                overflowY: "auto",
                overflowX: "hidden",
                borderRadius: "6px",
                padding: "4px",
              }}
            >
              <RemarksSection
                submissionData={submissionData[0].remarks}
                input_type={i.normal_input[0].input_type}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
const StageTable = ({
  documentData,
  submissionData = [],
  project,
  getProject,
  allData,
  i,
  id,
  getDocuments,
}) => {
  const [activeIndex, setActiveIndex] = useState(null);

  if (!submissionData || submissionData.length === 0) {
    return <p className="text-gray-600">No data available.</p>;
  }

  return (
    <>
      <div
        className="flex-row justify-between "
        style={{ width: `100%`, height: "70vh" }}
      >
        <div style={{ width: "100%" }}>
          <div
            className="box-shadow info-box-div-bg scroll-container-table child-table-scroll-progres scroll-hover"
            style={{
              height: "70vh",
              overflowY: "auto",
              overflowX: "hidden",
              borderRadius: "6px",
              padding: "4px",
            }}
          >
            <table className="custom-table" style={{ width: "100%" }}>
              <thead className="table-heading">
                <tr className="custom-table-head-tr">
                  <th className="table-heading-text text-start">Stages</th>
                  <th className="table-heading-text text-start">Stage Name</th>
                  <th className="table-heading-text text-start">
                    Stage Weightage
                  </th>
                  <th className="table-heading-text text-start">
                    Weightage Cost (in Cr)
                  </th>

                  <th className="table-heading-text text-start">
                    Work Completed
                  </th>
                  <th className="table-heading-text text-start">
                    Work Remaining
                  </th>
                  <th className="table-heading-text text-start">Status</th>
                  <th className="table-heading-text text-start">Remarks</th>
                </tr>
              </thead>
              <tbody>
                {submissionData.map((i, idx) => (
                  <>
                    <tr
                      className="custom-table-head-td global-table-td"
                      key={idx}
                    >
                      <td className="table-body text-left-sr">
                        Stage {idx + 1}.
                      </td>
                      <td className="table-body text-start">{i.stage_name}</td>
                      <td className="table-body text-start">{i.percentage}</td>
                      <td className="table-body text-start">
                        ₹ {i.stage_amount}
                      </td>

                      <td className="table-body text-start">
                        <tr className="completedText">
                          <td className="table-body text-start">Percent</td>
                          <td
                            className="table-body text-start"
                            style={{ padding: "0px 5px" }}
                          >
                            :
                          </td>
                          <td className="table-body text-start">
                            {i.completed_percentage}%
                          </td>
                        </tr>
                        <tr className="completedText">
                          <td className="table-body text-start">
                            About to Bill
                          </td>
                          <td
                            className="table-body text-start"
                            style={{ padding: "0px 5px" }}
                          >
                            :
                          </td>
                          <td className="table-body text-start">
                            ₹ {i.completed_work}{" "}
                          </td>
                        </tr>
                      </td>
                      <td className="table-body text-start">
                        <tr className="removeText">
                          <td className="table-body text-start">Percent</td>
                          <td
                            className="table-body text-start"
                            style={{ padding: "0px 5px" }}
                          >
                            :
                          </td>
                          <td className="table-body text-start">
                            {i.remaining_percentage
                              ? i.remaining_percentage
                              : 0}
                            %
                          </td>
                        </tr>
                        <tr className="removeText">
                          <td className="table-body text-start">
                            Remaining Amount
                          </td>
                          <td
                            className="table-body text-start"
                            style={{ padding: "0px 5px" }}
                          >
                            :
                          </td>
                          <td className="table-body text-start">
                            ₹ {i.remaining_work}{" "}
                          </td>
                        </tr>
                      </td>

                      <td className="table-body text-start">{i.status}</td>
                      <td className="table-body text-start">
                        <RemarksSection
                          stages={i.remarks}
                          input_type="Stage type"
                        />
                      </td>
                    </tr>
                  </>
                ))}
              </tbody>
              <tfoot
                style={{
                  position: "sticky",
                  bottom: 0,
                  zIndex: 2,
                  // height: "0vh",
                  backgroundColor: "#f8f9fa", // Different color to distinguish
                  borderTop: "2px solid #dee2e6",
                }}
              >
                <tr className="custom-table-head-td global-table-td">
                  <td
                    className="table-body text-start"
                    style={{ fontWeight: "bold" }}
                    colSpan={2}
                  >
                    Total
                  </td>
                  <td
                    colSpan={1}
                    className="table-body text-start"
                    style={{ fontWeight: "bold" }}
                  >
                    {submissionData.reduce(
                      (total, item) => total + Number(item.percentage || 0),
                      0,
                    )}
                  </td>
                  <td
                    colSpan={1}
                    className="table-body text-start"
                    style={{ fontWeight: "bold" }}
                  >
                    ₹{" "}
                    {submissionData.reduce(
                      (total, item) => total + Number(item.stage_amount || 0),
                      0,
                    )}
                  </td>
                  <td className="table-body text-start">
                    <tr className="completedText">
                      <td className="table-body text-start">About to Bill </td>
                      <td
                        className="table-body text-start"
                        style={{ padding: "0px 5px" }}
                      >
                        :
                      </td>
                      <td className="table-body text-start">
                        ₹{" "}
                        {submissionData
                          .reduce(
                            (total, item) =>
                              total + Number(item.completed_work || 0),
                            0,
                          )
                          .toFixed(2)}
                      </td>
                    </tr>
                  </td>
                  <td className="table-body text-start">
                    <tr className="completedText">
                      <td className="table-body text-start">
                        Remaining Amount{" "}
                      </td>
                      <td
                        className="table-body text-start"
                        style={{ padding: "0px 5px" }}
                      >
                        :
                      </td>
                      <td className="table-body text-start">
                        ₹{" "}
                        {submissionData
                          .reduce(
                            (total, item) =>
                              total + Number(item.remaining_work || 0),
                            0,
                          )
                          .toFixed(2)}
                      </td>
                    </tr>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

const StageStatusChart = ({ title, submissionData = [] }) => {
  if (!submissionData || submissionData.length === 0) {
    return <p className="text-gray-600">No data to display chart.</p>;
  }

  // ✅ Calculate counts for statuses
  const completedCount = submissionData.filter(
    (item) => item.status?.toLowerCase() === "completed",
  ).length;

  const pendingCount = submissionData.filter(
    (item) =>
      item.status?.toLowerCase() === "pending" ||
      item.status?.toLowerCase() === "not started",
  ).length;

  const total = completedCount + pendingCount;

  if (total === 0) {
    return <p className="text-gray-600">No valid status data.</p>;
  }

  const data = [
    { name: "Completed", value: completedCount },
    { name: "Pending", value: pendingCount },
  ];

  const COLORS = ["#4CAF50", "#F44336", "#FFC107"]; // Green / Red / Yellow

  return (
    <div className="chart-container" style={{ width: "100%", height: 280 }}>
      <h5 className="font-weight600 text-center mb-3">{title}</h5>
      <ResponsiveContainer>
        <PieChart>
          <Pie
            data={data}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            outerRadius={100}
            label={({ name, value }) =>
              `${name}: ${((value / total) * 100).toFixed(1)}%`
            }
          >
            {data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={COLORS[index % COLORS.length]}
              />
            ))}
          </Pie>
          <Tooltip
            formatter={(value, name) => [
              `${value} (${((value / total) * 100).toFixed(1)}%)`,
              name,
            ]}
          />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

const WorkstatsToggle = ({
  documentData,
  workstat,
  project,
  getProject,
  subconsultant_details,
  allData,
  getDocuments,
  sector,
}) => {
  const RAILWAY_SECTOR_UUID = "a00ab7e2-34cd-43e3-96f0-f9ee15caa6e7";
  const isRailway = sector === RAILWAY_SECTOR_UUID;
  const PaymentComponent = isRailway ? RailwayPayment : SubmissionPayment;
  const [activeId, setActiveId] = useState(null);
  const activeIdRef = useRef(null);

  const handleToggle = (id) => {
    const next = activeIdRef.current === id ? null : id;
    activeIdRef.current = next;
    setActiveId(next);
  };

  useEffect(() => {
    if (activeIdRef.current !== null) {
      setActiveId(activeIdRef.current);
    }
  }, [workstat]);

  if (!workstat || !allData) return null;
  // 🔹 Helper to determine color based on completion status
  const getStatusColor = (matched) => {
    let data = [];

    // Gather all relevant items for this workstage
    if (matched.workstage_inputtype === "Submission")
      data = matched.submission_data || [];
    else if (matched.workstage_inputtype === "Input")
      data = matched.normal_input || [];
    else if (matched.workstage_inputtype === "Stage")
      data = matched.stage || [];

    // Collect all statuses from these items
    const statuses = data.map((item) => item.status?.toLowerCase() || "");

    // Determine overall status
    if (statuses.includes("pending")) return "#dc2626"; // 🔴 red
    if (statuses.includes("completed")) return "#16a34a";
    else {
      return "#2576bc";
    } // 🟢 green
    // ⚪ gray default
  };

  console.log(allData, "AllData");

  return (
    <div className="info-box-div-bg mt-3">
      <h3 className="font-weight600 font-size-heading mb-3">
        Workstages of {allData.section_name}
      </h3>


      {/* ===================== Workstage Ordered List ===================== */}
      <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        {allData.workstat
          ?.filter((d) => allData.workstages?.includes(d.id))
          .map((matched, index) => {
            const isActive = activeId === matched.id;
            const color = getStatusColor(matched);

            const colorMeta =
              color === "#dc2626"
                ? { bg: "#fee2e2", label: "Pending" }
                : color === "#16a34a"
                  ? { bg: "#dcfce7", label: "Completed" }
                  : { bg: "#eff6ff", label: "In progress" };

            const totalAboutToBill =
              matched.stage?.reduce(
                (total, item) => total + Number(item.completed_work || 0),
                0,
              ) || 0;

            return (
              <div
                key={matched.id}
                style={{
                  background: "#fff",
                  border: isActive ? "1px solid #2576bc" : "1px solid #e8ecf0",
                  borderRadius: "6px",
                  overflow: "hidden",
                  boxShadow: isActive ? "0 2px 8px rgba(37,118,188,0.12)" : "none",
                }}
              >
                {/* Clickable row */}
                <div
                  onClick={() => handleToggle(matched.id)}
                  style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
                >
                  {/* Left color bar */}
                  <div style={{ width: "4px", alignSelf: "stretch", background: color, flexShrink: 0 }} />

                  {/* Number circle */}
                  <div style={{
                    width: "44px", display: "flex", alignItems: "center",
                    justifyContent: "center", padding: "14px 0",
                    borderRight: "1px solid #f0f2f5", flexShrink: 0,
                  }}>
                    <div style={{
                      width: "26px", height: "26px", borderRadius: "50%",
                      display: "flex", alignItems: "center", justifyContent: "center",
                      fontSize: "11px", fontWeight: 600,
                      background: colorMeta.bg, color: color,
                    }}>
                      {index + 1}
                    </div>
                  </div>

                  {/* Name + badges */}
                  <div style={{
                    flex: 1, padding: "12px 14px",
                    display: "flex", alignItems: "center",
                    justifyContent: "space-between", gap: "12px",
                  }}>
                    <span style={{ fontSize: "13px", color: "#1e293b", fontWeight: 500, lineHeight: 1.5 }}>
                      {matched.name}
                    </span>
                    <div style={{ display: "flex", alignItems: "center", gap: "10px", flexShrink: 0 }}>
                      <span style={{
                        fontSize: "12px", fontWeight: 600, color: "#64748b",
                        background: "#f1f5f9", padding: "3px 8px", borderRadius: "4px",
                      }}>
                        {Number(matched.percentage) || 0}%
                      </span>
                      <span style={{
                        fontSize: "11px", fontWeight: 600, padding: "3px 10px",
                        borderRadius: "20px", background: colorMeta.bg, color: color,
                      }}>
                        {colorMeta.label}
                      </span>
                      <span style={{ color: "#94a3b8", fontSize: "12px" }}>
                        {isActive ? "▲" : "▼"}
                      </span>
                    </div>
                  </div>
                </div>

                {/* ===================== Expanded Content ===================== */}
                {isActive && (
                  <div style={{ borderTop: "1px solid #e8ecf0", background: "#f8fafc" }}>
                    <div className="workstage-body mt-2 p-4 rounded bg-white">

                      {matched.workstage_inputtype === "Submission" && (
                        <>
                          <div style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: "10px 14px",
                            background: "#f5f7fa",
                            border: "0.5px solid #e0e0e0",
                            borderRadius: "6px",
                            marginBottom: "12px",
                          }}>
                            <span style={{ fontSize: "12px", fontWeight: 500, color: "#555" }}>
                              Submission Workstage
                            </span>
                            <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                              <AddSubmission
                                submissionItem={matched.submission_data?.[0]}
                                project={project}
                                getProject={getProject}
                                subconsultant_details={subconsultant_details}
                                allData={allData}
                                i={matched}
                                id={matched.id}
                              />
                              <PaymentComponent
                                status={matched.status}
                                project={project}
                                getProject={getProject}
                                allData={allData}
                                i={matched}
                                id={matched.id}
                                type="submission"
                                getDocuments={getDocuments}
                                documentData={documentData}
                              />
                            </div>
                          </div>
                          <SubmissionTable
                            submissionData={matched.submission_data}
                            project={project}
                            getProject={getProject}
                            allData={allData}
                            i={matched}
                            documentData={documentData}
                            getDocuments={getDocuments}
                            id={matched.id}
                          />
                        </>
                      )}

                      {matched.workstage_inputtype === "Input" && (
                        <>
                          <div style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: "10px 14px",
                            background: "#f5f7fa",
                            border: "0.5px solid #e0e0e0",
                            borderRadius: "6px",
                            marginBottom: "12px",
                          }}>
                            <span style={{ fontSize: "12px", fontWeight: 500, color: "#555" }}>
                              Input Workstage
                            </span>
                            <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                              <AddinputData
                                submissionItem={matched.normal_input?.[0]}
                                project={project}
                                getProject={getProject}
                                subconsultant_details={subconsultant_details}
                                allData={allData}
                                i={matched}
                                id={matched.id}
                                documentData={documentData}
                                getDocuments={getDocuments}
                              />
                              {matched.normal_input?.[0]?.input_type === "document" ? (
                                <>
                                  {matched.normal_input?.[0]?.status === "completed" && (
                                    <PaymentComponent
                                      type="Input"
                                      stageData={matched}
                                      totalStageCost={matched.cost}
                                      i={matched}
                                      project={project}
                                      allData={allData}
                                      getProject={getProject}
                                    />
                                  )}
                                </>
                              ) : (
                                <PaymentComponent
                                  type="Input"
                                  stageData={matched}
                                  totalStageCost={matched.cost}
                                  i={matched}
                                  project={project}
                                  allData={allData}
                                  getProject={getProject}
                                />
                              )}
                            </div>
                          </div>
                          <div className="flex-row">
                            <InputTable
                              submissionData={matched.normal_input}
                              project={project}
                              getProject={getProject}
                              allData={allData}
                              i={matched}
                              documentData={documentData}
                              getDocuments={getDocuments}
                              id={matched.id}
                            />
                          </div>
                        </>
                      )}

                      {matched.workstage_inputtype === "Stage" && (
                        <>
                          <div style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: "10px 14px",
                            background: "#f5f7fa",
                            border: "0.5px solid #e0e0e0",
                            borderRadius: "6px",
                            marginBottom: "12px",
                          }}>
                            <span style={{ fontSize: "12px", fontWeight: 500, color: "#555" }}>
                              Stage Workstage
                            </span>
                            <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                              <AddStagesData
                                submissionItem={matched.stage?.[0]}
                                project={project}
                                getProject={getProject}
                                subconsultant_details={subconsultant_details}
                                allData={allData}
                                i={matched}
                                id={matched.id}
                                documentData={documentData}
                                getDocuments={getDocuments}
                              />
                              <PaymentComponent
                                type="Stage"
                                stageData={matched}
                                totalStageCost={matched.cost}
                                totalCompleted={totalAboutToBill}
                                i={matched}
                                project={project}
                                allData={allData}
                                getProject={getProject}
                              />
                            </div>
                          </div>
                          <div className="flex-row" style={{ width: "100%" }}>
                            <StageTable
                              submissionData={matched.stage}
                              project={project}
                              getProject={getProject}
                              allData={allData}
                              i={matched}
                              documentData={documentData}
                              getDocuments={getDocuments}
                              id={matched.id}
                            />
                          </div>
                        </>
                      )}

                    </div>
                  </div>
                )}
              </div>
            );
          })}
      </div>
    </div>
  );
};

const ProjectAllDetails = () => {
  const location = useLocation();

  const projectIdd = location.state?.project?.id
    ? location.state?.project?.id
    : location?.state?.project;
  const [buffer, setBuffering] = useState(false);
  const [projectData, setProjectsData] = useState([]);

  const [documentData, setDocumentdata] = useState([]);
  const [activeTab, setActiveTab] = useState("workstages");

  const getDocuments = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/dpr/document/`, AUTH());
      setDocumentdata(res.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getDocuments();
  }, []);

  // AFTER
  const getProjects = async () => {
    const scrollY = window.scrollY;
    setBuffering(true);
    try {
      const proj = await axios.get(
        `${BASE_URL}/dpr/projectfilterbyid/${projectIdd}/`,
        AUTH()
      );
      // ✅ Derive costs before storing — always reflects latest project cost
      setProjectsData(proj.data);
    } catch (err) {
      console.error(err);
    } finally {
      setBuffering(false);
      requestAnimationFrame(() => {
        window.scrollTo({ top: scrollY, behavior: "instant" });
      });
    }
  };

  useEffect(() => {
    if (projectIdd != undefined && projectIdd != "") {
      getProjects();
    }
  }, [projectIdd]);

  const [openStage, setOpenStage] = useState(null);
  const toggleWorkstage = (id) => {
    setOpenStage((prev) => (prev === id ? null : id));
  };
  const [calculations, setCalculations] = useState({
    completedCost: 0,
    sectionCost: 0,
    remainingValue: 0,
    breakdown: [],
    claimed: 0,
    received: 0,
    deduction: 0,
    balanceToClaim: 0,
    balanceToReceive: 0,
  });

  useEffect(() => {
    if (projectData && projectData.length > 0) {
      calculateSectionCosts(projectData[0]);
    }
  }, [projectData]);

  const calculateSectionCosts = (data) => {
    let totalCompletedCost = 0;
    const breakdownItems = [];
    const sectionCost = parseFloat(data?.section_cost || 0);

    // ── payment accumulators ──
    let totalClaimed = 0;
    let totalReceived = 0;
    let totalDeduction = 0;
    let totalBalanceToClaim = 0;
    let totalBalanceToReceive = 0;

    const addPayment = (pd) => {
      if (!pd) return;
      totalClaimed += parseFloat(pd.billingClaimedAmount || 0);
      totalReceived += parseFloat(pd.billingReceivedAmount || 0);
      totalDeduction += parseFloat(pd.totalDeductionAmount || 0);
      totalBalanceToClaim += parseFloat(pd.balanceToClaimAmount || 0);
      totalBalanceToReceive += parseFloat(pd.balanceToReceiveAmount || 0);
    };

    data?.workstat?.forEach((workstage) => {
      const workstageType = workstage.workstage_inputtype;
      const workstageName = workstage.name;
      let workstageCompletedCost = 0;
      let workstageDetails = [];

      // ── INPUT type ──────────────────────────────────────────────────────
      if (workstageType === "Input") {
        // Payment lives on the workstage-level paymentData for Input
        addPayment(workstage.paymentData);

        workstage.normal_input?.forEach((inputItem) => {
          const inputType = inputItem.input_type;

          if (inputType === "Stage type") {
            inputItem.stage?.forEach((stageItem) => {
              const completedWork = parseFloat(stageItem.completed_work || 0);
              totalCompletedCost += completedWork;
              workstageCompletedCost += completedWork;
              workstageDetails.push({
                item: stageItem.stage_name || "Unnamed Stage",
                amount: completedWork,
                percentage: stageItem.completed_percentage,
                status: stageItem.status,
                stageAmount: stageItem.stage_amount,
                inputType: "Stage type",
                calculationMethod: "completed_work",
              });
            });

          } else if (inputType === "Normal Input") {
            if (inputItem.about_to_bill) {
              const aboutToBill = parseFloat(inputItem.about_to_bill || 0);
              totalCompletedCost += aboutToBill;
              workstageCompletedCost += aboutToBill;
              workstageDetails.push({
                item: inputItem.document_name || "Normal Input",
                amount: aboutToBill,
                type: inputType,
                calculationMethod: "about_to_bill",
              });
            }

          } else if (inputType === "document") {
            if (inputItem.status === "completed") {
              const completedAmount = parseFloat(inputItem.cost || 0);
              totalCompletedCost += completedAmount;
              workstageCompletedCost += completedAmount;
              workstageDetails.push({
                item: inputItem.document_name || "Document",
                amount: completedAmount,
                type: inputType,
                status: inputItem.status,
                calculationMethod: "cost",
                originalCost: inputItem.cost,
              });
            }
          }
        });

        if (workstageCompletedCost > 0) {
          breakdownItems.push({
            name: workstageName,
            type: "Input",
            completedCost: workstageCompletedCost,
            details: workstageDetails,
            summary: `${workstageDetails.length} item(s) — ₹${workstageCompletedCost.toFixed(2)}`,
          });
        }

        // ── STAGE type ───────────────────────────────────────────────────────
      } else if (workstageType === "Stage") {
        // Payment lives on the workstage-level paymentData for Stage
        addPayment(workstage.paymentData);

        workstage.stage?.forEach((stageItem) => {
          const completedWork = parseFloat(stageItem.completed_work || 0);
          totalCompletedCost += completedWork;
          workstageCompletedCost += completedWork;
          workstageDetails.push({
            item: stageItem.stage_name || "Unnamed Stage",
            amount: completedWork,
            percentage: stageItem.completed_percentage,
            status: stageItem.status,
          });
        });

        if (workstageCompletedCost > 0) {
          breakdownItems.push({
            name: workstageName,
            type: "Stage",
            completedCost: workstageCompletedCost,
            details: workstageDetails,
            summary: `${workstageDetails.length} stages — ₹${workstageCompletedCost.toFixed(2)}`,
          });
        }

        // ── SUBMISSION type ──────────────────────────────────────────────────
      } else if (workstageType === "Submission") {
        // ⚠️ Payment lives inside each submission_data[].paymentData
        // NOT on the workstage-level paymentData
        getPaymentSources(workstage).forEach((src) => addPayment(src.pd));
        workstage.submission_data?.forEach((submissionItem) => {
          // aggregate payment from each submission's own paymentData
          if (submissionItem.status === "completed") {
            const cost = parseFloat(submissionItem.cost || 0);
            totalCompletedCost += cost;
            workstageCompletedCost += cost;
            workstageDetails.push({
              item: submissionItem.submissionName || "Unnamed Submission",
              amount: cost,
              status: submissionItem.status,
            });
          }
        });

        if (workstageCompletedCost > 0) {
          breakdownItems.push({
            name: workstageName,
            type: "Submission",
            completedCost: workstageCompletedCost,
            details: workstageDetails,
            summary: `${workstageDetails.length} submissions — ₹${workstageCompletedCost.toFixed(2)}`,
          });
        }
      }
    });

    const remainingValue = sectionCost - totalCompletedCost;

    setCalculations({
      completedCost: Number(totalCompletedCost.toFixed(2)),
      sectionCost,
      remainingValue: Number(remainingValue.toFixed(2)),
      breakdown: breakdownItems,
      claimed: Number(totalClaimed.toFixed(2)),
      received: Number(totalReceived.toFixed(2)),
      deduction: Number(totalDeduction.toFixed(2)),
      balanceToClaim: Number(totalBalanceToClaim.toFixed(2)),
      balanceToReceive: Number(totalBalanceToReceive.toFixed(2)),
    });
  };

  const [formData, setFormData] = useState({
    section_cost: "",
    about_to_bill: "",
    remaining_amount: "",
  });

  // useEffect(() => {
  //     setFormData((prev) => ({
  //         ...prev,
  //         // about_to_bill: aboutToBill,
  //         payment_recieved: 100000,
  //         remaining_amount: calculations.remainingValue
  //     }));
  // }, [calculations.completedCost, calculations.remainingValue]);

  const updateProject = async (data) => {
    try {
      const res = await axios.put(
        `${BASE_URL}/dpr/project/${projectData[0].id}/`,
        data,
        AUTH()
      );
    } catch (err) {
      console.error("Error updating project:", err);
      if (err.response?.data) {
        toast.error(`Failed: ${JSON.stringify(err.response.data)}`);
      } else {
        toast.error("Failed to update project");
      }
    }
  };
  const updateMainProject = async (data) => {
    try {
      const res = await axios.put(
        `${BASE_URL}/dpr/projectdetails/${projectData[0].project_details}/`,
        data,
        AUTH()
      );
      // console.log("Updated successfully", res.data);
    } catch (err) {
      console.error("Error updating project:", err);
      if (err.response?.data) {
        toast.error(`Failed: ${JSON.stringify(err.response.data)}`);
      } else {
        toast.error("Failed to update project");
      }
    }
  };

  // useEffect(() => {
  //   if (projectData?.[0]?.id) {
  //     const paymentReceived = projectData[0].payment_recieved
  //       ? parseFloat(projectData[0].payment_recieved)
  //       : 0;
  //     const aboutToBill = calculations.completedCost - paymentReceived;

  //     updateProject({
  //       about_to_bill: aboutToBill,
  //       remaining_amount: calculations.remainingValue,
  //       // ── payment summary fields ──
  //       claimed: calculations.claimed,
  //       received: calculations.received,
  //       deduction: calculations.deduction,
  //       balance_to_claim: calculations.balanceToClaim,
  //       balance_to_receive: calculations.balanceToReceive,
  //     });
  //   }
  // }, [calculations.completedCost, calculations.claimed]);


  return (
    <>

      <Dashboardnavbar name={`Project Details`} url="" />

      <div className="content-tabs">
        {projectData.map((i) => (
          <div
            key={i.id}
            className="info-box-div-bg"
            style={{ padding: 0, overflow: "hidden" }}
          >
            {/* ── Title band ── */}
            <div
              style={{
                padding: "16px 20px",
                borderBottom: "0.5px solid #e0e0e0",
              }}
            >
              <p
                style={{
                  fontSize: "11px",
                  color: "#888",
                  margin: "0 0 3px",
                  letterSpacing: "0.07em",
                  textTransform: "uppercase",
                }}
              >
                Project details
              </p>
              <h2
                className="jd-heading-main font-weight600 font-size-heading"
                style={{ margin: 0 }}
              >
                {i.project_details_data.pr_code} :{" "}
                {i.project_details_data.project_short_name}
              </h2>
              <div
                className="jd-heading-bottom-bold"
                style={{ marginTop: "6px" }}
              />
            </div>

            {/* ── Project name row ── */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                padding: "10px 20px",
                borderBottom: "0.5px solid #e0e0e0",
                background: "#f5f7fa",
              }}
            >
              <span
                className="personal-detail-1 font-weight500 font-size-text"
                style={{ minWidth: "110px" }}
              >
                Project name
              </span>
              <span className="font-weight500 font-size-text">
                {i.project_details_data.project_name}
              </span>
            </div>

            {/* ── Detail grid (3 rows × 4 cols) ── */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(4, 1fr)",
                borderBottom: "0.5px solid #e0e0e0",
              }}
            >
              {[
                { label: "Section name", value: i.section_name || "-" },
                {
                  label: "Section cost",
                  value: i.section_cost
                    ? `₹${formatCurrencyIndian(Number(i.section_cost / 100000).toFixed(2))} Lacs`
                    : "-",
                },
                {
                  label: "Department",
                  value: i.project_details_data.department || "-",
                },
                {
                  label: "LOA date",
                  value: i.project_details_data.loa_date || "-",
                },

                {
                  label: "Section length",
                  value: i.length ? `${i.length} KM` : "-",
                },
                {
                  label: "About to bill",
                  value: `₹${formatCurrencyIndian(Number(calculations.completedCost / 100000).toFixed(2))} Lacs`,
                  color: "#0F6E56",
                },
                {
                  label: "Work type",
                  value: i.project_details_data.worktype_details?.name || "-",
                },
                {
                  label: "Completion date",
                  value: i.project_details_data.completion_date || "-",
                },

                { label: "Location", value: i.location || "-" },
                {
                  label: "Remaining",
                  value: `₹${formatCurrencyIndian(Number(calculations.remainingValue / 100000).toFixed(2))} Lacs`,
                  color: "#A32D2D",
                },
                {
                  label: "Sector",
                  value: i.project_details_data.sector_details?.name || "-",
                },
                { label: "Status", value: "In progress", badge: true },
              ].map(({ label, value, color, badge }, idx) => {
                const col = idx % 4;
                const row = Math.floor(idx / 4);
                return (
                  <div
                    key={idx}
                    style={{
                      padding: "13px 20px",
                      borderRight: col !== 3 ? "0.5px solid #e0e0e0" : "none",
                      borderTop: row !== 0 ? "0.5px solid #e0e0e0" : "none",
                    }}
                  >
                    <p style={{ fontSize: "11px", color: "#888", margin: "0 0 4px" }}>
                      {label}
                    </p>
                    {badge ? (
                      <span
                        style={{
                          fontSize: "12px",
                          fontWeight: 500,
                          color: "#633806",
                          background: "#FAEEDA",
                          padding: "2px 10px",
                          borderRadius: "20px",
                          display: "inline-block",
                        }}
                      >
                        {value}
                      </span>
                    ) : (
                      <p
                        style={{
                          fontSize: "13px",
                          fontWeight: 500,
                          color: color || "var(--color-text-primary, #1a1a1a)",
                          margin: 0,
                        }}
                      >
                        {value}
                      </p>
                    )}
                  </div>
                );
              })}
            </div>

            {/* ── Latest completion date (EOT) row — only shown when an EOT exists ── */}
            {i.latest_eot && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  padding: "13px 20px",
                  borderBottom: "0.5px solid #e0e0e0",
                }}
              >
                <div>
                  <p style={{ fontSize: "11px", color: "#888", margin: "0 0 4px" }}>
                    Latest completion date
                  </p>
                  <p
                    style={{
                      fontSize: "13px",
                      fontWeight: 500,
                      color: "#9A5B0F",
                      margin: 0,
                    }}
                  >
                    {i.latest_eot.extension_upto_date}
                  </p>
                </div>
                <EOTHistoryButton projectId={i.id} latestEot={i.latest_eot} />
              </div>
            )}

            {/* ── Billing progress bar ── */}
            <div
              style={{
                padding: "13px 20px",
                borderBottom: "0.5px solid #e0e0e0",
              }}
            >
              {(() => {
                const pct =
                  i.section_cost && calculations.completedCost
                    ? Math.min(
                      100,
                      Math.round(
                        (calculations.completedCost / i.section_cost) * 100,
                      ),
                    )
                    : 0;
                return (
                  <>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "7px",
                      }}
                    >
                      <span style={{ fontSize: "12px", fontWeight: 500 }}>
                        Billing progress
                      </span>
                      <span style={{ fontSize: "11px", color: "#888" }}>
                        ₹
                        {formatCurrencyIndian(
                          Number(calculations.completedCost / 100000).toFixed(
                            2,
                          ),
                        )}{" "}
                        of ₹
                        {formatCurrencyIndian(
                          Number(i.section_cost / 100000).toFixed(2),
                        )}{" "}
                        Lacs
                      </span>
                    </div>
                    <div
                      style={{
                        background: "#efefef",
                        borderRadius: "4px",
                        height: "6px",
                        overflow: "hidden",
                      }}
                    >
                      <div
                        style={{
                          width: `${pct}%`,
                          height: "100%",
                          background: "#1D9E75",
                          borderRadius: "4px",
                          transition: "width 0.4s ease",
                        }}
                      />
                    </div>
                    <div
                      style={{ display: "flex", gap: "16px", marginTop: "5px" }}
                    >
                      <span style={{ fontSize: "11px", color: "#0F6E56" }}>
                        Billed: {pct}%
                      </span>
                      <span style={{ fontSize: "11px", color: "#A32D2D" }}>
                        Remaining: ₹
                        {formatCurrencyIndian(
                          Number(calculations.remainingValue / 100000).toFixed(
                            2,
                          ),
                        )}{" "}
                        Lacs
                      </span>
                    </div>
                  </>
                );
              })()}
            </div>

            {/* ── Payment summary label ── */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                padding: "11px 20px 10px",
                borderBottom: "0.5px solid #e0e0e0",
                background: "#f5f7fa",
              }}
            >
              <div
                style={{
                  width: "3px",
                  height: "13px",
                  background: "#185FA5",
                  borderRadius: "0",
                }}
              />
              <span
                style={{
                  fontSize: "11px",
                  fontWeight: 500,
                  color: "#555",
                  letterSpacing: "0.07em",
                  textTransform: "uppercase",
                }}
              >
                Payment summary
              </span>
            </div>

            {/* ── Payment cards ── */}
            <div
              style={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)" }}
            >
              {[
                {
                  label: "Claimed",
                  sub: "total billed to client",
                  value: calculations.claimed,
                  dot: "#185FA5",
                  text: "#0C447C",
                },
                {
                  label: "Received",
                  sub: "payment collected",
                  value: calculations.received,
                  dot: "#1D9E75",
                  text: "#085041",
                },
                {
                  label: "Deduction",
                  sub: "TDS + retention",
                  value: calculations.deduction,
                  dot: "#E24B4A",
                  text: "#791F1F",
                },
                {
                  label: "Bal. to claim",
                  sub: "yet to be claimed",
                  value: calculations.balanceToClaim,
                  dot: "#EF9F27",
                  text: "#633806",
                },
                {
                  label: "Bal. to receive",
                  sub: "pending receipt",
                  value: calculations.balanceToReceive,
                  dot: "#7C3AED",
                  text: "#3C3489",
                },
              ].map(({ label, sub, value, dot, text }, idx) => (
                <div
                  key={label}
                  style={{
                    padding: "14px 20px",
                    borderRight: idx !== 4 ? "0.5px solid #e0e0e0" : "none",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      marginBottom: "6px",
                    }}
                  >
                    <div
                      style={{
                        width: "6px",
                        height: "6px",
                        borderRadius: "50%",
                        background: dot,
                        flexShrink: 0,
                      }}
                    />
                    <p style={{ fontSize: "11px", color: "#888", margin: 0 }}>
                      {label}
                    </p>
                  </div>
                  <p
                    style={{
                      fontSize: "15px",
                      fontWeight: 500,
                      color: text,
                      margin: "0 0 3px",
                    }}
                  >
                    ₹{formatCurrencyIndian(value)}
                  </p>
                  <p style={{ fontSize: "11px", color: "#aaa", margin: 0 }}>
                    {sub}
                  </p>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* ── Workstages ── */}
      <div className="content-tabs">
        {projectData[0] && (
          <>
            {/* ── Tab Switcher ── */}
            <div
              style={{
                display: "flex",
                gap: "0",
                borderBottom: "0.5px solid #e0e0e0",
                marginBottom: "0",
                background: "#fff",
                borderRadius: "6px 6px 0 0",
                overflow: "hidden",
                border: "0.5px solid #e0e0e0",
              }}
            >
              {[
                { key: "workstages", label: `Workstages of ${projectData[0]?.section_name || "Section"}` },
                { key: "eot", label: "EOT Timeline" },
              ].map((tab) => {
                const isActive = activeTab === tab.key;
                return (
                  <button
                    key={tab.key}
                    onClick={() => setActiveTab(tab.key)}
                    style={{
                      padding: "10px 20px",
                      fontSize: "13px",
                      fontWeight: isActive ? 600 : 500,
                      color: isActive ? "#2576bc" : "#64748b",
                      background: isActive ? "#eff6ff" : "#f5f7fa",
                      border: "none",
                      borderBottom: isActive ? "2px solid #2576bc" : "2px solid transparent",
                      cursor: "pointer",
                      outline: "none",
                      transition: "all 0.15s ease",
                    }}
                  >
                    {tab.label}
                    {tab.key === "eot" && (
                      <span
                        style={{
                          marginLeft: "6px",
                          fontSize: "10px",
                          fontWeight: 700,
                          background: "#2576bc",
                          color: "#fff",
                          padding: "1px 6px",
                          borderRadius: "10px",
                        }}
                      >
                        NEW
                      </span>
                    )}
                  </button>
                );
              })}
            </div>

            {/* ── Tab Content ── */}
            {activeTab === "workstages" && (
              <WorkstatsToggle
                getDocuments={getDocuments}
                documentData={documentData}
                workstat={projectData[0]?.workstat}
                project={projectData[0]?.id}
                subconsultant_details={projectData[0]?.subconsultant_name}
                getProject={getProjects}
                allData={projectData[0]}
                sector={projectData[0]?.project_details_data?.sector_details?.id}
              />
            )}

            {activeTab === "eot" && (
              <EOTTimeline
                allData={projectData[0]}
                userRole="superadmin"
              />
            )}
          </>
        )}
      </div>
    </>
  );
};

export { ProjectAllDetails };